export const maData = {
  locale: {
    home_instavc_build:
      "संस्था आणि कर्मचारी यांच्यात अर्थपूर्ण संबंध निर्माण करा",
    home_instavc_conference_platform:
      "कॉन्फरन्स प्लॅटफॉर्म an n अतुलनीय वापरकर्ता अनुभवासह",
    home_instavc_start_conference:
      "कॉन्फरन्स सुरू करा. कॉन्फरन्स जॉइन करा. इंस्टा कॉन्फरन्स",
    home_instavc_Hippa:
      "हिप्पा पात्रता आणि पीसीआय डीएसएस, एसओसी, आयएसओ / ईआयसी 27001, आयएसओ / आयईसी 27017, आयएसओ / आयईसी 27018, आणि आयएसओ 9001 कंपनी.",
    home_instavc_copyrights:
      "© 2018 · इंस्टाव्हीसी · पीपललिंक युनिफाइड कम्युनिकेशन्स प्रायव्हेट लिमिटेड",
    home_instavc_terms_agree: "मी सहमत आहे",
    home_instavc_terms: "अटी व शर्ती",

    visibility: " दृश्यमानता",
    members: "सदस्य",
    create_class: "वर्ग तयार करा",
    public_class: " सार्वजनिक - केवळ वर्ग सदस्य सामील होऊ शकतात",
    private_class: " खाजगी - तुमच्या संस्थेतील कोणीही सहभागी होऊ शकते",
    private: " खाजगी",
    filter_by: "यानुसार फिल्टर करा:",
    blocked: " अवरोधित",
    deleted: "हटवले",
    unblock: " अनब्लॉक करा",
    make_active: " सक्रिय करा",
    addNewSubject: "नवीन विषय जोडा",
    addNewClass: "नवीन वर्ग जोडा",
    editSubject: "विषय संपादित करा",
    editQuestionnarie: "प्रश्नावली संपादित करा",
    editAssignment: "असाइनमेंट संपादित करा",
    assign_teacher: " शिक्षक नियुक्त करा",
    exculde_students: " विद्यार्थ्यांना वगळा",
    dateOfJoining: "सामील होण्याची तारीख",
    classes: "वर्ग",
    users: "वापरकर्ते",
    classList: "वर्गांची यादी",
    add_teacher: "शिक्षक जोडा",
    add_student: "विद्यार्थी जोडा",
    mySessions: "माझे सत्र",
    reports: "अहवाल",

    inclass_admin_teacher: "शिक्षक",
    inclass_admin_student: "विद्यार्थीच्या",
    inclass_admin_studentName: "विद्यार्थ्याचे नाव",
    inclass_admin_studentID: "विद्यार्थी ओळखपत्र",
    inclass_teacher_designation: "पदनाम",
    inclass_teacher_department: "विभाग",
    inclass_student_rollnumber: "हजेरी क्रमांक",
    inclass_teacher_status: "स्थिती",
    inclass_admin_user_info: "वापरकर्ता माहिती",
    inclass_admin_professional_info: "व्यावसायिक माहिती",
    inclass_student_classname: "वर्गाचे नाव",

    instavc_login: "लॉग इन",
    instavc_login_email: "ईमेल",
    instavc_login_password: "संकेतशब्द",
    instavc_login_button: "लॉग इन",
    instavc_login_forgotpassword: "संकेतशब्द विसरलात?",
    instavc_login_have_account: "खाते नाही?",
    instavc_login_signup: "साइन अप",
    instavc_signup: "साइन अप",
    instavc_signup_firstname: "पहिले नाव",
    instavc_signup_lastname: "आडनाव",
    instavc_signup_email: "ईमेल",
    instavc_signup_password: "संकेतशब्द",
    instavc_signup_cpassword: "पासवर्डची पुष्टी करा",
    instavc_signup_button: "साइन अप",
    instavc_signup_already_have_account: "आधीपासूनच एक खाते आहे?",
    instavc_signup_login: "लॉग इन",
    instavc_signup_fname_error: "पहिले नाव फक्त अक्षरे असावे",
    instavc_signup_lname_error: "आडनाव फक्त अक्षरे असावेत",
    instavc_signup_email_error: "ईमेल योग्य स्वरूपात असावा",
    instavc_forgotpassword_link:
      "तुमच्या खात्याशी संबंधित ईमेल आयडी टाका. तुमचा पासवर्ड रीसेट करण्यासाठी आम्ही तुम्हाला एक OTP मेल करू.",
    instavc_forgotpassword_email: "ईमेल पत्ता प्रविष्ट करा",
    instavc_forgotpassword: "संकेतशब्द विसरलात",
    instavc_forgotpassword_button: "संकेतशब्द विसरलात",
    instavc_confirmpass_heading: "विद्यार्थी तयार करा",
    instavc_confirmpass_verificationcode: "सत्यापन कोड प्रविष्ट करा",
    instavc_confirmpass_newpassword: "नवीन पासवर्ड टाका",
    instavc_confirmpass_retypepassword: "संकेतशब्द पुन्हा टाका",
    instavc_confirmpass_button: "शिक्षक तयार करा",
    instavc_forgotpassword_signin: "साइन इन",
    instavc_forgotpassword_passwordcreated:
      "अभिनंदन! तुमचा नवीन पासवर्ड अपडेट केला गेला आहे, तुम्ही आता इनक्लासमध्ये साइन इन करू शकता.",
    instavc_dashboard: "डॅशबोर्ड",
    instavc_dashboard_schedule: "शेड्यूल सत्र",
    instavc_dashboard_meetinglist: "मागील सत्रे",
    instavc_dashboard_conferenceplatform:
      "एक अतुलनीय वापरकर्ता अनुभवासह कॉन्फरन्स प्लॅटफॉर्म",
    instavc_dashboard_SC_room: "परिषद प्रारंभ करा",
    instavc_dashboard_SC_roomlist: "तुमचे नियोजित सत्र निवडून",
    instavc_dashboard_startconference: "परिषद प्रारंभ करा",
    instavc_dashboard_JC: "परिषदेत सामील व्हा",
    instavc_dashboard_JC_ID: "कॉन्फरन्स आयडीद्वारे किंवा अनुसूचीद्वारे",
    instavc_dashboard_JC_button: "सामील व्हा",
    instavc_dashboard_SC: "परिषद प्रारंभ करा",
    instavc_dashboard_SC_p2p: "आपल्या सूचीतून एक कक्ष निवडून",
    instavc_dashboard_instaconference: "इंस्टा कॉन्फरन्स",
    instavc_dashboard_buynow: "ताबडतोब खरेदी करा",
    instavc_dashboard_myprofile: "माझे प्रोफाइल",
    instavc_dashboard_settings: "सेटिंग्ज",
    instavc_dashboard_myadmin: "माझे प्रशासन",
    instavc_dashboard_affiliate: "माझे संलग्न",
    instavc_dashboard_logout: "बाहेर पडणे",
    conference_myrooms: "माझ्या खोल्या",
    conference_myrooms_host: "शिक्षक आयडी",
    conference_myrooms_roomhost: "आपण या खोलीसाठी होस्ट आहात.",
    conference_myrooms_search: "शोधा",
    conference_myrooms_hostuser: "होस्ट वापरकर्ता",
    conference_myrooms_gotopremium: "प्रीमियम वर जा",
    conference_myrooms_buynow: "ताबडतोब खरेदी करा",
    conference_myrooms_renewal: "नूतनीकरण",
    conference_setup: "सेटअप",
    conference_myrooms_renewnow: "आता नूतनीकरण करा",
    // "conference_myrooms_hosts": "Host", : होस्ट
    conference_myrooms_join: "सामील व्हा",
    conference_myrooms_setup: "खोली सेटअप",
    conference_myrooms_sethost_email:
      "स्वत: ला होस्ट म्हणून सेट करा किंवा वापरकर्त्याने त्याला होस्ट बनवण्यासाठी ईमेल पत्ता प्रविष्ट करा",
    conference_myrooms_selfhost: "स्वत: ला यजमान म्हणून सेट करा",
    conference_myrooms_otherhost:
      "किंवा - आपण कोणत्याही वापरकर्त्यास होस्ट बनवू इच्छित असल्यास, त्याचा / तिचा ईमेल पत्ता प्रविष्ट करा",
    conference_myrooms_email: "ईमेल पत्ता",
    Cancel: "रद्द करा",
    conference_myrooms_apply: "अर्ज करा",
    view_schedule_myrooms: "माझ्या खोल्या",
    view_schedule_search: "शोधा",
    view_schedule_schedule: "वेळापत्रक",
    view_schedule_calender: "खाली या खोलीचे वेळापत्रक तपासण्यासाठी कॅलेंडर आहे",
    video_recordings: "व्हिडिओ रेकॉर्डिंग",
    view_recordings_search: "शोधा",
    view_recordings_month: "या महिन्यात",
    view_recordings_week: "गेल्या 7 दिवस",
    view_recordings_today: "आज",
    no_recordings: "अजून रेकॉर्डिंग नाही",
    no_recordings_message: "आत्ता येथे कोणतेही व्हिडिओ नाहीत",
    no_recordings_startmessage:
      "एकदा आपण रेकॉर्डिंग सुरू केल्यावर आपण आपले सर्व व्हिडिओ येथे पाहू शकता ",
    stop_recording: "आपण हे रेकॉर्डिंग थांबवू इच्छिता?",
    stop_recording_agree: "सहमत",
    stop_recording_disagree: "असहमत",
    conference_in_use: "परिषद वापरात आहे",
    conference_mode: "कॉन्फरन्स मोड",
    large_conference_mode: "मोठा कॉन्फरन्स मोड",
    conference_setup_configuration: "संरचना",
    conference_setup_generateid:
      "कोणताही सत्र आयडी आढळला नाही, एक निर्माण करा!",
    conference_setup_regenerate: "पुन्हा निर्माण करणे",
    conference_setup_meetingid: "सत्र आयडी",
    conference_setup_camera: "फेसटाइम एचडी कॅमेरा",
    conference_setup_defaultmicrophone: "डीफॉल्ट - अंतर्गत मायक्रोफोन (अंगभूत)",
    conference_setup_microphone: "अंतर्गत मायक्रोफोन (अंगभूत)",
    conference_setup_volume: "आवाज",
    conference_setup_videomode: "व्हिडिओ मोड",
    conference_setup_forward: "पुढे",
    conference_setup_mix: "एकत्रीकरण",
    conference_setup_invite: "आमंत्रित करा",
    conference_setup_invitepeople: "लोकांना आमंत्रित करा",
    conference_setup_invitefriends:
      "आपल्या मित्रांना आणि सहकार्‍यांना सहयोगासाठी आमंत्रित करा.",
    conference_setup_invite_directlink: "आपल्या खोलीचा थेट दुवा",
    conference_setup_invite_sharelink:
      "आपल्या सत्रात सामील होण्यासाठी आपल्या सहभागींसाठी हा दुवा सामायिक करा",
    conference_setup_invite_link:
      "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
    conference_setup_invitebyemail: "मेलद्वारे आमंत्रित करा",
    conference_setup_invite_enteremail:
      "आपले सहभागी आमंत्रित प्राधान्य ईमेल पत्ता प्रविष्ट करा",
    conference_setup_invite_emailid: "ईमेल पत्ता",
    conference_setup_invite_close: "बंद",
    conference_setup_invite_button: "आमंत्रित करा",
    conference_setup_advancesettings: "आगाऊ सेटिंग्ज",
    conference_setup_changeresolution: "ठराव निवडा",
    conference_setup_lowbandwidth: "लो बँडविड्थ",
    conference_setup_poornetwork: "खराब नेटवर्क",
    conference_setup_vga: "व्हीजीए - (640x480)",
    conference_setup_vga_graphics:
      "व्हिडिओ ग्राफिक्स अ‍ॅरे (व्हीजीए) व्हिडिओ रिझोल्यूशनसाठी",
    conference_setup_hd1080: "HD1080p - (1920x1080)",
    conference_setup_fhd: "पूर्ण उच्च परिभाषा (एफएचडी) व्हिडिओ रिझोल्यूशनसाठी",
    conference_setup_4k: "4K - (3840 x 2160)",
    conference_setup_4k_fhd: "For Full High Definition (FHD) Video Resolution",
    conference_setup_sif: "SIF - (320x240)",
    conference_setup_sif_vr: "For SIF Video Resolution",
    conference_setup_hd720: "HD720p - (1280x720)",
    conference_setup_hd720_vr: "For High Definition (HD) Video Resolution",
    conference_setup_2k: "2K - (2048×1080)",
    conference_setup_2k_fhd: "For Full High Definition (FHD) Video Resolution",
    conference_setup_broadcastoptions: "प्रसारण पर्याय",
    conference_setup_enable: "सक्षम करा",
    conference_setup_disable: "अक्षम करा",
    conference_setup_reportquality:
      "व्हॉईस आणि व्हिडिओ कॉल सुधारण्यात मदतीसाठी गुणवत्ता आकडेवारीचा अहवाल द्या",
    conference_setup_havetroubleshoot:
      "आपण कॉन्फरन्स समस्या निवारण करू इच्छित असाल तर दुव्यावर क्लिक करा",
    conference_setup_conferencetroubleshoot: "कॉन्फरन्स ट्रबलशूटर",
    conference_troubleshoot: "समस्यानिवारण",
    conference_troubleshoot_faq: "सामान्य प्रश्न",
    conference_troubleshoot_emailreport: "ईमेल अहवाल",
    conference_troubleshoot_gotoconference: "कॉन्फरन्स जा",
    conference_troubleshoot_os: "ऑपरेटिंग सिस्टम",
    conference_troubleshoot_version: "आवृत्ती",
    conference_troubleshoot_browser: "ब्राउझर",
    conference_troubleshoot_chromeversion: "क्रोम आवृत्ती",
    conference_troubleshoot_privatebrowsing: "खाजगी ब्राउझिंग",
    conference_troubleshoot_displayresolution: "ठराव प्रदर्शित करा",
    conference_troubleshoot_aspectratio: "प्रसर गुणोत्तर प्रदर्शित करा",
    conference_troubleshoot_hasspeakers: "सिस्टममध्ये स्पीकर्स आहेत?",
    conference_troubleshoot_foundspeaker: "स्पीकर साधने आढळली",
    conference_troubleshoot_hasmicrophone: "सिस्टममध्ये मायक्रोफोन आहे?",
    conference_troubleshoot_foundmicrophone: "मायक्रोफोन डिव्हाइस सापडले",
    conference_troubleshoot_haswebcam: "सिस्टममध्ये वेबकॅम आहे?",
    conference_troubleshoot_foundcameras: "कॅमेरा साधने सापडली",
    conference_troubleshoot_webcampermission:
      "वेबसाइटवर वेबकॅम परवानग्या आहेत?",
    conference_troubleshoot_microphonepermission:
      "वेबसाइटला मायक्रोफोन परवानग्या आहेत?",
    conference_troubleshoot_getUsermedia:
      "ब्राउझर या पृष्ठावर युजरमाडियाला परवानगी देतो?",
    conference_troubleshoot_changeoutput_audiodevice:
      "आपण आउटपुट ऑडिओ डिव्हाइस बदलू शकता?",
    conference_troubleshoot_changecamera_resolution:
      "नवीन परिषद विनंती केल्याशिवाय आपण कॅमेरा ठराव बदलू शकता?",
    conference_troubleshoot_supportwebrtc:
      "ब्राउझर वेबआरटीसी (एकतर 1.0 किंवा 1.1) चे समर्थन करतो?",
    conference_troubleshoot_supportortc:
      "ब्राउझर ओआरटीसी (वेबआरटीसी 1.1) चे समर्थन करतो?",
    conference_troubleshoot_turnserver:
      "टर्न सर्व्हरवर पुन्हा प्रवेश करता येईल?",
    conference_troubleshoot_turn: "turn:139.59.64.172:443",
    conference_troubleshoo_coturn: "turn:coturn.instavc.com:443",
    conference_troubleshoot_replacetracks:
      "तोलामोलाचा सल्ला न घेता आपण ट्रॅक पुनर्स्थित करू शकता?",
    conference_troubleshoot_record_remoteaudio:
      "आपला ब्राउझर रिमोट ऑडिओ रेकॉर्ड करू शकतो किंवा वेब ऑडिओ एपीआय मध्ये रिमोट ऑडिओ प्रवाहावर प्रक्रिया करू शकतो",
    conference_troubleshoot_browsersupports_websocketapi:
      "ब्राउझर वेबसोकेट्स API ला समर्थन देतात",
    conference_troubleshoot_blockwebsocket:
      "आपल्या सिस्टमने वेबसॉकेट्स प्रोटोकॉल अवरोधित केला आहे किंवा वेबसॉकेट्स सर्व्हर प्रवेशयोग्य नाही?",
    conference_troubleshoot_supportwebaudioapi:
      "ब्राउझर वेब ऑडिओ API चे समर्थन करतो",
    conference_troubleshoot_supportsctp:
      "ब्राउझर एससीटीपी डेटा चॅनेलला समर्थन देतो",
    conference_troubleshoot_supportsrtp:
      "ब्राउझर आरटीपी डेटा चॅनेलला समर्थन देतो?",
    conference_troubleshoot_support_screencapturing:
      "हे पृष्ठ स्क्रीन कॅप्चरिंग API चे समर्थन करते?",
    conference_troubleshoot_support_multimonitor:
      "ब्राउझर एकाधिक-मॉनिटर निवडीस समर्थन देतो आणि कोणत्याही मॉनिटरची स्क्रीन कॅप्चर करतो? ",
    conference_troubleshoot_mobiledevice: "हे मोबाइल डिव्हाइस आहे?",
    conference_troubleshoot_supportscreencap_canvas:
      "ब्राउझर कॅनव्हासवरून स्क्रीन कॅप्चरिंगला समर्थन देतो?",
    conference_troubleshoot_supportscreencap_video:
      "ब्राउझर व्हिडिओ वरून स्क्रीन कॅप्चरिंगला समर्थन देतो?",
    conference_troubleshoot_supportpromisses:
      "ब्राउझर आश्वासनांचे समर्थन करतो?",
    conference_troubleshoot_ipaddress: "आयपी पत्ते दर्शविण्यासाठी क्लिक करा",
    conference_troubleshoot_stunserver: "स्टन सर्व्हर पोचण्यायोग्य आहे का?",
    cancel: "रद्द करा",
    instavc_conference_revoke_fromhost: "होस्टमधून मागे घ्या",
    instavc_conference_startvideoconf_button: "व्हिडिओ कॉन्फरन्स प्रारंभ करा",
    instavc_conference_loading: "आपली स्क्रीन लोड करीत आहे कृपया प्रतीक्षा करा",
    instavc_conference_authenticating:
      "इन्स्टॅव्हक सर्व्हरवर प्रमाणीकरण करीत आहे",
    instavc_conference_joinconference: "परिषदेत सामील होत आहे",
    instavc_conference_publishyourvideo: "आपला व्हिडिओ प्रकाशित करीत आहे",
    instavc_conference_publishyouraudio: "आपला ऑडिओ प्रकाशित करीत आहे",
    instavc_conference_settings: "सेटिंग्ज",
    instavc_conference_setting: "परिषद सेटिंग्ज",
    instavc_conference_setting_source: "स्त्रोत",
    instavc_conference_setting_camera: "कॅमेरा",
    instavc_conference_audioinputs: "ऑडिओ इनपुट",
    instavc_conference_setting_apply: "अर्ज करा",
    instavc_conference_setting_resolution: "परिणाम",
    instavc_conference_setting_qr: "QR(BETA)",
    instavc_conference_whiteboard: "Whiteboard",
    instavc_conference_screenshare: "Screen Share",
    instavc_conference_presenter: "Presenter",
    instavc_conference_stopshare: "Stop Share",
    instavc_conf_install_Screenshare: "Install ScreenShare",
    instavc_conference_videosync: "Watch Together",
    instavc_conference_videourl: "Video URL",
    instavc_conference_enter_videourl: "Enter Video URL",
    instavc_conference_videourl_note:
      "टीपः केवळ सक्रिय सहभागी हा व्हिडिओ पाहू शकतात, उशीरा सहभागी होणारा व्हिडिओ पाहू शकत नाहीत",
    instavc_conf_recordings: "मुद्रित करणे",
    instavc_conference_sharecontent: "Share your Screen",
    instavc_conference_sharecontent_screen:
      "connect.instavc.com आपल्या स्क्रीनमधील सामग्री सामायिक करू इच्छित आहे. आपण काय सामायिक करू इच्छिता ते निवडा",
    instavc_conference_shareentire_screen: "आपली संपूर्ण स्क्रीन",
    instavc_conference_sharescreen_applicationwindow: "Application Window",
    instavc_conference_sharescreen_chrometab: "Chrome Tab",
    instavc_conference_sharescreen_share: "सामायिक करा",
    instavc_conf_sharescreen: "आपण आपली स्क्रीन सामायिक करत आहात!",
    instavc_conf_share_otherparticipants:
      "इतर सहभागी आपल्या स्क्रीनवर अनुप्रयोग आणि दस्तऐवज पाहू शकतात",
    instavc_stopsharing: "Stop Sharing",
    instavc_conference_chat: "Chat",
    instavc_conference_additional_camera: "Additional Camera",
    instavc_conference_sharescreen_groupchat: "Group Chat",
    instavc_conference_sharescreen_GC: "GC",
    instavc_conference_entermessage: "काहीतरी बोला",
    instavc_conference_adddevice: "Add Devices",
    instavc_conference_adddevice_addcamera: "Add Camera",
    instavc_conference_adddevice_source: "SOURCE",
    instavc_conference_adddevice_camera: "Camera",
    instavc_conference_adddevice_cameraname: "FaceTime HD Camera",
    instavc_conference_adddevice_close: "CLOSE ",
    instavc_conference_adddevice_publish: "PUBLISH",
    instavc_conference_info: "info",
    questions: "Questions",
    instavc_conference_askquestions: "प्रश्न विचारा",
    instavc_conference_info_meetingid: "वैयक्तिक सत्र आयडी",
    instavc_conference_fullscreen: "पूर्ण स्क्रीन",
    conference_setup_invitepeoplel: "लोकांना आमंत्रित करा",
    conference_setup_invite_linktojoin:
      "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
    conference_setup_invite_byemail: "मेलद्वारे आमंत्रित करा",
    instavc_conference_participants: "सहभागी",
    instavc_conference_participants_search: "शोधा",
    instavc_conference_participant: "सहभागी",
    instavc_conference_participants_muteall: "सर्व नि: शब्द करा",
    instavc_conference_participants_unmuteall: "सर्व सशब्द करा",
    instavc_conference: "परिषद",
    instavc_conf_more: "अधिक",
    instavc_conference_picturemode:
      "हा व्हिडिओ पिक्चर-इन-पिक्चर मोडमध्ये प्ले होत आहे",
    instavc_conference_mediastreams_stats: "मीडिया प्रवाह आकडेवारी",
    instavc_conference_mediastreams_audio: "ऑडिओ",
    instavc_conference_mediastreams_audio_send: "पाठवा",
    instavc_conference_mediastreams_audio_codec: "Codec",
    instavc_conference_mediastreams_audio_rates: "Rates(Kbps)",
    instavc_conference_mediastreams_audio_lost: "हरवले",
    instavc_conference_mediastreams_audio_fraction: "Fraction",
    instavc_conference_mediastreams_video: "व्हिडिओ",
    instavc_conference_mediastreams_video_send: "पाठवा",
    instavc_conference_mediastreams_video_codec: "Codec",
    instavc_conference_mediastreams_video_rates: "Rates(Kbps)",
    instavc_conference_mediastreams_video_lost: "हरवले",
    instavc_conference_mediastreams_video_fraction: "Fraction",
    instavc_conference_resolution: "ठराव",
    instavc_conference_framerate: "Frame rate",
    instavc_conference_nack: "Nack",
    instavc_conference_pli: "PLI",
    instavc_conference_bw: "Available BW",
    instavc_conference_audiomuted: "ऑडिओ नि: शब्द केला",
    instavc_conference_microphonemuted: "आपला मायक्रोफोन नि: शब्द केला",
    join_conference_join_meetinginvitation: "सत्र आमंत्रणांमध्ये सामील व्हा",
    join_conference_search: "शोधा",
    "join_conference_meeting details":
      "बैठक नावद्वारा आमंत्रितआमंत्रणकर्ता नाव",
    join_conference_join: "सामील व्हा",
    join_conference_nomeetings: "कोणतीही सत्रे नाहीत",
    join_conference_noupcomingmeetings:
      "अरेरे! आपल्याकडे अद्याप कोणतीही आगामी सत्रे नाहीत!",
    insta_conference_mycontacts: "माझे संपर्क",
    insta_conference_search: "शोधा",
    insta_conference_typemessage: "एक संदेश टाइप करा",
    insta_conference_addcontact: "संपर्क जोडा",
    insta_conference_enteremail: "मेल आयडी प्रविष्ट करा",
    insta_conference_add: "जोडा",
    insta_conference_nouserfound:
      "या ईमेल पत्त्यासह असा कोणताही वापरकर्ता आढळला नाही",
    instavc_conf_callnot_allowed:
      "आपण आधीपासूनच कॉलमध्ये असता तेव्हा आपण इतर वापरकर्त्यांना कॉल करू शकत नाही",
    insta_conference_pendingapproval: "मंजूरीसाठी प्रलंबित",
    insta_conference_outgoingvideocall: "Outgoing Video Call",
    insta_conference_calling: "कॉल करत आहे",
    insta_conference_incomingvideocall: "Incoming Video Call",
    insta_conference_calldecline: "नाकारणे",
    insta_conference_callaccept: "स्वीकारा",
    insta_conference_instavcalert: "connect.instavc.com परवानगी देऊ इच्छित आहे",
    insta_conference_usemicrophone: "आपला मायक्रोफोन वापरा",
    insta_conference_usecamera: "आपला कॅमेरा वापरा",
    insta_conference_blockdevices: "ब्लॉक करा",
    insta_conference_allowdevices: "परवानगी द्या",
    instavc_schedulemeeting_createmeeting: "नवीन सत्र तयार करा / संपादित करा",
    instavc_schedulewebinar_createmeeting: "नवीन वेबिनार / संपादन तयार करा",
    instavc_schedulemeeting_meetingname: "तुमच्या सत्राला नाव द्या",
    instavc_schedulemeeting_selectnames_tomeeting:
      "तुमच्या सत्रासाठी एक खोली निवडा",
    instavc_schedulemeeting_setduration: "कालावधी सेट करा",
    instavc_schedulemeeting_15min: "15 मिनिटे",
    instavc_schedulemeeting_30min: "30 मिनिटे",
    instavc_schedulemeeting_60min: "60 मिनिटे",
    instavc_schedulemeeting_setcustom: "सानुकूल सेट करा",
    instavc_schedulemeeting_customduration: "सानुकूल कालावधी",
    instavc_schedulemeeting_minutes: "मिनिटे",
    instavc_schedulemeeting_setconfpassword: "आपला परिषद संकेतशब्द सेट करा",
    instavc_schedulemeeting_typepassword: "तुमच्या सत्रासाठी पासवर्ड टाइप करा",
    instavc_schedulemeeting_conferencecolor:
      "आपल्या कॉन्फरन्सच्या आयकॉनला रंग द्या",
    instavc_schedulemeeting_invitepeople: "या सत्रासाठी लोकांना आमंत्रित करा",
    instavc_schedulemeeting_search: "शोधा",
    instavc_schedulemeeting_SM: "SM",
    instvc_SM_message:
      "अधिकृत वापरकर्त्या परवान्यासह वापरकर्त्यांची संख्या परवान्यांची मर्यादा ओलांडली आहे. आपण इच्छित असलेल्या लोकांना अधिक आमंत्रित करू इच्छित असल्यास ",
    instavc_SM_message_href: "प्रीमियम वर जा",
    instavc_schedulemeeting_notify:
      "निवडलेल्या लोकांना या सत्राबद्दल सूचित करा",
    instavc_schedulemeeting_addreminder: "स्मरणपत्रे जोडा",
    instavc_schedulemeeting_add: "जोडा",
    instavc_schedulemeeting_addmeetingreminder: "सत्र स्मरणपत्र जोडा",
    instavc_schedulemeeting_adddatetime: "तारीख निवडकर्ता, वेळ निवडकर्ता",
    instavc_schedulemeeting_apply: "अर्ज करा",
    instavc_schedulemeeting_name: "कृपया सत्राचे नाव प्रविष्ट करा",
    instavc_schedulemeeting_selectroom: "कृपया खोली निवडा",
    instavc_schedulemeeting_selectduration: "कृपया कालावधी निवडा",
    instavc_recuring_schedule: "आवर्ती वेळापत्रक",
    instavc_schedulemeeting_nothinginreminders: "स्मरणपत्रांमध्ये काहीही नाही",
    instavc_schedulemeeting_createbutton: "तयार करा",
    instavc_schedulemeeting_createdsuccessfully:
      "वेळापत्रक यशस्वीरित्या तयार केले",
    instavc_meetinglist_calender: "CALENDER",
    instavc_meetinglist_selecteddates: "आपल्या निवडलेल्या तारखा",
    instavc_meetinglist_meetingdetils:
      "सत्राचे नाव, सत्राची वेळ, द्वारे आयोजित",
    instavc_meetinglist_search: "शोधा",
    instavc_meetinglist_alow_deleterecuring:
      "आपण फक्त वर्तमान वेळापत्रक किंवा पुनरावृत्तीमधील सर्व वेळापत्रक हटवू इच्छिता?",
    instavc_meetinglist_schedule_series:
      "मालिकेतील इतर सर्व वेळापत्रक बाकी राहतील",
    instavc_meetinglist_schedule_seriesdelete:
      "मालिकेतील सर्व वेळापत्रक हटविली जातील",
    instavc_meetinglist_allrecuringsch: "सर्व आवर्ती वेळापत्रक",
    instavc_meetinglist_cancelchanges: "बदल रद्द करा",
    instavc_meetinglist_noschedules: "कोणतीही वेळापत्रक नाही",
    instavc_ml_schedulemessage:
      "अद्याप कोणतेही सत्र वेळापत्रक तयार केलेले नाही! खालील बटणावर क्लिक करून तुमचे वेळापत्रक तयार करा.",
    instavc_create_schedule: "वेळापत्रक तयार करा",
    instavc_meetinglist_currentschedule: "वर्तमान वेळापत्रक",
    instavc_meetinglist_join: "सामील व्हा",
    instavc_meetinglist_buynow: "आत्ताच खरेदी करा",
    instavc_dashboard_chooseplan: "योजना निवडा",
    instavc_package_smbplan: "SMB Plans",
    instavc_package_smbplan_host: "(Host Based License)",
    instavc_package_smbplandescription:
      "खोलीत एकावेळी फक्त 1 होस्ट असू शकतात. एक क्रेता कक्ष नियंत्रित करू शकेल असे होस्ट खाते सेट किंवा बदलू शकतो. कॉल दरम्यान होस्ट प्रवेश सामायिक केला जाऊ शकत नाही. होस्ट परिषदेत सामील होईपर्यंत इतर सर्व वापरकर्ते संवाद साधू शकत नाहीत",
    instavc_package_basic: "मूलभूत",
    instavc_package_hostuser_smb: "1 होस्ट आणि",
    instavc_package_hostuser_smb_users: "वापरकर्ते",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ महिना",
    instavc_package_bill_smb: "वार्षिक बिल",
    instavc_package_include_smb: "या पॅकेजमध्ये यासह समाविष्ट आहे",
    instavc_package_buynowbutton: "आत्ताच खरेदी करा",
    instavc_package_fullfeatures_smb: "संपूर्ण वैशिष्ट्ये",
    instavc_package_billinginfo: "बिलिंग माहिती",
    instavc_package_billinginfo_name: "नाव",
    instavc_package_billinginfo_orginazation: "संघटना",
    instavc_package_biilinginfo_gstin: "GSTIN",
    instavc_package_billingdetails: "पावतीचा तपशील",
    instavc_package_billingdetails_firstname: "पहिले नाव",
    instavc_package_billingdetails_lastname: "आडनाव",
    instavc_package_billingdetails_address: "पत्ता",
    instavc_package_shippinginfo_edit: "सुधारणे",
    instavc_package_shippingdetails_firstname: "पहिले नाव",
    instavc_package_shippingdetails_lastname: "आडनाव",
    instavc_package_shippingdetails_address: "पत्ता",
    instavc_package_1year: "1 वर्ष",
    instavc_package_2years: "2 वर्षे",
    instavc_package_3years: "3 वर्षे",
    instavc_package_4years: "4 वर्षे",
    instavc_package_5years: "5 वर्षे",
    instavc_package_subtotal: "एकूण",
    instavc_package_taxes: "कर आणि फी (जीएसटी + 18%)",
    instavc_package_launchoffer: "LAUNCHOFFER",
    instavc_package_promo: "प्रोमो यशस्वीरित्या लागू झाला",
    instavc_package_remove: "काढा",
    instavc_package_havepromocode: "प्रोमो कोड आहे का ? येथे अर्ज करा",
    instavc_package_entercouponcode: "कृपया वैध कूपन कोड प्रविष्ट करा",
    instavc_package_total: "एकूण",
    instavc_package_offerdisclaimer: "ऑफर अस्वीकरण पहा",
    instavc_package_paynow: "आता द्या",
    instavc_package_payment_instavclicense:
      "PeopleLink Unified Communication\nPayment for InstaVC License",
    instavc_package_phone: "Phone",
    instavc_package_entervalid_contactnumber:
      "कृपया वैध संपर्क क्रमांक प्रविष्ट करा",
    instavc_package_email: "ईमेल",
    instavc_package_enteremail:
      "कृपया वैध ईमेल आयडी प्रविष्ट करा. उदाहरणः you@example.com",
    instavc_package_paybycard: "कार्डद्वारे पैसे द्या",
    instavc_package_securedbyrazorpay: "Secured by Razorpay",
    instavc_package_card: "कार्ड",
    instavc_package_enterotp:
      "Enter OTP sent on xxxxxxxxx\nto access Saved Cards",
    instavc_package_resendotp: "ओटीपी पुन्हा पाठवा",
    instavc_package_skipsavedcards: "जतन केलेली कार्डे वगळा",
    instavc_package_enter_otp: "कृपया ओटीपी प्रविष्ट करा",
    instavc_package_skipthesavedcards: "जतन केलेली कार्डे वगळा",
    instavc_package_cardnumber: "कार्ड क्रमांक",
    instavc_package_entervalid_cardnumber:
      "कृपया एक वैध कार्ड नंबर प्रविष्ट करा",
    instavc_package_expiry: "Expiry",
    instavc_package_cardholdername: "कार्ड धारकाचे नाव",
    instavc_package_cvv: "CVV",
    instavc_package_3digitcode:
      "हा आपल्या कार्डाच्या मागील बाजूस छापलेला 3 अंकी कोड आहे",
    instavc_package_pay: "PAY",
    instavc_package_remembercard: "कार्ड लक्षात ठेवा",
    instavc_package_medium: "मध्यम",
    instavc_package_vmcudetails:
      "एका खोलीत एकावेळी फक्त 1 होस्ट असू शकतात. एक क्रेता कक्ष नियंत्रित करू शकेल असे होस्ट खाते सेट किंवा बदलू शकतो. कॉल दरम्यान होस्ट प्रवेश सामायिक केला जाऊ शकत नाही. होस्ट परिषदेत सामील होईपर्यंत इतर सर्व वापरकर्ते संवाद साधू शकत नाहीत",
    instavc_package_instavc: "InstaVC",
    instavc_package_include_platinum: "या पॅकेजमध्ये यासह समाविष्ट आहे",
    instavc_package_specifictions_platinum:
      "व्हाइटबोर्ड \n स्क्रीन शेअर \n चॅट \n रेकॉर्डिंग \n प्रस्तुतकर्ता मोड",
    instavc_package_legacybaselicense: "वारसा आधारित परवाना",
    instavc_package_licensebased_ports: "बंदरांच्या संख्येवर आधारित परवाना",
    instavc_package_hardwareendpoint: "हार्डवेअर एंडपॉईंटसह इंस्टाव्हीसी",
    instavc_package_webrtcconf_legacysupport:
      "लेगसी सपोर्टसह वेबआरटीसी कॉन्फरन्सिंग",
    instavc_package_sip: "SIP / BFCP Support",
    instavc_package_chh323: "ChH323 / H.239 Support",
    instavc_package_contactus: "आमच्याशी संपर्क साधा",
    instavc_myprofile: "MY PROFILE",
    instavc_myprofile_personaldetail: "वैयक्तिक माहिती",
    instavc_myprofile_personaldetails_name: "नाव",
    instavc_myprofile_personaldetails_email: "ईमेल",
    instavc_myprofile_personaldetails_phoneno: "दूरध्वनी क्रमांक",
    instavc_myprofile_personaldetails_address: "पत्ता",
    instavc_myprofile_personaldetails_city: "शहर",
    instavc_myprofile_edit: "सुधारणे",
    instavc_myprofile_personaldetails: "वैयक्तिक माहिती",
    instavc_myprofile_firstname: "पहिले नाव",
    instavc_myprofile_lastname: "आडनाव",
    instavc_myprofile_email: "ईमेल",
    instavc_myprofile_phoneno: "दूरध्वनी क्रमांक",
    instavc_myprofile_professionaldetails: "वैयक्तिक माहिती",
    instavc_myprofile_position: "Position",
    instavc_myprofile_professionaldetails_email: "ईमेल",
    instavc_myprofile_professionaldetails_phoneno: "दूरध्वनी क्रमांक",
    instavc_myprofile_professionaldetails_address: "पत्ता",
    instavc_myprofile_professionaldetails_branch: "Branch",
    instavc_myprofile_professionaldetails_edit: "सुधारणे",
    instavc_myprofile_officialdetails: "अधिकृत तपशील",
    instavc_myprofile_officialdetails_email: "ईमेल",
    instavc_myprofile_officialdetails_phoneno: "दूरध्वनी क्रमांक",
    instavc_myprofile_officialdetails_address: "पत्ता",
    instavc_myprofile_contactinfo: "Contact Info",
    instavc_myprofile_add: "जोडा",
    instavc_myprofile_contactinformation_address: "पत्ता",
    instavc_myprofile_contactinformation_city: "शहर / नगर ",
    instavc_myprofile_contactinformation_zip: "Zip",
    instavc_myprofile_contactinformation_landmark: "खूण",
    instavc_myprofile_address: "पत्ता",
    instavc_myprofile_landmark: "खूण",
    instavc_myprofile_delete: "सतर्क",
    instavc_myprofile_deletealert: "आपली खात्री आहे की आपण हे हटवू इच्छिता?",
    instavc_myprofile_websiteexample: "https://www.google.com",
    instavc_myprofile_sociallinks_example: "https://www.facebook.com/xxx",
    instavc_myprofile_basicinfo_dob: "जन्म तारीख",
    instavc_myprofile_basicinfo_gender: "लिंग",
    instavc_myprofile_basicinformation_dob: "जन्म तारीख",
    instavc_myprofile_basicinformation_gender: "लिंग",
    instavc_myprofile_basicinformation_deletealert:
      "सतर्क आपली खात्री आहे की आपण हे हटवू इच्छिता?",
    instavc_myprofile_preferredlanguage: "पसंतीची भाषा",
    instavc_settings_changepassword: "संकेतशब्द बदला",
    instavc_settings_changepass: "संकेतशब्द बदला",
    instavc_settings_currentpassword: "सध्याचा गुप्त शब्द",
    instavc_settings_newpassword: "नवीन पासवर्ड",
    conf_password: "पासवर्डची पुष्टी करा",
    instavc_settings_enter_currentpassword: "कृपया सद्य संकेतशब्द प्रविष्ट करा",
    instavc_settings_enter_newpassword: "कृपया नवीन संकेतशब्द प्रविष्ट करा",
    enter_confpassword: "कृपया पासवर्ड कन्फर्म करा",
    newpassword_confpassword_should_same:
      "नवीन पासवर्ड आणि कन्फर्म पासवर्ड एकच असावा",
    curnt_psw_and_new_psw_should_not_same:
      "वर्तमान संकेतशब्द आणि नवीन संकेतशब्द समान नसावेत",
    instavc_settings_help: "मदत",
    instavc_settings_affiliate: "संबद्ध व्हा",
    instavc_settings_support: "समर्थन केंद्र",
    instavc_settings_newticket: "नवीन तिकीट उघडा",
    instavc_settings_ticketstatus: "तिकिट स्थिती तपासा",
    instavc_settings_troubleshoot: "समस्यानिवारण",
    instavc_legacy_dailout: "Dial Out",
    instavc_legacy_stats: "आकडेवारी",
    instavc_legacy_dail_in_detail: "डायल-इन तपशील",
    instavc_legacy_h323_endpoint: "H.323 End Point",
    instavc_legacy_sip_endpoint: "SIP End Point",
    instavc_admin_users: "वापरकर्ते",
    instavc_courses: "अभ्यासक्रम",
    instavc_admin_username: "शिक्षकाचे नाव",
    instavc_admin_user_accountstatus: "खाते स्थिती",
    instavc_admin_user_confirmed: "पुष्टी",
    instavc_admin_user_unconfirmed: "अपुष्ट",
    instavc_admin_user_resetall: "सर्व रीसेट करा",
    instavc_admin_user_sync: "समक्रमित करा",
    instavc_admin_user_status: "स्थिती",
    instavc_admin_user_phonenumber: "फोन नंबर",
    instavc_admin_user_created: "तयार केले",
    instavc_admin_user_all: "सर्व",
    instavc_admin_groups: "गट",
    instavc_admin_addmore: "आणखी जोडा",
    instavc_admin_group_peoplelink: "क्वीन्स, गोलिव्ह, पीपललिंक",
    instavc_admin_select_plan: "योजना निवडा",
    instavc_admin_lastmodified: "अंतिम सुधारित",
    instavc_admin_email_verified: "ईमेल सत्यापित",
    instavc_admin_verified: "सत्यापित",
    instavc_admin_Unverified: "असत्यापित",
    instavc_admin_licenses: "परवाने",
    instavc_admin_addlicense: "परवाने जोडा",
    instavc_mculink: "https://awsmcu.instavc.com",
    instavc_admin_expirydate: "कालबाह्यता तारीख",
    instavc_admin_settings: "प्रशासक सेटिंग्ज",
    instavc_default_offer: "रेफरलसाठी डीफॉल्ट ऑफर",
    instavc_enter_coupon_code: "कूपन कोड प्रविष्ट करा",
    instavc_current_partshare: "वर्तमान भागीदार सामायिक करा",
    instavc_share_value: "शेअर मूल्य",
    instavc_affliate_share: "वर्तमान संबद्ध हिस्सा",
    instavc_enter_share: "शेअर मूल्य प्रविष्ट करा",
    instavc_roomname: "खोलीचे नाव",
    instavc_room_ten: "दहा",
    instavc_room_twenty: "वीस",
    instavc_room_thirty: "तीस",
    instavc_roomid: "खोली आयडी",
    instavc_roomtype: "वय",
    instavc_room_options: "खोली पर्याय",
    instavc_commercialtype: "विषय",
    instavc_free: "फुकट",
    instavc_poc: "POC",
    instavc_commercial: "व्यावसायिक",
    instavc_createdAt: "येथे तयार केले",
    instavc_useraccess: "वापरकर्ता प्रवेश",
    instavc_peoplelinkroom: "पीपलिंक खोली",
    instavc_inputlimit: "इनपुट मर्यादा",
    instavc_participant_limit: "सहभागींची मर्यादा",
    instavc_adduser: "वापरकर्ता जोडा",
    instavc_searchbyname: "नावानुसार शोध",
    instavc_manage_plans: "योजना / उत्पादने व्यवस्थापित करा",
    instavc_new_plans: "नवीन योजना / उत्पादन",
    instavc_allplan_list: "सर्व योजनांची यादी",
    instavc_sortby: "यानुसार क्रमवारी लावा",
    instavc_active: "सक्रिय",
    instavc_inactive: "निष्क्रिय",
    instavc_create_plan: "नवीन योजना तयार करा",
    instavc_plan_name: "योजनेचे नाव",
    instavc_enteramount: "रक्कम प्रविष्ट करा (किमान: INR 100)",
    instavc_select_product: "उत्पादन निवडा",
    instavc_host_room: "1 यजमान / खोली",
    instavc_number_hosts: "यजमानांची संख्या",
    instavc_number_participants: "सहभागींची संख्या",
    instavc_number_room: "खोल्यांची संख्या",
    instavc_subscriptiom_period: "सदस्यता कालावधी",
    instavc_sub_yearly: "वार्षिक",
    instavc_sub_monthly: "मासिक",
    instavc_sub_weekly: "साप्ताहिक",
    instavc_setinterval: "मध्यांतर सेट करा",
    instavc_type: "प्रकार",
    instavc_subscription: "सदस्यता",
    instavc_onetime: "एकावेळी",
    instavc_description: "वर्णन",
    instavc_planid: "PlanID",
    instavc_orders: "आदेश",
    instavc_orderid: "Order Id",
    instavc_none: "काहीही नाही",
    instavc_customer: "ग्राहक",
    instavc_recurring_billing: "आवर्ती बिलिंग",
    instavc_invoice_details: "पावत्या तपशील",
    instavc_recurring_payment: "आवर्ती पेमेंट",
    instavc_todays_sale: "आजची विक्री",
    instavc_total_order: "एकूण आदेश",
    instavc_total_rooms: "एकूण खोल्या",
    instavc_current_conference: "सद्य परिषद",
    instavc_current_user: "वर्तमान वापरकर्ते",
    instavc_live_broadcast: "थेट प्रसारणे",
    instavc_loading_chart: "लोड करीत आहे चार्ट",
    instavc_view: "पहा",
    instavc_coupon_info: "कूपन माहिती",
    instavc_new_coupon: "नवीन कूपन",
    instavc_create_coupon: "नवीन कूपन तयार करा",
    instavc_coupon_code: "कूपन कोड",
    instavc_company_code: "कंपनी कोड",
    instavc_select_plan: "योजना निवडा",
    instavc_discount: "सवलत",
    instavc_activestatus: "सक्रिय स्थिती",
    instavc_usage: "वापर",
    instavc_activeusage: "सक्रिय वापर",
    instavc_singleuse: "एकच वापर",
    instavc_multiuse: "बहु वापर",
    instavc_first_page: "पहिले पान",
    instavc_previosu_page: "मागील पान",
    instavc_next_page: "पुढील पृष्ठ",
    instavc_last_page: "शेवटचं पान",
    instavc_plan: "योजना",
    instavc_request_withdrawal: "विनंती मागे घ्या",
    instavc_withdraw: "माघार घ्या",
    instavc_account: "खाते",
    instavc_verification: "पडताळणी",
    instavc_add_bank: "पैसे काढण्यासाठी बँक खाते जोडा",
    instavc_bank_description:
      "आम्ही आपली आर्थिक माहिती गोपनीय ठेवून आपल्या बँक खात्याचे संरक्षण करतो. आम्हाला या खात्यातून पैसे काढण्यासाठी विनंती प्राप्त झाल्यावर आम्ही आपल्याला स्थिती ईमेल करू. पैसे काढण्याचे अपयश टाळण्यासाठी आणि पैसे परत करण्यासाठी, या खात्यातील नाव आपल्या बँक खात्यावरील नावाशी जुळले पाहिजे. आपल्या बँकेच्या धोरणे आणि सुट्टीच्या वेळापत्रकानुसार हस्तांतरण पूर्ण करण्यात काही वेळ लागू शकेल ",
    instavc_bank_accountnumber: "बँक खाते क्रमांक",
    instavc_enter_accountnumber: "आपला खाते क्रमांक प्रविष्ट करा",
    instavc_account_name: "खातेधारकाचे नाव",
    instavc_bankname: "बँकेचे नाव",
    instavc_branchname: "बँकेच्या शाखेचे नाव",
    instavc_confirmdetails: "तपशीलांची पुष्टी करा",
    instavc_pandetails: "आपल्या पॅननुसार लीज खाली तपशील द्या",
    instavc_enter_pan: "पॅन नुसार आपले नाव प्रविष्ट करा",
    instavc_fathername: "वडिलांचे नाव",
    instavc_enter_fathername: "वडिलांचे नाव प्रविष्ट करा",
    instavc_pannumber: "PAN Number",
    instavc_panexampe: "Ex: BNZPM2501G",
    instavc_upload_pan_copy: "पॅन कॉपी अपलोड करा",
    instavc_save_details: "तपशील जतन करा",
    instavc_sales: "विक्री",
    instavc_transactionid: "व्यवहार आयडी",
    instavc_date: "तारीख",
    instavc_amount: "रक्कम",
    instavc_setaccount_withdraw: "पैसे काढण्यापूर्वी खात्याचा तपशील सेट करा",
    instavc_first_withdraw:
      "आपण प्रथमच पैसे काढण्यासाठी विनंती करीत असलेले वापरकर्ता असल्यास, आपल्याला पुढील टॅबमध्ये पॅन कार्ड तपशील वापरुन खात्याचा तपशील भरणे आणि आपले खाते सत्यापित करणे आवश्यक आहे. एकदा आपण सत्यापन केले की आपण आपल्या उपलब्ध शिल्लकमधून पैसे काढण्यासाठी विनंती करण्यास पुढे जाऊ शकता",
    instavc_accountdetails: "खात्याचा तपशील भरा",
    instavc_available_balance: "उपलब्ध शिल्लक",
    instavc_enteramount_withdraw: "आपण काढू इच्छित रक्कम प्रविष्ट करा",
    instavc_select_payment_mode: "देय मोड निवडा",
    instavc_paypal_payment: "Paypal Payment",
    instavc_bank_transaction: "Bank Transaction",
    instavc_totalamount_withdraw: "पैसे काढण्याची एकूण रक्कम",
    instavc_sendrequest: "विनंती पाठवा",
    instavc_no_request_withdraw:
      "पैसे काढण्यासाठी अद्याप कोणतीही विनंती उठविली नाही!",
    instavc_start_process_withdraw:
      "आपण खालीून पैसे काढण्यासाठी प्रक्रिया सुरू करू शकता.",
    instavc_request_withdraw_now: "आता मागे घेण्याची विनंती करा",
    instavc_current_commission: "चालू आयोग",
    instavc_from: "पासून",
    instavc_today: "आज",
    instavc_last7days: "गेल्या 7 दिवस",
    instavc_lastmonth: "या महिन्यात",
    instavc_paid_customers: "सशुल्क ग्राहक",
    instavc_share_referral_link: "आपला रेफरल दुवा मित्रांसह सामायिक करा",
    instavc_paid: "पैसे दिले",
    instavc_unpaid: "न चुकता",
    instavc_totalearned: "एकूण कमाई",
    instavc_myreferral: "माझे संदर्भ",
    instavc_viewall: "सर्व पहा",
    instavc_mysales: "माझी विक्री",
    instavc_sms_mfa: "SMS MFA Status",
    instavc_facebook: "फेसबुक",
    instavc_twitter: "ट्विटर",
    instavc_linkedin: "लिंक्डइन",
    instavc_referred_users: "संदर्भित वापरकर्ते",
    instavc_created_date: "तयार केलेली तारीख",
    instavc_myearnings: "माझे कमाई",
    instavc_earnings: "कमाई",
    instavc_commission_share: "कमिशन शेअर",
    instavc_commission_percentage: "कमिशन टक्केवारी",
    instavc_coupon_offers: "कूपन / ऑफर",
    instavc_my_referral_account: "माझे संदर्भ खाते",
    instavc_req_withdraw: "विनंती मागे घ्या",
    instavc_authenticating: "इन्स्टाव्हीसी सर्व्हरवर प्रमाणीकरण करत आहे",
    instavc_join_access_media: "सामील झाले .. मीडिया उपकरणांवर प्रवेश करत आहे",
    instavc_publish_success: "यशस्वी यशस्वी",
    instavc_recieves: "प्राप्त करते",
    instavc_host_screenshare:
      "आपल्याला स्क्रीन / दस्तऐवज सामायिकरणसाठी किंवा होस्ट होण्यासाठी आवश्यक आहे",
    instavc_request_sharescreen:
      "स्क्रीन / दस्तऐवज सामायिकरणासाठी प्रवेशाची विनंती करा",
    instavc_note: "Note",
    instavc_filesize: "फाईलचा आकार 10MB पेक्षा जास्त नसावा",
    instavc_become_host:
      "होस्ट होण्यासाठी व्हिडिओवरील डॉटेड ओव्हरफ्लो मेनू चिन्हावर क्लिक करा",
    instavc_clicklink:
      "पॉपअपमध्ये होस्ट दुवा व्हा क्लिक करा आणि यजमान संकेतशब्द प्रविष्ट करा आणि होस्ट बटणावर क्लिक करा ",
    instavc_doc_share: "Document Share",
    instavc_search_host: "होस्टची वाट पहात आहे",
    instavc_wait_for_host: "कृपया होस्टने हे सत्र सुरू होण्याची प्रतीक्षा करा",
    instavc_host_permission: "आपल्याला होस्टकडून प्रवेशाची परवानगी आवश्यक आहे",
    instavc_please_wait: "कृपया प्रतीक्षा करा ",
    instavc_waiting_msg:
      "प्रतीक्षा केल्याबद्दल धन्यवाद. होस्ट सामील झाल्यावर आम्ही सत्र सुरू करू",
    instavc_let_hostname:
      "आपण होस्टला आपली प्रतीक्षा करीत आहोत हे सांगायचे आहे का?",
    instavc_exitconf: "निर्गमन परिषद",
    instavc_end_host_msg:
      "होस्टने हे सत्र संपवले आहे. उपस्थित राहिल्याबद्दल धन्यवाद.",
    instavc_close_conf: "आपण घरी परत जाऊ शकता (किंवा) अनुप्रयोग बंद करू शकता",
    instavc_gohome: "घरी जा",
    instavc_hand_raised: "हात उंचावला",
    instavc_ask: "विचारा",
    instavc_confirm_details: "आपल्या तपशीलांची पुष्टी करा",
    instavc_enter_info_conf:
      "कृपया परिषद सुरू करण्यापूर्वी आपली माहिती प्रविष्ट करा.",
    instavc_have_acc: "आपल्याकडे आधीपासूनच खाते असल्यास?",
    instavc_host_pass: "होस्ट संकेतशब्द प्रविष्ट करा",
    instavc_becomehost: "होस्ट व्हा",
    instavc_request_permission: "ला अतिरिक्त परवानग्यांची विनंती केली आहे",
    // "instavc_planid" : "PlanId",
    instavc_customeremail: "ग्राहक ईमेल",
    instavc_orderlink: "ऑर्डर दुवा",
    instavc_customerid: "ग्राहक आयडी",
    instavc_selectpackage: "पॅकेज निवडा",
    instavc_nodata_msg:
      "अरेरे! आपल्याला आत्ता दर्शविण्यासाठी कोणताही डेटा उपलब्ध नाही.",
    instavc_basicplan: "Basic Plan",
    instavc_host_participants: "30 सहभागी असणारे 1 होस्ट",
    instavc_expires: "Expires",
    instavc_start_VC: "व्हिडिओ कॉन्फरन्स सुरू करा",
    instavc_start_AC: "ऑडिओ कॉन्फरन्स सुरू करा",
    instavc_date_error: "प्रारंभ तारीख आणि वेळ वर्तमान वेळेपेक्षा मोठा असावा",
    instavc_browser_update: "ब्राउझर अद्यतन आवश्यक",
    instavc_browser_upgrade:
      "अधिक चांगल्या अनुभवासाठी कृपया या ब्राउझरच्या कोणत्याही नवीनतम आवृत्तीमध्ये श्रेणीसुधारित करा.",
    instavc_contact_msg:
      "आधीपासून श्रेणीसुधारित केले आहे, परंतु अद्याप समस्या आहे? येथे आमच्याशी संपर्क साधा",
    instavc_camera_busy: "कॅमेरा व्यस्त असल्याचे दिसते!",
    instavc_close_camera:
      "कृपया सर्व अनुप्रयोग बंद करा आणि पुन्हा प्रयत्न करा.",
    instavc_resolution: "ठराव समर्थित नाही!",
    instavc_camera_notsupport: "आपला कॅमेरा या ठरावाला समर्थन देत नाही.",
    instavc_camera_reconfig:
      "कमी रिजोल्यूशनसह आपली सेटिंग्ज पुन्हा कॉन्फिगर करा आणि पुन्हा प्रयत्न करा.",
    instavc_change_resolution: "ठराव बदला",
    instavc_delete_room: "आपली खात्री आहे की आपण कक्ष हटवू इच्छिता?",
    instavc_delete_license: "आपणास खात्री आहे की परवाना हटवायचा आहे?",
    instavc_help: "आम्ही आपल्याला मदत करण्यासाठी येथे आहोत",
    instavc_browse_questions:
      "बर्‍याचदा विचारल्या जाणार्‍या प्रश्नांमधून ब्राउझ करा.",
    instavc_os: "Operating System",
    instavc_webcam_permission: "वेबसाइटवर वेबकॅम परवानग्या आहेत?",
    instavc_microphone_permission: "वेबसाइटला मायक्रोफोन परवानग्या आहेत?",
    instavc_change_output_device: "आपण आउटपुट ऑडिओ डिव्हाइस बदलू शकता?",
    instavc_initial_setup:
      "कृपया आपल्या प्रारंभिक सेटअपवर प्रक्रिया होत असताना प्रतीक्षा करा!",
    instavc_close_browser:
      "यावेळी आपला ब्राउझर बंद करू नका किंवा मागील बटण वापरू नका.",
    instavc_whoops: "अरेरे!",
    instavc_nonet_msg:
      "कोणतेही इंटरनेट कनेक्शन आढळले नाही. कृपया आपले कनेक्शन तपासा किंवा पुन्हा प्रयत्न करा.",
    instavc_nosearch: "शोध परिणाम आढळला नाही",
    instavc_noserchmsg:
      "आम्हाला आपल्या शोधाशी जुळणारी कोणतीही वस्तू सापडली नाही.",
    instavc_nosearch_filter:
      "आपण शोधत असलेले शोधण्यासाठी आपला शोध समायोजित करण्याचा प्रयत्न करा किंवा फिल्टर.",
    instavc_gotohoem_page: "मुख्यपृष्ठावर जा",
    instavc_pageloading: "पृष्ठ लोड करीत आहे ... कृपया प्रतीक्षा करा!",
    instavc_process: "प्रक्रिया करीत आहे ...",
    instavc_session_timeout: "सत्र कालबाह्य",
    instavc_session_inactivity: "निष्क्रियतेमुळे आपले सत्र कालबाह्य होत आहे.",
    instavc_session_msg: "कृपया साइन इन रहाणे निवडा.",
    instavc_site_notreached: "या साइटवर पोहोचणे शक्य नाही!",
    instavc_site_webaddress:
      "आपल्याला योग्य वेब पत्ता मिळाला आहे याची खात्री करा",
    instavc_check_internet: "आपले नेटवर्क तपासा",
    instavc_search_url: "अन्य ब्राउझरमध्ये URL शोधा",
    instavc_start_collabrate: "व्हाइटबोर्ड मध्ये सहयोग सुरू करण्यासाठी",
    instavc_large_conference_mode:
      'हा "मोठा परिषद" मोड, होस्ट आपल्याला परवानगी देत नाही तोपर्यंत आपण इतरांना बोलू किंवा पाहू शकत नाही',
    instavc_allow_participants:
      'त्याचा "मोठा कॉन्फरन्स" मोड, आपल्याला सहभागींना व्यक्तिशः बोलण्याची परवानगी द्यावी लागेल',
    instavc_buy_premium: "ही वैशिष्ट्ये अनलॉक करण्यासाठी प्रीमियम खरेदी करा",
    instavc_alert_tryagain: "काहीतरी चूक झाली, कृपया पुन्हा प्रयत्न करा",
    instavc_browser_not_support_incall:
      "आपला ब्राउझर कॉल दरम्यान रिझोल्यूशन बदलास समर्थन देत नाही!",
    instavc_failed_toPublish: "व्हिडिओ प्रकाशित करण्यात अयशस्वी",
    instavc_publish_fail: "व्हिडिओ प्रकाशित करा",
    instavc_video_cant_publish:
      "वापरकर्त्याची मर्यादा गाठल्यामुळे व्हिडिओ प्रकाशित केला जाऊ शकत नाही",
    instavc_failed_joinConference: "परिषदेत सामील होण्यात अयशस्वी",
    instavc_mute_audio:
      "रिमोट ऑडिओ नि: शब्द केल्यास आपण निःशब्द / सशब्द करू शकत नाही",
    instavc_remote_audio_muted: "रिमोट ऑडिओ निःशब्द केले!",
    instavc_enter_conferenceid: "आपला कॉन्फरन्स आयडी प्रविष्ट करा",
    instavc_sharing_your_screen: "आपली स्क्रीन सामायिक करत आहे",
    instavc_stop: "थांबा",
    instavc_back: "मागे",
    instavc_choose_plan: "खालील योजनेतून आपली योजना निवडा",
    instavc_have_promotionalcode: "एक जाहिरात कोड / भागीदार कोड आहे?",
    instavc_contact_pricing: "आमच्याशी संपर्क साधा",
    instavc_payment_failed: "देय देणे अयशस्वी",
    instavc_payment_error: "दुर्दैवाने आपले देय हाताळताना त्रुटी आली",
    instavc_contact_support:
      "कृपया काही सहाय्य आवश्यक असल्यास आमच्या समर्थन कार्यसंघाशी संपर्क साधा.",
    instavc_tryagain: "पुन्हा प्रयत्न करा",
    instavc_payment_success: "देय यशस्वी",
    instavc_thanks_for_payment: "आपल्या देय दिल्याबद्दल धन्यवाद!",
    instavc_payment_processed:
      "आपल्या देयकावर यशस्वीरित्या प्रक्रिया केली गेली आहे. स्वयंचलित पेमेंट पावती",
    instavc_mail_sent: "लवकरच आपल्या नोंदणीकृत ईमेल पत्त्यावर पाठविला जाईल",
    instavc_goto_homepage: "मुख्यपृष्ठावर परत जा",
    instavc_want_toend_call: "कॉल समाप्त करू इच्छिता?",
    instavc_exit_window:
      "ही विंडो बंद केल्याने आपल्या कॉलमधून बाहेर पडेल. आपली खात्री आहे की आपण हा कॉल समाप्त करू इच्छिता? ",
    instavc_create_room: "खोली तयार करा",
    instavc_userlimit: "वापरकर्त्याची मर्यादा",
    instavc_edit_room: "कक्ष संपादित करा",
    instavc_update: "अद्यतनित करा",
    instavc_manage_license: "परवाने व्यवस्थापित करा",
    instavc_package: "पॅकेज",
    instavc_no_of_rooms: "खोल्यांची संख्या",
    instavc_no_of_users: "वापरकर्त्यांपैकी नाही",
    instavc_purchasedOn: "वर विकत घेतले",
    instavc_expiredon: "रोजी कालबाह्य",
    instavc_or: "किंवा",
    instavc_otherhost_email:
      "आपण कोणत्याही वापरकर्त्यास होस्ट बनवू इच्छित असल्यास, त्याचा / तिचा ईमेल पत्ता प्रविष्ट करा",
    instavc_set_host_password: "होस्ट संकेतशब्द सेट करा",
    instavc_host_password: "होस्ट संकेतशब्द",
    instavc_access_room: "या खोलीत आणखी कोण प्रवेश करू शकेल?",
    instavc_select_user_host:
      "सूचीतून कोणताही वापरकर्ता त्याला होस्ट करण्यासाठी निवडा.",
    instavc_start: "प्रारंभ करा",
    instavc_enter_website: "कृपया वेबसाइटचे नाव प्रविष्ट करा",
    instavc_enter_valid_email: "कृपया वैध ईमेल प्रविष्ट करा",
    instavc_enter_valid_phone: "कृपया वैध फोन नंबर प्रविष्ट करा",
    instavc_field_required: "हे क्षेत्र आवश्यक आहे",
    instavc_invitedby: "द्वारा आमंत्रित",
    instavc_storage: "साठवण",

    affiliate_approve: "मंजूर",
    affiliate_pending: "प्रलंबित",
    affiliate_rejected: "नाकारले",
    affiliate_user_status: "वापरकर्त्याची स्थिती",
    commission_other: "इतर कमिशन",
    add_commission: "कमिशन जोडा",
    delete_commission: "तुम्हाला कमिशन हटवायचे आहे का?",
    update_commission: "अद्यतन आयोग",
    name: "नाव",
    offer_value: "ऑफर मूल्य",
    add: "जोडा",
    update: "अद्यतनित करा",
    affiliates: "संबद्ध",
    status: "स्थिती",
    status_change_message: "आपण स्थिती बदलू इच्छिता?",
    approve: "मंजूर",
    reject: "नाकारणे",
    withdraw_data: "डेटा मागे घ्या",
    withdraw_amount: "रक्कम मागे घ्या",
    payment_method: "देय द्यायची पद्धत",
    payment_fee: "Payment Fee",
    total_amount_withdraw: "पैसे काढण्यासाठी एकूण रक्कम",
    total_earnings: "एकूण उत्पन्न",
    pending_amount: "प्रलंबित रक्कम",
    paid_amount: "देय रक्कम",
    unpaid_amount: "अनपेड रक्कम",
    requested_withdraw: "पैसे काढण्याची विनंती केली",
    english: "इंग्रजी",
    french: "फ्रेंच",
    portuguese: "पोर्तुगीज",
    hindi: "हिंदी",
    gujarati: "गुजराती",
    kannada: "कन्नड",
    marathi: "मराठी",
    tamil: "तमिळ",
    telugu: "तेलगु",
    urdu: "उर्दू",
    spanish: "स्पॅनिश",
    malyalam: "माईलम",
    italian: "इटालियन",
    bangla: "बांगला",
    room: "खोली",
    create: "तयार करा",
    repeat: "पुन्हा करा",
    daily: "दररोज",
    repeat_every: "प्रत्येक पुनरावृत्ती",
    repeat_on: "पुन्हा करा",
    ends: "संपेल",
    after: "नंतर",
    occurences: "घटना",
    on: "on",
    summary: "सारांश",
    repeats: "पुनरावृत्ती",
    withdraws: "माघार घेतो",
    every: "प्रत्येक",
    days: "दिवस",
    weeks: "आठवडे",
    months: "महिना",
    onday: "दिवशी ",
    years: "वर्षे",
    times: "वेळा",
    until: "पर्यंत",
    past_meeting_list: "मागील सत्र यादी",
    organised_by: "आयोजित",
    delete: "हटवा",
    join: "सामील व्हा",
    enter_password: "पासवर्ड टाका",
    submit: "प्रस्तुत करणे",
    enter_passwordmessage: "कृपया संकेतशब्द प्रविष्ट करा",
    delete_message: "आपण हटवू इच्छिता का",
    meeting_permanent: "सत्र कायमचे?",
    day: "दिवस",
    password_message: "संकेतशब्द चुकीचा आहे",
    timezone: "वेळ क्षेत्र",
    by: "By",
    weekdays: ["रवि", "सोम", "मंगळ", "बुध", "गुरु", "शुक्र", "शनि"],
    allweek: [
      "रविवार",
      "सोमवार",
      "मंगळवार",
      "बुधवार",
      "गुरुवार",
      "शुक्रवार",
      "शनिवार",
    ],
    day_month: "महिन्याचा दिवस",
    day_week: "आठवड्याचा दिवस",
    week: "आठवडा",
    month: "महिना",
    year: "वर्ष",
    enterpassword:
      "कृपया आपला नवीन संकेतशब्द प्रविष्ट करा आणि संकेतशब्दाची पुष्टी करा",
    passwordmessage: "संकेतशब्द आणि पुष्टीकरण संकेतशब्द दोन्ही समान असावेत",
    passwordupdate:
      "संकेतशब्द यशस्वीरित्या अद्यतनित झाला, कृपया आपल्या नवीन संकेतशब्दासह लॉगिन करा",
    numeric: ["प्रथम", "द्वितीय", "तृतीय", "चौथा", "पाचवा"],
    verify_email: "आपला ईमेल सत्यापित करा",
    confirm_code: "पुष्टीकरण कोड",
    verify_msg: "कृपया कोडसाठी आपला मोबाइल तपासा",
    verify: "सत्यापित करा",
    not_recieved: "मिळाले नाही?",
    resend_otp: "ओटीपी पुन्हा पाठवा",
    start_browsing: "ब्राउझिंग प्रारंभ करा",
    become_affiliate: "संबद्ध व्हा",
    affiliate: "संबद्ध",
    verify_mobile: "आपला मोबाइल नंबर सत्यापित करा",
    instavc_allow_DocumentAccess: "परवानगी दस्तऐवज-सामायिक करा",
    instavc_allow_Notes: "परवानगी नोट्स",

    //common - CameraResolution	",
    camera_not_access: "पुढीलपैकी एका कारणांमुळे कॅमेरा प्रवेशयोग्य नाही:",
    camera_not_access_reason1:
      "रिजोल्यूशन सेटिंग्ज कदाचित या प्रदर्शनासह सुसंगत नसतील.आपल्या सेटिंग्जला कमी रिझोल्यूशनसह संरचीत करा आणि पुन्हा प्रयत्न करा.",
    camera_not_access_reason2:
      "आपला कॅमेरा भिन्न अनुप्रयोगाद्वारे वापरला जात आहे, कृपया सर्व अनुप्रयोग बंद करा आणि दुव्यावर क्लिक करून पुन्हा प्रयत्न करा.",
    //assignQuestList	",
    quslsit_assig_que_list: "नियुक्त प्रश्नावली यादी",
    quslsit_question_lists: "प्रश्नावली याद्या",
    quslsit_add_new_question: "नवीन प्रश्नावली जोडा",
    quslsit_no_question_assign:
      "अद्याप कोणतीही प्रश्नावली नियुक्त केली गेली नाही!",
    quslsit_assign_new_ques:
      "वरील वाटप प्रश्नावली बटणावर क्लिक करण्यासाठी नवीन प्रश्नावली नियुक्त करा",

    //model-assign-Questionnaire	",
    select_questionnaire: "प्रश्नावली निवडा",
    duration: "कालावधी",
    time_limit: "वेळेची मर्यादा",
    show_results: "परिणाम दर्शवा",
    save: "जतन करा",
    //viewAssigned	",
    content_group: "सामग्री गट",
    list_assigned_ques: "नियुक्त केलेल्या प्रश्नांची यादीः",
    marks: "गुण",
    //AssignedQuestions	",
    asgQues_5_Marks: "( 5 Marks )",
    asgQues_answers: "उत्तरे",

    //content - components - contentGrade	",
    //GradeSetting	",
    grdSet_GPA_calculation: "टक्केवारीवरून जीपीए गणना",
    grdSet_GPA_cal_msg:
      "टक्केवारी 100% ची आहे जी 100 गुणांशिवाय काहीही नाही. तर टक्केवारीतील 25 गुण जीपीए सिस्टममधील 1 बिंदूइतके असतात. जीपीए फॉर्म्युलाची टक्केवारी केवळ आपल्या टक्केवारीचे 100 चे विभाजन करा आणि 4 ने गुणाकार करा. जर आपली टक्केवारी 75% असेल तर आपला ग्रेड (75/100) * 4 = 3 असेल.",
    grdSet_grade_point: "जर ग्रेड पॉईंट्स असतील",
    //managegrade	",
    mngGrd_modify: "सुधारित करा",
    mngGrd_save_grades: "ग्रेड जतन करा",
    //content - components - ContentParticipants : 	सामग्री भाग घेणारे",
    //components-admnAnsView",
    admnAns_answer_list_for_question:
      "खाली या सामग्री समूहाच्या सर्व प्रश्नावलींच्या उत्तरांची यादी खाली दिली आहे.",
    //components-participants	",
    prtcpt_certification: "प्रमाणपत्रे:",
    prtcpt_other_content_group: "इतर सामग्री गटांमध्ये",
    prtcpt_sales: "विक्री",
    prtcpt_marketing: "विपणन",
    prtcpt_human_resource: "मानवी संसाधने",
    //manageparticipants	",
    mngPrtcpt_add_participants: "सहभागी जोडा",
    mngPrtcpt_participants_list: "सहभागी याद्या",
    mngPrtcpt_import_participants: "सहभागी आयात करा",
    mngPrtcpt_download_sample: "नमुना डाउनलोड करा",
    mngPrtcpt_no_participants_added: "अद्याप कोणतेही सहभागी जोडले गेले नाहीत!",
    mngPrtcpt_add_new_participant:
      "नवीन सहभागी जोडा, जोडण्यासाठी वरील सहभागी बटण जोडा क्लिक करा",
    //modal-add-participants	",
    addPrtcpt_select_participants: "सहभागी निवडा",
    addPrtcpt_model_add_participants: "सहभागी जोडा",
    //partipantGradeView	",
    prtcptGrde_participant_grade: "सहभागी ग्रेड तपशील",
    prtcptGrde_grade_participants_list: "सहभागी यादी",
    //content - components - ContentQuestionnaire	",
    //managequestionnaire	",
    mngQuesnr_create_questionnaire: "प्रश्नावली तयार करा",
    questionnaire_list: "प्रश्नावली यादी",
    //managequestions	",
    mngQues_no_question_created: "अद्याप कोणताही प्रश्न तयार केला गेला नाही!",
    mngQues_create_new_question:
      "नवीन प्रश्न तयार करा, तयार करण्यासाठी वरील प्रश्न तयार करा बटणावर क्लिक करा",
    //modal-create-quest-group	",
    mdlGrp_update: "अद्यतनित करा",
    mdlGrp_create: "तयार करा",
    //modal-create-questions",
    mdlCrtQues_question_type: "प्रश्न प्रकार",
    mdlCrtQues_sel_question_type: "प्रश्न प्रकार निवडा",
    mdlCrtQues_single_sel_multiple_choice: "सिंगल सिलेक्ट सिलेक्ट मल्टीपल चॉईस",
    mdlCrtQues_multiselect_multiple_choice: "मल्टीलाइलेक्ट मल्टिपल चॉईस",
    mdlCrtQues_ture_false: "खरे खोटे",
    mdlCrtQues_enter_answer_choice:
      "उत्तर निवडी प्रविष्ट करा आणि कोणते उत्तर बरोबर आहे ते चिन्हांकित करा",
    mdlCrtQues_add_another_choice: "+ आणखी एक पर्याय जोडा",
    //viewQuestionnaire	",
    viewQues_add_questions: "प्रश्न जोडा",
    viewQues_no_question_created: "अद्याप कोणताही प्रश्न तयार केला गेला नाही!",
    viewQues_create_new_question:
      "नवीन प्रश्न तयार करा, तयार करण्यासाठी वरील प्रश्न तयार करा बटणावर क्लिक करा",

    //content - components - createContent	",
    //createcontent	:",
    crteContent_create_new_content: "नवीन सामग्री तयार करा",
    crteContent_update_content: "सामग्री अद्यतनित करा",
    crteContent_save_content: "सामग्री जतन करा",
    crteContent_content_list: "सामग्री याद्या",
    edit_content: "सामग्री संपादित करा",
    crteContent_create_content: "सामग्री तयार करा",
    crteContent_create_your_content_like:
      "प्रतिमा, व्हिडिओ फाइल्स, ऑडिओ फायली आणि दस्तऐवजांसारखे मीडिया जोडून आपली सामग्री तयार करा.",
    crteContent_upload_document: "कागदपत्रे अपलोड करा",
    crteContent_upload_media: "मीडिया अपलोड करा",
    crteContent_document: "कागदपत्रे",
    //view-content	",
    viewCon_content_view: "सामग्री दृश्य",
    viewCon_content_list: "सामग्री याद्या",
    viewCon_View_content: "सामग्री पहा",
    viewCon_document: "कागदपत्रे",

    //content - components - contentRow	",
    conRow_by: "By: ",

    //content - components - managecontent	",
    mngCon_no_content_created: "अद्याप कोणतीही सामग्री तयार केली गेली नाही!",
    mngCon_create_new_content:
      "तयार करण्यासाठी वरील सामग्री बटणावर क्लिक करा, नवीन सामग्री तयार करा",
    //content - components - model-access-right	",
    mdlAccRight_share_access: "इतर प्रशिक्षकांसह प्रवेश सामायिक करा",
    mdlAccRight_type_id_add: "ईमेल आयडी टाइप करा आणि जोडा",
    mdlAccRight_no_instructor_added:
      "अद्याप कोणताही इन्स्ट्रक्टर जोडला गेला नाही!",
    mdlAccRight_add_people_from_addressbok:
      "आपल्या अ‍ॅड्रेस बुकमधून किंवा ईमेल पत्ता टाइप करून लोकांना जोडा",
    mdlAccRight_contacts: "संपर्क",
    mdlAccRight_add_contacts:
      "आपल्या अ‍ॅड्रेस बुक संपर्कांमधून सामग्री गटात संपर्क जोडा",
    mdlAccRight_no_contacts_added: "अद्याप कोणतेही संपर्क जोडले गेले नाहीत!",
    //content - components - model-confirm-delete	",
    mdlConfDel_confirmation: "पुष्टीकरण",
    mdlConfDel_are_you_sure_delete: "आपली खात्री आहे की आपण हे हटवू इच्छिता",
    mdlConfDel_delete: "हटवा",
    //content - components - model-create-content-group	",
    mdlCrtConGrp_alert_enter_group_title: "कृपया गट शीर्षक प्रविष्ट करा : ",
    mdlCrtConGrp_alert_enter_group_description: "कृपया गट वर्णन प्रविष्ट करा",
    mdlCrtConGrp_group_name: "गटाचे नाव",
    //content - components - model-upload-doc	",
    mdlUpldoc_alert_enter_title_doc: "कृपया दस्तऐवजाचे शीर्षक प्रविष्ट करा",
    mdlUpldoc_upload_document: "कागदपत्रे अपलोड करा",
    mdlUpldoc_document_title: "दस्तऐवज शीर्षक",
    mdlUpldoc_upload_doc_from_system:
      "आपल्या सिस्टमवरून दस्तऐवज अपलोड करा, ते .पीडीएफ, एक्सेल, शब्द दस्तऐवज समर्थन करते. ",
    mdlUpldoc_upload_doc: "दस्तऐवज अपलोड करा",
    mdlUpldoc_added_doc: "दस्तऐवज जोडले",
    //content - components - model-upload-media	",
    mdlUplMedia_alert_enter_title_media: "कृपया माध्यमांचे शीर्षक प्रविष्ट करा",
    mdlUplMedia_alert_enter_title_url: "कृपया शीर्षक आणि URL प्रविष्ट करा",
    mdlUplMedia_alert_enter_youtube_vimeo_url:
      "कृपया वैध आणि URL प्रविष्ट करा (YouTube / Vimeo)",
    mdlUplMedia_add_media_url: "मीडिया संलग्न करण्यासाठी मीडिया URL पत्ता जोडा",
    mdlUplMedia_Add_media_file: "मीडिया फायली जोडल्या",

    //content - managecontent - index	",
    // "mngContent_content" : "Content",
    mngContent_participants: "सहभागी",

    //content - index	",
    content_all_content_group: "सर्व सामग्री गट",
    create_new_group: "गट तयार करा",
    content_no_group_created: "अद्याप कोणतेही गट तयार केलेले नाहीत",
    content_create_new_group:
      "एक नवीन गट तयार करा, तयार करण्यासाठी वरील गट तयार करा बटणावर क्लिक करा",

    //ContentShare - contentList",
    conList_all_group: "सर्व गट",
    grpList_no_group_created: "अद्याप कोणतेही गट तयार केले गेले नाहीत!",

    //ContentShare - questionStepper	",
    queStepper_cant_skip: "आपण पर्यायी नसलेले एक चरण वगळू शकत नाही",
    queStepper_back: "मागे",
    queStepper_next: "पुढे",
    queStepper_skip: "वगळा ",
    queStepper_finish: "समाप्त",
    queStepper_submit_next: "सबमिट करा आणि पुढे",
    //contentshare - showContent	",
    showCont_document: "कागदपत्रे",
    showCont_previous: "मागील",
    showCont_next: "पुढे",
    showCont_have_completed_topic: "मी या सामग्रीमधील विषय पूर्ण केले आहेत",
    //contentShare - showMedia",
    showMedia_page: "पृष्ठ",

    //contentShare - showquestions	",
    showQues_completed_test: "आपण या प्रश्नावलीमधील चाचणी पूर्ण केली आहे.",
    showQues_go_back_content_group: "सामग्री गटाकडे परत जा",
    //contentShare - viewUserScore	",
    viewUserScore_view_score: "स्कोअर पहा",
    viewUserScore_total_marks: "एकूण गुण",
    viewUserScore_scored_marks: "स्कोअर गुण",
    viewUserScore_below_list_of_answer:
      "खाली या सामग्री समूहाच्या सर्व प्रश्नावलींच्या उत्तरांची यादी खाली दिली आहे",
    viewUserScore_answered: "उत्तर दिले",
    viewUserScore_correct_answer: "बरोबर उत्तर",

    //schedule - components	",
    //ConfirmCancelInvite	",
    confCancle_confirmation: "पुष्टीकरण",
    confCancle_are_you_sure: "आपली खात्री आहे?",
    confCancle_delete_user: "वापरकर्ता हटवा",
    //confirmscheduledelete	",
    confSche_are_you_sure_delete:
      "आपली खात्री आहे की आपण हे वेळापत्रक हटवू इच्छिता?",
    confSche_no: "नाही",
    //PastMeetingitem	",
    // "pastMtnItem_rn" : "RN",
    // "pastMtnItem_room_name" : "Room Name: ", : खोलीचे नाव",
    // "pastMtnItem_webinar_list" : "Webinar List",
    // "pastMtnItem_list_webinar" : "Below are the list of webinars.", : खाली वेबिनारची यादी आहे",
    // "pastMtnItem_today" : "Today", : आज",
    // "pastMtnItem_webinar_title_falls" : "Webinar Title Falls Here",
    // "pastMtnItem_view" : "View", : पहा",
    // "pastMtnItem_upcoming" : "Upcoming", : आगामी",

    //SchedulesView	",
    //"scheView_edit_content" : "Edit content",
    scheView_invite_participants: "सहभागींना आमंत्रित करा",
    scheView_start_conference: "परिषद सुरू करा",
    scheView_event_details: "कार्यक्रम तपशील",
    scheView_room_name: ",खोलीचे नाव",
    scheView_minutes: "मिनिटे",
    scheView_conference_password: "परिषद संकेतशब्द",
    scheView_guest_login_anonymous: "अतिथी अनामिक म्हणून लॉग इन करू शकतात",
    scheView_allow_invities:
      "केवळ आमंत्रणांना परिषदेत सामील होण्यास परवानगी द्या",
    scheView_list_of_people_invited: "खाली आमंत्रित लोकांची यादी आहे",
    scheView_alert_err_to_join: "सामील होण्यास त्रुटी",
    //WebinarDetails	",
    webnrDtls_upcoming_webinar_room: "खाली या खोलीसाठी आगामी वेबिनार आहेत",
    // Webinar 1",
    // Webinar 2",
    // Webinar 3",
    webnrDtls_webinar_title_falls: "वेबिनार शीर्षक येथे येते",
    webnrDtls_get_more_joining: "या वेबिनारमध्ये सामील होऊन अधिक मिळवा",
    webnrDtls_join_webinar: "वेबिनारमध्ये सामील व्हा",
    //webinarList	",
    webnrList_below_list_of_webinar: "खाली वेबिनारची यादी आहे",
    webnrList_today: "आज",
    webnrList_view: "पहा",
    webnrList_upcoming: "आगामी",

    //schedule - 	",
    //AddressBook	",
    addBook_contact: "संपर्क",
    addBook_add_contact_to_meeting:
      "तुमच्या अॅड्रेस बुक संपर्कांमधून, सत्रात संपर्क जोडा",
    //MeetingList	",
    meetingList_past_meetings: "मागील सत्रे",
    meetingList_past_meetings_list: "मागील सत्रांची यादी",
    meetingList_room_name: "खोलीचे नाव",
    meetingList_view: "पहा",
    //scheduleInvite	",
    scheInvt_err_invalid_id: "अवैध ईमेल आयडी",
    scheInvt_invite_participants: "सहभागींना आमंत्रित करा",
    scheInvt_invite_people_to_meeting:
      "या सत्रासाठी लोकांना आमंत्रित करा. तुमच्या अॅड्रेस बुकमधून किंवा ईमेल अॅड्रेस टाइप करून लोकांना जोडा.",
    scheInvt_start: "Starts @ ",
    scheInvt_below_list_of_answer:
      "खाली या सामग्री समूहाच्या सर्व प्रश्नावलींच्या उत्तरांची यादी खाली दिली आहे",
    scheInvt_minutes: "मिनिटे",
    //Webinar 1",
    scheInvt_add: "जोडा",
    scheInvt_no_participants_added: "कोणतेही सहभागी जोडले नाहीत",
    scheInvt_add_ppl_to_meetings:
      "तुमच्या अॅड्रेस बुकमधून लोकांना या सत्रात सहभागी म्हणून जोडा किंवा त्यांना शोधाद्वारे जोडा.",
    scheInvt_send_invitation: "आमंत्रण पाठवा",
    scheInvt_send_passcodes: "वेगळ्या मेलमध्ये पासकोड पाठवा",

    //Invitation - component - invitationbody	",
    invitBody_invite_only_upto: "आपण केवळ 10 लोकांना आमंत्रित करू शकता",
    invitBody_invite_ppl_meeting_email_add:
      "लोकांना या सत्रासाठी आमंत्रित करा, तुमच्या अॅड्रेस बुकमधून लोकांना जोडा किंवा ईमेल अॅड्रेसद्वारे जोडा.",
    invitBody_enter_emailid: "ईमेल आयडी प्रविष्ट करा",
    invitBody_close: "बंद",
    invitBody_send_invitation: "आमंत्रण पाठवा",

    //documentShare 	",
    //index,js	",
    docShare_doc_sharing: "दस्तऐवज सामायिकरण",
    docShare_no_doc: "कागदपत्रे नाहीत",
    docShare_no_doc_in_list: "अद्याप यादीमध्ये कागदपत्रे जोडलेली नाहीत",
    docShare_add_doc: "दस्तऐवज जोडले",
    docShare_alert_title_doc: "कृपया दस्तऐवजाचे शीर्षक प्रविष्ट करा",
    docShare_alert_something_went_wrong:
      "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा",
    //components - PermitDocShare	",
    permitDocShr_permit_doc_share_access: "परवानगी दस्तऐवज सामायिक प्रवेश",
    permitDocShr_req_permission_doc_share:
      "ने दस्तऐवज सामायिक करण्यासाठी प्रवेशाची परवानगी मागितली आहे",
    permitDocShr_deny: "नाकारणे",
    permitDocShr_allow: "परवानगी द्या",
    //components - RequestDocShare	",
    reqDocShr_req_doc_share_access: "विनंती दस्तऐवज सामायिक प्रवेश",
    reqDocShr_access_permission_host:
      "दस्तऐवज सामायिकरण सक्षम करण्यासाठी, आपल्याला होस्टकडून प्रवेशाची परवानगी आवश्यक आहे",
    reqDocShr_plz_wait: "कृपया प्रतीक्षा करा",
    reqDocShr_permission_start_doc_share:
      "दस्तऐवज सामायिकरण प्रारंभ करण्याची परवानगी",
    reqDocShr_doc_share: "दस्तऐवज सामायिक करा",
    //components - ShowDocument View	",
    showDocViewback: "मागे",
    showDocViewdoc_title_name: "दस्तऐवज शीर्षक नाव",
    showDocViewnext: "पुढे",

    //Broadcast - 	",
    //boradcastScreenShare	",
    borcstScreen_Plz_enable_js:
      "हा व्हिडिओ पाहण्यासाठी कृपया जावास्क्रिप्ट सक्षम करा आणि त्या वेब ब्राउझरमध्ये श्रेणीसुधारित करण्याचा विचार करा",
    borcstScreen_steam_play_when_live:
      "जेव्हा तो थेट होईल तेव्हा व्हिडिओ प्रवाह प्ले होईल",
    //broadcast	",
    broadcast_enter_your_name: "कृपया आपले नाव प्रविष्ट करा",
    broadcast_enter_your_email: "कृपया आपला ईमेल प्रविष्ट करा",
    broadcast_Plz_enable_js:
      "हा व्हिडिओ पाहण्यासाठी कृपया जावास्क्रिप्ट सक्षम करा आणि त्या वेब ब्राउझरमध्ये श्रेणीसुधारित करण्याचा विचार करा",
    broadcast_steam_play_when_live:
      "जेव्हा तो थेट होईल तेव्हा व्हिडिओ प्रवाह प्ले होईल",
    //broadcastConference	",
    // "brdcstConf_participants" : "participants", : सहभागी",
    brdcstConf_broadcast: "प्रसारण",
    brdcstConf_right: "बरोबर",
    //broadcast - component	",
    //broadcasterParicipants	",
    brdcstPart_broadcast_list: "ब्रॉडकास्टर यादी",

    //Containers - calender	",
    //index	",
    calender_scheduled_calendar: "वेळापत्रक दिनदर्शिका",
    calender_select_all: "सर्व निवडा",
    calender_calender: "कॅलेंडर",
    calender_daily: "दररोज",
    calender_weekly: "साप्ताहिक",
    calender_month: "महिना",
    calender_today: "आज",

    //Dashboard - componenet	",

    //MeetingReminder	",
    meetReminder_scheduled_confirm: "वेळापत्रक पुष्टीकरण",
    meetReminder_meeting_has_been_scheduled:
      "या क्षणी पुढील सत्र नियोजित केले आहे",
    meetReminder_start_meeting: "हे सत्र सुरू करा",
    meetReminder_join_meeting: "या सत्रात सामील व्हा",
    meetReminder_quick_start_another_meeting: "दुसरे सत्र जलद सुरू करा",
    //MyMeetingItem	",
    myMeetItem_start: "प्रारंभ करा",
    myMeetItem_minutes: "मिनिटे",
    //MyMeeting	",
    myMeet_my_meetings: "माझे सत्र",
    myMeet_search_my_meetings: "माझे सत्र शोधा",
    //NoScheduledMeeting	",
    noScheMeet_no_meeting_scheduled: "कोणतीही सत्रे शेड्यूल केलेली नाहीत",
    noScheMeet_no_upcoming_meetings:
      "तुमच्याकडे अद्याप कोणतीही आगामी सत्रे शेड्यूल केलेली नाहीत. तुम्ही एक नवीन वेळापत्रक तयार करू शकता किंवा तुमची परिषद त्वरित सुरू करू शकता.",
    noScheMeet_create_schedule: "वेळापत्रक तयार करा",
    noScheMeet_quick_start: "द्रुत प्रारंभ",
    noScheMeet_or: "किंवा",
    //RoomSettings	",
    roomSet_alert_select_license: "कृपया परवाना निवडा",
    roomSet_manage_licenses: "परवाने व्यवस्थापित करा",
    roomSet_no_of_rooms: "खोल्यांची संख्या",
    roomSet_no_of_user: "वापरकर्त्यांची संख्या",
    roomSet_create_room: "खोली तयार करा",

    confNotf_want_to_join: "या सत्र कक्षात सामील होऊ इच्छित आहे.",
    confNotf_allow: "परवानगी द्या",
    confNotf_deny: "नाकारणे",
    confNotf_ask_question: "एक प्रश्न विचारला",
    confNotf_send_msg_lobby: "लॉबीकडून निरोप पाठविला",
    //Loddy	",
    lobby_participants_loddy: "लॉबीमध्ये सहभागी",
    lobby_pramote_all: "सर्वांचा प्रचार करा",
    lobby_user_name: "वापरकर्ता नाव",
    //RemoveUserDialog	",
    removeUserDlg_manage_user_selecting:
      "यापैकी कोणताही पर्याय निवडून या वापरकर्त्यास व्यवस्थापित करा",
    removeUserDlg_user_name: "वापरकर्ता नाव",
    removeUserDlg_block_participant: "सहभागीला अवरोधित केले आहे",
    removeUserDlg_send_to_lobby: "लॉबीला पाठवा",
    removeUserDlg_remote_participant: "सहभागी काढा",
    removeUserDlg_close: "बंद",
    //participantsList	",
    PartList_participants_in_lobby: "लॉबीमध्ये सहभागी",
    PartList_alert_something_went_wrong:
      "काहीतरी चूक झाली, कृपया पुन्हा प्रयत्न करा",
    PartList_promote_all: "सर्वांचा प्रचार करा",
    //participants2020	Retry : पुन्हा प्रयत्न करा",
    //WaitingRoom	",
    waitingRoom_waiting_room: "प्रतीक्षालय",
    waitingRoom_plz_wait_host_allow:
      "कृपया होस्ट आपल्याला परिषदेत सामील होईपर्यंत प्रतीक्षा करा",
    waitingRoom_no_msg_yet: "अद्याप संदेश नाहीत!",
    waitingRoom_no_msg_from_host: "होस्टकडून कोणतेही संदेश नाहीत",
    //userRemoved	",
    userRemoved_you_removed_by_host:
      "होस्टद्वारे आपल्याला सहभागी यादीमधून काढले गेले आहे",
    //invitationSlide	",
    invitSlide_invite: "आमंत्रित करा",
    invitSlide_add_email: "ईमेल जोडा",
    invitSlide_add: "जोडा",
    invitSlide_broadcast_list: "प्रसारण दुवा",
    invitSlide_invite_people_to_meeting:
      "या सत्रासाठी लोकांना आमंत्रित करा. लोकांना त्यांचा ईमेल पत्ता टाइप करून जोडा आणि आमंत्रण पाठवण्यासाठी सूचीमध्ये जोडा.",
    invitSlide_err_invalid_id: "अवैध ईमेल आयडी",
    //participantsChat	",
    particiChat_no_chat_msg: "अद्याप चॅट संदेश नाहीत",
    particiChat_start_conversation: "संदेश पाहण्यासाठी येथे संभाषण सुरू करा",

    //components - lobbyparticipants	",
    lobbyPartici_no_participants: "सहभागी नाही",
    lobbyPartici_no_participants_lobby: "लॉबीमध्ये सहभागी नाही",

    //conference	",
    //simulcast	",
    simulcast_alert_decline_access: "होस्टने प्रवेश नाकारला",
    simulcast_no_host_available:
      "याक्षणी कोणतेही होस्ट उपलब्ध दिसत नाही, कृपया स्क्रीन सामायिक करण्यासाठी होस्ट व्हा",
    //simulcastVAD & // Conference.js	",
    conference_access_to_participants: "सहभागींमध्ये प्रवेश",
    conference_lock_all: "सर्व लॉक करा",
    conference_become_host: "होस्ट व्हा",
    conference_you_are_host: "आपण होस्ट आहात",
    conference_share: "सामायिक करा",
    conference_document_share: "दस्तऐवज सामायिक करा",
    conference_more: "अधिक",
    conference_become_host: "होस्ट व्हा",
    conference_alert_no_host_aval_screen:
      "याक्षणी कोणतेही होस्ट उपलब्ध दिसत नाही, कृपया स्क्रीन सामायिक करण्यासाठी होस्ट व्हा",
    conference_alert_no_host_aval_doc:
      "याक्षणी कोणतेही होस्ट उपलब्ध दिसत नाही, कृपया दस्तऐवज सामायिक करण्यासाठी होस्ट व्हा",
    conference_alert_host_decline_access: "होस्टने प्रवेश नाकारला",
    conference_unmute_mic_start_talk:
      "बोलणे सुरू करण्यासाठी आपला मायक्रोफोन सशब्द करा",

    // tools	",
    confTools_new_whiteboard: "आपला नवीन व्हाइटबोर्ड येथे येतो",
    confTools_type_text_here: "आपला मजकूर टाइप करा",

    //meetingRecording	",
    meetRec_video_rec_meeting_name: "सत्राच्या नावाचे व्हिडिओ रेकॉर्डिंग",
    //meetingRecording- recordinglistview	",
    recListView_title_name_rec: "रेकॉर्डिंगचे शीर्षक नाव",
    recListView_name_user: "वापरकर्त्याचे नाव ",

    // /////////////////////////////////////////////////////////////////////",
    //Src	",
    //component - common - BrowserUpgrade	",
    brwUpg_req_fun_not_avail:
      "आपल्या ब्राउझरमध्ये आवश्यक कार्यक्षमता उपलब्ध नाही",
    brwUpg_meeting_req_fun_sup:
      "या सत्र सेवेसाठी तुमच्या ब्राउझरद्वारे समर्थित नसलेले कार्यकर्ता आवश्यक आहे.",
    brwUpg_plz_upgrade:
      "कृपया श्रेणीसुधारित करा, भिन्न ब्राउझरवर स्विच करा किंवा आपल्या सेटिंग्ज तपासा. समर्थित ब्राउझर",
    //"    Samsung Internet",
    //component - common - header - header.js	",

    //containers/admin/plans/components/createPlan.js	",
    crtePln_plz_enter_name: "कृपया योजनेचे नाव प्रविष्ट करा",
    crtePln_plz_amount_Plan: "कृपया योजनेची रक्कम प्रविष्ट करा",
    crtePln_plz_enter_des: "कृपया वर्णन प्रविष्ट करा",
    crtePln_Plz_sel_product: "कृपया उत्पादन निवडा",
    crtePln_plz_sel_no_host: "कृपया होस्टची संख्या निवडा",
    crtePln_plz_enter_no_participants: "कृपया सहभागींची संख्या प्रविष्ट करा",
    crtePln_plz_enter_roomno: "खोल्यांची संख्या प्रविष्ट करा",
    crtePln_select_period: "कृपया कालावधी निवडा",
    crtePln_sel_interval: "कृपया मध्यांतर निवडा",
    crtePln_update_succ: "यशस्वीरित्या अद्यतनित केले",
    crtePln_err_creating_plan: "योजना तयार करताना त्रुटी",

    //containers/broadcast/components/BroadcastHandRaise.js	",
    brdcRaise_alert_question_50_char: "आपल्या प्रश्नात किमान 50 वर्ण असावेत",
    //containers/conference/components/components	",
    cofCom_no_part_lobby: "लॉबीमध्ये सहभागी नाही",
    //containers/conference/components/ConfirmUserDetails.js	",
    confmUser_plz_provide_name_email: "कृपया आपले नाव आणि ईमेल प्रदान करा",
    confmUser_notes: "Notes",
    //containers/conference/ConferenceSetup.js 	",
    confSetup_telepresence: "दूरध्वनी",
    confSetup_alert_not_generate_meetingID:
      "सत्र आयडी जनरेट करू शकत नाही, काही वेळानंतर प्रयत्न करा",
    confSetup_auth_part_can_join: "केवळ अधिकृत सहभागी सामील होऊ शकतात",
    confSetup_meeting_notyet_started:
      "हे सत्र अद्याप सुरू झालेले नाही. कृपया नंतर सामील व्हा!. तुम्ही होस्ट असल्यास, कृपया instaVC मध्ये लॉग इन करा आणि मीटिंग सुरू करा",
    confSetup_meeting_locked_byhost: "हे सत्र होस्टद्वारे लॉक केलेले आहे",
    confSetup_meeting_notyet_started_wait_host:
      "हे सत्र अद्याप सुरू झालेले नाही. कृपया सत्र सुरू होण्यासाठी होस्टची प्रतीक्षा करा!",

    //containers/conference/libs/InstaVC.js 	",
    instaVc_server_busy:
      "सर्व्हर व्यस्त आहे असे दिसते! दुसरा सर्व्हर कनेक्ट करण्याचा प्रयत्न करीत आहे",
    //"    load-message",
    instaVc_server_busy_reload_tojoin:
      "सर्व्हर व्यस्त आहे असे दिसते! परिषदेत सामील होण्यासाठी रीलोड करा",
    instaVc_broadcast_scr_failed: "प्रसारण स्क्रीन अयशस्वी",
    instaVc_broadcast_failed: "प्रसारण अयशस्वी",
    instaVc_waiting_for_host: "होस्टच्या व्हिडिओची प्रतीक्षा करत आहे",
    //containers/content/components/contentQuestionnaire/modal-create-quest-group.js 	",
    modlCreate_plz_enter_title: "कृपया शीर्षक प्रविष्ट करा",
    poll_submitted: "मतदान यशस्वीरित्या सबमिट केले.",
    //containers/content/components/contentQuestionnaire/modal-create-poll-question.js	",
    mdlCretPoll_plz_enter_quest: "कृपया प्रश्न प्रविष्ट करा",
    mdlCretPoll_option_should_not_same: "पर्याय एकसारखे नसावेत",
    mdlCretPoll_plz_enter_option: "कृपया पर्याय प्रविष्ट करा",
    mdlCretPoll_plz_select_type_option: "कृपया पर्यायांचा प्रकार निवडा",
    alert_server_error: "अंतर्गत सर्व्हर त्रुटी कृपया नंतर पुन्हा प्रयत्न करा",
    mdlCretPoll_update_ques: "मतदान प्रश्न अद्यतनित करा",
    mdlCretPoll_create_ques: "प्रश्न तयार करा",
    mdlCretPoll_enter_que_here: "आपला प्रश्न येथे प्रविष्ट करा",
    mdlCretPoll_end: "शेवट",
    //containers/content/components/contentQuestionnaire/viewQuestionnaire.js	",
    delete_successfully: "यशस्वीरित्या हटविले",

    //containers/content/components/hozContentNavBlock.js / managecontent-index.js	",
    // "mngContent_mngContent_content" : "Content",
    // "mngContent_mngContent_participants" : "Participants", : सहभागी",
    mngContent_mngContent_fav_prog_lang:
      "आपली आवडती प्रोग्रामिंग भाषा कोणती आहे?",

    //"package_participants" : "Participants", : सहभागी",
    // SOHO",
    //"    SMB 300",
    package_concurrentUser_room2: "20 समकालीन वापरकर्ते - 2 खोल्या",
    package_concurrentUser_room5: "30 समकालीन वापरकर्ते - 5 खोल्या",
    package_concurrentUser_room20: "100 समकालीन वापरकर्ते - 20 खोल्या",
    package_concurrentUser_room30: "200 समकालीन वापरकर्ते - 30 खोल्या",
    package_concurrentUser_room50: "500 समकालीन वापरकर्ते - 50 खोल्या",

    pastMeeting_past_meeting_dtls: "मागील सत्राचे तपशील",
    pastMeeting_duration: "कालावधी",
    pastMeeting_download_parti_atten: "सहभागी आणि उपस्थिती डाउनलोड करा",
    // "pastMeeting_participants" : "Participants", : सहभागी",
    pastMeeting_attendees: "उपस्थिती",
    pastMeeting_no_participants_in_meeting: "या सत्रात कोणतेही सहभागी नाहीत!",
    pastMeeting_no_parti_attended_meeting: "या सत्रात कोणीही सहभागी नव्हते.",
    "pastMeeting_no_guests_were_invited ":
      "या सत्रात आमंत्रित किंवा उपस्थित असलेले कोणतेही अतिथी नव्हते.",
    pastMeeting_delete_all: "सर्व हटवा",
    pastMeeting_no_chat_msg_inmeeting: "या सत्रात कोणतेही चॅट संदेश नाहीत!",
    pastMeeting_no_conver_during_meeting:
      "सत्रादरम्यान गप्पांमध्ये कोणतेही संभाषण झाले नाही.",
    pastMeeting_no_user_inwebinar: "या वेबिनारमध्ये कोणतेही वापरकर्ते नाहीत!",
    pastMeeting_no_user_attand_webinar:
      "या वेबिनारमध्ये उपस्थित असलेले कोणतेही वापरकर्ते नाहीत.",
    pastMeeting_no_chat_msg_inwebinar:
      "या वेबिनारमध्ये कोणतेही गप्पा संदेश नाहीत!",
    pastMeeting_no_conver_during_webinar:
      "वेबिनार दरम्यान चॅटमध्ये कोणतीही संभाषणे नव्हती",
    pastMeeting_del_chat_history: "गप्पा इतिहास हटवा",
    pastMeeting_delete_all_chat_history:
      "आपली खात्री आहे की आपण सर्व चॅट इतिहास कायमचा हटवू इच्छिता?",
    pastMeeting_delete: "हटवा",
    //containers/schedule/components/Schedules.js	",
    schedul_upload_custom_banner:
      "आपल्या वेबिनार इव्हेंटसाठी सानुकूल बॅनर अपलोड करा",
    //containers/schedule/components/SchedulesView.js	",
    schedulView_time: "वेळ",
    schedulView_enable_training_mode: "प्रशिक्षण मोड सक्षम करा",

    //class components",
    //content - components - hozContentNavBlock	",
    // "hozConNav_content" : "Content",
    //scheduleMeeting	",
    scheMeet_room_reserved_from: "पासून खोली आरक्षित",
    scheMeet_meeting_name: "सत्राच्या नावासह",
    //dashboard - component -Contact	",
    contact_alert_already_in_call:
      "आपण आधीपासूनच कॉलमध्ये आलात तेव्हा आपण अन्य वापरकर्त्यास कॉल करु शकत नाही",
    //dashboard - dashboard.js	",
    dashboard_alert_cannot_start:
      "जेव्हा आपण इतर कॉलमध्ये असाल तेव्हा आपण परिषद प्रारंभ करू शकत नाही",
    dashboard_alert_cannot_join:
      "जेव्हा आपण इतर कॉलमध्ये असाल तेव्हा आपण परिषदेत सामील होऊ शकत नाही",
    dashboard_maintenance_msg:
      "कृपया लक्षात घ्या की आम्ही नियमित देखभाल केल्यामुळे 22 एप्रिल 2020 रोजी रात्री 8.30 वाजेपासून 9.00 वा IST पर्यंत सर्व्हर डाउनटाइमचा अनुभव घेत आहोत",
    //coBrowsing	",
    "coBrows_host_share-video": "कृपया थांबा! होस्ट व्हिडिओ सामायिक करणार आहे",
    //Additionalcamera	",

    // genral same lang",
    answer_list: "उत्तरे यादी",
    answer: "उत्तरे",
    answered: "उत्तर दिले",
    correct_answer: "बरोबर उत्तर",
    please_try_again: "कृपया पुन्हा प्रयत्न करा",
    question: "प्रश्न",
    cancel: "रद्द करा",
    questionnaire: "प्रश्नावली",
    view: "पहा",

    // new langs",
    plz_enter_marks: "कृपया प्रश्नाचे गुण प्रविष्ट करा",
    plz_sel_crtans: "कृपया बरोबर उत्तर निवडा",
    truefalse_choice: "सत्य / चुकीची निवड",
    questionnarie: "प्रश्नावली",
    content_title: "सामग्री शीर्षक",
    val_shuld_grtr_grade: "मधील मूल्य ग्रेडपेक्षा जास्त असावे",
    enable_hand_raise: "हात वाढवणे सक्षम करा/वेबिनारमध्ये प्रश्न विचारा",
    enable_waiting_room: "प्रतीक्षालय सक्षम करा",
    allow_only_invite: "केवळ आमंत्रितांना परिषदेत सामील होण्यास परवानगी द्या",
    guest_login_anonymous: "अतिथी अनामिक म्हणून लॉग इन करू शकतात",
    give_name_webinar: "आपल्या वेबिनारला एक नाव द्या",
    video_syn: "व्हिडिओ समक्रमण",
    enable_handraise: "वेबिनारमध्ये हात उंचावणे सक्षम करा",
    //new one venkatesh",
    polls_list: "मतदान यादी",
    no_poll_assign: "अद्याप कोणतेही पोल नियुक्त केलेले नाही!",
    poll_view: "मतदान दृश्य",

    // new Prudhvi",
    select_room: "कृपया एक खोली निवडा",
    provide_event_name: "कृपया कार्यक्रमाचे नाव प्रदान करा",
    end_time_greater_start_time:
      "समाप्तीची वेळ प्रारंभ वेळेपेक्षा मोठी असणे आवश्यक आहे!",
    invite_people_meeting: "या सत्रासाठी लोकांना आमंत्रित करा",
    delete_meeting: "हे सत्र हटवा",
    room: "खोली",
    new_event: "नवीन कार्यक्रम",
    end_repeat: "शेवटची पुनरावृत्ती",
    invite_users_timezone:
      "खालील टाईम झोन असलेल्या वापरकर्त्यांना आमंत्रित करा",
    wrong_password: "चुकीचा गुप्तशब्द",
    college: "कॉलेज",
    university: "विद्यापीठ",
    country: "देश",
    time_period: "कालावधी",
    currently_working_here: "सध्या येथे कार्यरत आहे",
    graduated: "पदवीधर",
    enter_description: "आपले वर्णन येथे प्रविष्ट करा ",
    concentration: "एकाग्रता",
    school: "शाळा",
    poll_question: "मतदान प्रश्न",
    create_poll_ques: "मतदान प्रश्न तयार करा",
    options: "पर्याय",
    no_ques_assigned_yet: "अद्याप कोणतेही प्रश्न नियुक्त केले गेले नाहीत!",
    create_new_ques_click_create_ques:
      "वरील प्रश्न तयार करा बटणावर क्लिक करण्यासाठी नवीन प्रश्न तयार करा",
    enter_room_name: "कृपया खोलीचे नाव प्रविष्ट करा",
    billed_annually: "वार्षिक बिल",
    subscribe_now: "आत्ता सभासद व्हा",
    group: "गट",
    sample_webinar: "नमुना वेबिनार",
    webinar_affiliate: "संबद्ध कंपन्यांविषयी वेबिनार",
    workspace: "कार्यक्षेत्र",
    company: "कंपनी",
    add_another: "आणखी एक जोडा",

    // missing translations, adding english for now, need to convert
    instavc_amount_withdraw: " पैसे काढण्याची रक्कम",
    pastMeeting_notes: "नोट्स",
    assignment: "असाइनमेंट",
    assignments: "असाइनमेंट",
    create_new_poll:
      "असाइन करणे प्रारंभ करण्यासाठी नवीन मतदान प्रश्न तयार करा.",
    plz_title_url: "कृपया शीर्षक आणि url प्रविष्ट करा",
    votes: "मते",
    enter_content_title: "कृपया सामग्रीचे शीर्षक प्रविष्ट करा",
    failed_result: "अयशस्वी परिणाम",
    removed_successfully: "यशस्वीरित्या काढले",
    enter_duration: "कृपया कालावधी प्रविष्ट करा",
    select_questionnarie: "कृपया प्रश्नावली निवडा ",
    no_assignments: "कोणतीही असाइनमेंट नाही",
    create_new_assignment:
      "नवीन असाइनमेंट तयार करा, तयार करण्यासाठी वरील असाइनमेंट बटण तयार करा क्लिक ",
    create_assignment: "असाईनमेंट तयार करा",
    assignments_list: "असाइनमेंट यादी",
    assignment_description: "असाइनमेंट वर्णन",
    assignment_name: "असाइनमेंट नाव",
    update_assignment: "असाइनमेंट अद्यतनित करा",
    add_new_assignment: "नवीन असाइनमेंट जोडा",
    assignment_list: "असाइनमेंट यादी",
    assign_assignments: "असाइनमेंट द्या",
    assigned_assignments_list: "असाइनमेंट सूची",
    assignment_answer: "असाइनमेंट उत्तर",
    no_assig_submitted: "अद्याप कोणतेही असाइनमेंट सबमिट केलेले नाही",
    no_assig_submitted_participants:
      "अद्याप कोणत्याही सहभागींकडून कोणतीही असाइनमेंट सबमिट केलेली नाही",
    view_assignment: "असाइनमेंट पहा",
    assigned_participants: "सहभागी नियुक्त केले",
    select_assignment: "असाइनमेंट निवडा",
    fill_your_assignment: "आपले असाइनमेंट भरा",
    submit_assignment: "असाईनमेंट सबमिट करा",
    assignment_details: "असाइनमेंट तपशील",
    assignment_submit_success: "असाइनमेंट यशस्वीरित्या सबमिट केले",
    assignment_saved_success: "असाइनमेंट यशस्वीरित्या जतन केले",
    how_to_get_started: "प्रारंभ कसा करावा",
    create_new_room: "नवीन खोली तयार करा",
    create_room_add_participants: "एक नवीन खोली तयार करा आणि खोलीत सहभागी जोडा",
    repeats_every: "आमची भेट झाली",
    now: "आता",
    Plz_enter_title_meeting: "कृपया सत्राचे शीर्षक प्रविष्ट करा",
    no_start_time: "प्रारंभ वेळ आढळली नाही",
    no_end_time: "अंतिम वेळ आढळली नाही",
    item_id_not_found: "आयटम आढळला नाही",
    msg_title_not_found: "संदेश शीर्षक आढळले नाही",
    plz_join_conf_clicking_link:
      "कृपया खालील दुव्यावर क्लिक करून परिषदेत सामील व्हा",
    hi_there: "नमस्कार",
    room_permanently: "खोली कायमची?",
    sure_want_to_delete_participants:
      "आपली खात्री आहे की आपण हा सहभागी हटवू इच्छिता?",
    delete_participant: "सहभागी हटवा",
    add_email: "ईमेल जोडा",
    add_participants_to_the_room:
      "खालील इनपुट बॉक्समध्ये सहभागींचा ईमेल पत्ता टाइप करुन या खोलीत सहभागी. ",
    no_of_users: "वापरकर्त्यांची संख्या नाही",
    edit_the_name: "आपण नाव आणि या खोलीचे वापरकर्ते क्रमांक संपादित करू शकता",
    delete_room: "खोली हटवा",
    are_you_sure_delete: "तुम्हाला नक्की डिलीट करायचे आहे का",
    delete_this_room: "ही खोली हटवा",
    delete_room_will_parmanently: "हटवा क्लिक करून, ही खोली कायमची हटविली ",
    enable_storage: "संचयन सक्षम करा",
    enable_recordings: "रेकॉर्डिंग सक्षम करा",
    enable_SIP: "एसआयपी सक्षम करा",
    addons: "अ‍ॅडॉन",
    expires_on: "रोजी कालबाह्य",
    purchased_on: "वर विकत घेतले",
    more_storage: "अधिक संग्रह",
    total_storage: "Tएकूण संचयन",
    storage_occupied: "स्टोरेज व्यापला",
    added: "जोडले",
    open_graphs: "ओपन आलेख",
    participant_controls: "सहभागी नियंत्रणे",
    "dashboard_controls ": "डॅशबोर्ड नियंत्रणे",
    start_meeting: "एक सत्र सुरू करा",
    join_a_meeting: "एका सत्रात सामील व्हा",
    meeting_settings: "मीटिंग सेटिंग्स",
    videos_to_get_started: "प्रारंभ करण्यासाठी व्हिडिओ ",
    if_you_are_host:
      "तुम्ही होस्ट असल्यास, सत्र सुरू करण्यासाठी खालील बटणावर क्लिक करा ",
    guest_link: "अतिथी दुवा",
    pay_now: "आता द्या",
    promo_code_apply_here: "प्रोमो कोड आहे का? येथे अर्ज करा",
    per_month: "दरमहा",
    billed_for: "साठी बिल दिले",
    gst_applicable:
      "शासकीय निकषांचे पालन केल्यानुसार अतिरिक्त 18% जीएसटी भारतातीराहकांना लागू ",
    select_country_code: "देश कोड निवडा",
    country_code: "देश कोड",
    enter_email_id: "ईमेल आयडी प्रविष्ट करा",
    downLoad_chat: "डाऊनलोड चॅट",
    allow_guest_control_their:
      "अतिथीला त्यांचा व्हिडिओ / ऑडिओ नियंत्रित करण्याची परवानगी",
    below_list_people_invited: "खाली आमंत्रित लोकांची यादी आहे",
    verification_code: "सत्यापन कोड",
    open_link_enter_verify_code:
      "खाली असलेला URL दुवा उघडा आणि एकत्रीकरणासाठी आपला सत्यापन कोड प्रविष्ट करा",
    social_media_integration: "सोशल मीडिया एकत्रीकरण",
    integrate_social_media_platform:
      "आपण सोशल मीडिया प्लॅटफॉर्मवर समाकलित करू शकता, एका बटणावर क्लिक करून, आपल्याला सत्यापन कोड मिळेल, तो एकात्मतासाठी वापरा.",
    plz_enter_val_email: "कृपया वैध ईमेल प्रविष्ट करा",
    record: "विक्रम",
    in_conference: "परिषदेत",
    password_if_any: "संकेतशब्द (असल्यास)",
    stop_send: "थांबा आणि पाठवा",
    broadcast_not_enabled_meeting: "या सत्रासाठी प्रसारण सक्षम नाही",
    facebook_url: "फेसबुक यूआरएल",
    enter_facebook_url: "फेसबुक आरटीएमबी यूआरएल प्रविष्ट करा",
    add_facebook_url: "फेसबुक आरटीएमपी यूआरएल जोडा",
    youtube_url: "यूट्यूब यूआरएल",
    enter_youtube_url: "यूट्यूब आरटीएमबी यूआरएल प्रविष्ट करा",
    add_youtube_url: "यूट्यूब आरटीएमपी जोडा",
    register: "नोंदणी करा",
    time_of_program: "कार्यक्रमाची वेळ",
    date_of_program: "कार्यक्रमाची तारीख",
    name_program_interested: "इच्छुक कार्यक्रमाचे नाव",
    email_id: "ई - मेल आयडी",
    dob: "जन्म तारीख",
    applicant_address: "अर्जदाराचा पत्ता",
    qualification: "पात्रता",
    designation: "पदनाम",
    org_name_address: "संस्थेचे नाव व पत्ता",
    fullname_participant: "सहभागींची पूर्ण नावे",
    registration_form: "नोंदणी पत्रक",
    thanks_submitting_data: "आपला डेटा सबमिट केल्याबद्दल धन्यवाद",
    manage_content: "सामग्री व्यवस्थापित करा",
    API_settings: "API सेटिंग्ज",
    schedule_API: "वेळापत्रक API",
    image_upload_success: "प्रतिमा यशस्वीरित्या अपलोड केली",
    less_than_10MB: "कृपया 10MB पेक्षा कमी फाईल अपलोड करा",
    at_time_of_event: "कार्यक्रमाच्या वेळी",
    min_5: "5 मिनिटांपूर्वी",
    min_10: "10 minutes before",
    min_15: "15 मिनिटांपूर्वी",
    min_30: "30 मिनिटांपूर्वी",
    hrs_1: "1 तास आधी",
    hrs_2: "2 तास आधी",
    day_1: "1 दिवस आधी",
    day_2: "2 दिवस आधी",
    jan: "जानेवारी",
    feb: "फेब्रुवारी",
    mar: "मार्च",
    apr: "एप्रिल",
    may: "मे",
    jun: "जून     ",
    jul: "जुलै",
    aug: "ऑगस्ट",
    sep: "सप्टेंबर",
    oct: "ऑक्टोबर",
    nov: "नोव्हेंबर",
    dec: "डिसेंबर",
    mon: "सोमवार",
    tue: "मंगळवार",
    wed: "बुधवार",
    thu: "गुरुवार",
    fri: "शुक्रवार",
    sat: "शनिवार",
    sun: "रविवारी",
    all_day: "संपूर्ण दिवस",
    starts_ddmmyyyy: "प्रारंभ (दिनांक / मिमी / ये)",
    ends_ddmmyyyy: "समाप्त (दि. / मि.मी. / वर्ष)",
    ddmmyyyy: "(दि. / मि.मी. / होय)",
    by_dayweek: "दिवस / आठवडा द्वारे",
    never: "कधीही नाही",
    on_date: "तारखेला...",
    alert: "सतर्क",
    multi_factor_auth: "मल्टी फॅक्टर प्रमाणीकरण (एमएफए) सक्षम करा",
    advanced_settings: "प्रगत सेटिंग्ज",
    verify_Otp: "ओटीपी सत्यापित करा",
    resend_Otp: "ओटीपी पुन्हा पाठवा",
    otp_sent_mobile: "Enter the OTP sent to your mobile number",
    update_mobile: "मोबाइल अद्यतनित करा",
    verify_mobile: "मोबाइल सत्यापित करा",
    mob_verfi_pending: "आपले मोबाइल सत्यापन प्रलंबित आहे",
    mobile_number: "मोबाइल नंबर",
    enter_Otp: "ओटीपी प्रविष्ट करा",
    enter_mob_no: "कृपया मोबाइल नंबर प्रविष्ट करा",
    sure_want_to_delete_rec: "आपणास खात्री आहे की टी 0 रेकॉर्डिंग हटवा",
    delete_recording: "रेकॉर्डिंग हटवा",
    invalid_credentials: "अवैध प्रमाणपत्रे",
    join_conf_by_clicking_link:
      "कृपया खालील दुव्यावर क्लिक करून परिषदेत सामील व्हा",
    hi_there: "नमस्कार",
    valid_room_name: "कृपया वैध खोलीचे नाव प्रविष्ट करा",
    internal_server_error: "अंतर्गत सर्व्हर त्रुटी, कृपया पुन्हा प्रयत्न करा",
    room_limit_exceed: "खोलीची मर्यादा ओलांडली",
    cant_start_meeting_already_goingon:
      "तुम्ही सत्र सुरू करू शकत नाही, कारण आधीच एक सत्र सुरू आहे.",

    instavc_signup_password_error:
      "संकेतशब्द आठ अक्षरे लांब आणि एक अपरकेस, एक लोअरकेस, एक अंक आणि एक विशेष वर्ण असावा ",
    instavc_signup_cpassword_error:
      "पुष्टीकरण संकेतशब्द वरील संकेतशब्दाशी जुळला पाहिजे",
    instavc_meetinglist_schedulecreted: "वेळापत्रक तयार केली",
    instavc_meetinglist_pastschedule: "मागील वेळापत्रक",
    instavc_meetinglist: "सत्रांची यादी",
    instavc_meetinglist_deleterecuring: "आवर्ती वेळापत्रक हटवा",
    instavc_package_specifictions_Whiteboard: "व्हाइटबोर्ड",
    instavc_package_specifictions_Screen: "स्क्रीन शेअर",
    instavc_package_specifictions_nChat: "गप्पा",
    instavc_package_specifictions_Recording: "रेकॉर्डिंग",
    instavc_package_specifictions_PresenterMode: "सादरकर्ता मोड",
    Save: "जतन करा",
    instavc_package_billinginfo_edit: "सुधारणे",
    instavc_package_billingdetails_zip: "झिप",
    instavc_package_shippinginfo: "पाठवण्याची माहिती",
    instavc_package_shippingdetails: "शिपिंग तपशील",
    instavc_package_shippingdetails_zip: "झिप",
    instavc_package_cartsummary: "कार्ट सारांश",
    instavc_package_hostbase: "होस्ट-आधारित परवाना (परवान्याचे नाव)",
    instavc_package_smbplan_basic: "एसएमबी योजना - मूलभूत",
    instavc_package_plandetails: "$ 144,02  आणि 1 वर्ष  n $ 13 दरमहा बिल",
    instavc_package_term: "टर्म",
    instavc_package_hostuser_medium: "1 होस्ट आणि 50 वापरकर्ते",
    instavc_package_month_medium: "$ 15 / महिना",
    instavc_package_bill_medium: "वार्षिक बिल + जीएसटी 18%",
    instavc_package_include_medium: "या पॅकेजमध्ये समाविष्ट आहे",
    instavc_package_specifictions_medium:
      "व्हाइटबोर्ड  स्क्रीन शेअर  चॅट  रेकॉर्डिंग प्रस्तुतकर्ता मोड",
    instavc_package_buynow_medium: "आता खरेदी करा",
    instavc_package_fullfeatures_medium: "संपूर्ण वैशिष्ट्ये",
    instavc_package_advanced: "प्रगत",
    instavc_package_hostuser_advanced: "1 होस्ट आणि 100 वापरकर्ते",
    instavc_package_month_advanced: "$ 16 / महिना",
    instavc_package_bill_advanced: "वार्षिक बिल + जीएसटी 18%",
    instavc_package_include_advanced: "या पॅकेजमध्ये समाविष्ट आहे",
    instavc_package_specifictions_advanced:
      "व्हाइटबोर्ड \n स्क्रीन शेअर \n चॅट \n रेकॉर्डिंग \n प्रस्तुतकर्ता मोड",
    instavc_package_buynow_advanced: "आता खरेदी करा",
    instavc_package_fullfeatures_advanced: "संपूर्ण वैशिष्ट्ये",
    instavc_package_virtualmcu: "व्हर्च्युअल एमसीयू परवाना",
    instavc_package_virtualmcu_room: "(कक्ष आधारित परवाना)",
    instavc_package_silver: "चांदी",
    instavc_package_userrooms_silver_users: "वापरकर्ते",
    instavc_package_userrooms_silver_rooms: "कक्ष",
    instavc_package_month_silver: "$ 281 / महिना",
    instavc_package_bill_silver: "वार्षिक बिल + जीएसटी 18%",
    instavc_package_include_silver: "या पॅकेजमध्ये समाविष्ट आहे",
    instavc_package_specifictions_silver:
      "व्हाइटबोर्ड \n स्क्रीन शेअर \n चॅट \n रेकॉर्डिंग \nप्रस्तुतकर्ता मोड",
    instavc_package_buynow_silver: "आता खरेदी करा",
    instavc_package_fullfeatures_silver: "संपूर्ण वैशिष्ट्ये",
    instavc_package_gold: "सोने",
    instavc_package_userrooms_gold: "200 वापरकर्ते - 30 खोल्या",
    instavc_package_month_gold: "$ 467 / महिना",
    instavc_package_bill_gold: "वार्षिक बिल + जीएसटी 18%",
    instavc_package_include_gold: "Tया पॅकेजमध्ये समाविष्ट आहे",
    instavc_package_specifictions_gold:
      "व्हाइटबोर्ड \n स्क्रीन शेअर \n चॅट \n रेकॉर्डिंग \n प्रस्तुतकर्ता मोड",
    instavc_package_buynow_gold: "आता खरेदी करा",
    instavc_package_fullfeatures_gold: "संपूर्ण वैशिष्ट्ये",
    instavc_package_platinum: "प्लॅटिनम",
    instavc_package_userrooms_platinum: "500 वापरकर्ते - 50 खोल्या",
    instavc_package_month_platinum: "$ 933 / महिना",
    instavc_package_bill_platinum: "वार्षिक बिल + जीएसटी 18%",
    instavc_package_buynow_platinum: "आता खरेदी करा",
    instavc_package_fullfeatures_platinum: "संपूर्ण वैशिष्ट्ये",
    instavc_myprofile_dashboard: "डॅशबोर्ड",
    instavc_myprofile_settings: "सेटिंग्ज",
    instavc_myprofile: "माझे प्रोफाइल",
    instavc_myprofile_officialdetails_position: "स्थिती",
    instavc_myprofile_officialdetails_branch: "शाखा",
    instavc_myprofile_contactinfo: "संपर्क माहिती",
    instavc_myprofile_contactinformation: "संपर्क माहिती",
    instavc_myprofile_disagree: "असहमत",
    instavc_myprofile_agree: "सहमत",
    instavc_myprofile_websitelinks: "वेबसाइट दुवा",
    instavc_myprofile_website_add: "जोडा",
    instavc_myprofile_website: "वेबसाइट",
    instavc_myprofile_sociallinks: "सामाजिक दुवे",
    instavc_myprofile_sociallinks_add: "जोडा",
    instavc_myprofile_sociallink: "सामाजिक दुवे",
    instavc_myprofile_basicinfo: "मुलभूत माहिती",
    instavc_myprofile_basicinfo_add: "जोडा",
    instavc_myprofile_basicinformation: "मुलभूत माहिती",
    instavc_myprofile_basicinformation_disagree: "असहमत",
    instavc_myprofile_basicinformation_agree: "सहमत",
    instavc_myprofile_uploadnewavatar: "नवीन अवतार अपलोड करा",
    instavc_myprofile_cropimage: "क्रॉप प्रतिमा",
    instavc_myprofile_locale: "स्थानिक",
    instavc_myprofile_localesettings: "लोकॅल सेटिंग्ज",
    instavc_myprofile_language: "इंग्रजी",
    instavc_settings: "सेटिंग्ज",
    instavc_admin_defaultroom: "डीफॉल्ट खोली",
    instavc_admin_hostlicense: "होस्ट बेस्ड परवाना",
    instavc_admin_roomlicense: "कक्ष आधारित परवाना",
    instavc_admin_virtualmcu: "व्हर्च्युअल एमसीयू आधारित परवाना",
    instavc_admin_enterprise: "एंटरप्राइझ लायसन्स",
    instavc_mcuserver: "एमसीयू सर्व्हर",
    instavc_room_hostbased: "होस्ट बेस्ड",
    instavc_virtualmcu: "व्हर्च्युअल एमसीयू",
    instavc_rooms_enterprises: "उपक्रम",
    instavc_multiroom: "मल्टी होस्ट / रूम",
    instavc_legacyrooms: "लेगसी रूम",
    instavc_build_anually: "एकदा तयार करा",
    instavc_next_due: "पुढील देय चालू",
    instavc_withdraw_history: "इतिहास मागे घ्या",
    instavc_per_bank_account: "बँक खात्यानुसार",
    instavc_ifsc: "आयएफएससी कोड",
    instavc_pannumber: "पॅन क्रमांक",
    instavc_panexampe: "उदा: बीएनझेडपीएम 2501 जी",
    instavc_paypalfee: "पेपल फी",
    instavc_to: "करण्यासाठी",
    instavc_copylink: "दुवा कॉपी करा",
    instavc_minimum_payout: "किमान पैसे",
    instavc_referral_signup: "रेफरल साइन अप",
    instavc_referral_clicks: "रेफरल क्लिक",
    instavc_open_black_dialog: "काळा संवाद उघडा",
    instavc_open_white_dialog: " पांढरा संवाद उघडा",
    instavc_dail_detail: "डायल करा - तपशील",
    instavc_request_access: "प्रवेश विनंती",
    instavc_inordder_enable: "सक्षम करण्यासाठी",
    instavc_host_permission: "आपल्याला होस्टकडून प्रवेशाची परवानगी आवश्यक आहे",
    instavc_please_wait: "कृपया प्रतीक्षा करा ",
    instavc_host_to_permit: "(होस्ट) ला परवानगी",
    instavc_alternate_content: "Alternative Content",
    instavc_meeting_room: "चे सत्र कक्ष",
    instavc_host_left_conference: "होस्टने संमेलन सोडले आहे!",
    instavc_conf_end: "परिषद आपोआप संपेल",
    instavc_seconds: "सेकंद",
    instavc_host_left: "होस्ट डावे ...",
    instavc_protocal: "प्रोटोकॉल",
    instavc_bitrate: "बिटरेट",
    instavc_host_access: "होस्ट प्रवेश",
    instavc_permit_screenshare: "परवानगी स्क्रीन-सामायिक",
    instavc_allow_access: "व्हाइटबोर्ड प्रवेशास अनुमती द्या",
    instavc_deny: "नाकारणे",
    // "instavc_planid" : "PlanId", : प्लॅनआयडी",
    instavc_host_package: "होस्ट-आधारित पॅकेज",
    instavc_virtualbase_mcu: "आभासी एमसीयू आधारित",
    instavc_plans_product: "योजना / उत्पादने",
    instavc_nodata: "माहिती उपलब्ध नाही",
    instavc_basicplan: "मूलभूत योजना",
    instavc_link: "दुवा",
    instavc_cancel_order: "ऑर्डर रद्द करा",
    instavc_per: "प्रति",
    instavc_user_email: "वापरकर्ता ईमेल",
    instavc_owner: "मालक",
    instavc_user: "वापरकर्ता",
    instavc_default_users: "डीफॉल्ट ऑफर",
    instavc_system_settings: "प्रणाली संयोजना",
    instavc_expires: "Expires",
    instavc_browser_note:
      "आमच्या लक्षात आले आहे की आपण ब्राउझर नाव ची जुनी आवृत्ती वापरत आहात जी आता असमर्थित आहे.",
    instavc_browser_msg:
      "Instavc.com ला ब्राउझर नाव  किंवा इतर कोणत्याही आधुनिक ब्राउझरची अद्ययावत आवृत्ती आवश्यक आहे.",
    instavc_googlechrome: "गुगल क्रोम",
    instavc_gc_version74: "आवृत्ती 74",
    instavc_mfirefox: "मोझिला फायरफॉक्स",
    instavc_mff_version: "आवृत्ती 66",
    instavc_opera: "ऑपेरा",
    instavc_opera_version: "आवृत्ती 60.0+",
    instavc_microsoftedge: "मायक्रोसॉफ्ट एज",
    instavc_ms_version: "आवृत्ती 44+",
    instavc_safari: "ऍपल सफारी",
    instavc_safari_version: "आवृत्ती 12.1",
    instavc_confirmation: "पुष्टीकरण",
    instavc_yes: "होय",
    instavc_os: "ऑपरेटिंग सिस्टम",
    instavc_macos: "मॅक ओएस एक्सप्रेस",
    instavc_chrome_version: "क्रोम आवृत्ती",
    instavc_private_browsing: "खाजगी ब्राउझिंग?",
    instavc_faq_no: "नाही",
    instavc_display_resolution: "इंस्टा व्हीसी प्रदर्शन निराकरण",
    instavc_aspect_ratio: "प्रसर गुणोत्तर प्रदर्शित करा",
    instavc_sys_hasspeakers: "सिस्टममध्ये स्पीकर्स आहेत?",
    instavc_found_speakers: "स्पिकर साधने आढळली: 2",
    instavc_speakers1: "स्पीकर १",
    instavc_speakers2: "स्पीकर 2",
    instavc_sys_have_microphone: "सिस्टममध्ये मायक्रोफोन आहे?",
    instavc_found_microphone: "मायक्रोफोन डिव्हाइस आढळली: 2",
    instavc_microphone1: "मायक्रोफोन 1",
    instavc_microphone2: "मायक्रोफोन 2",
    instavc_has_webcam: "सिस्टममध्ये वेबकॅम आहे?",
    instavc_found_speakers1: "स्पिकर साधने आढळली: 1",
    instavc_camera1: "कॅमेरा 1",
    instavc_browser_allows: "ब्राउझर या पृष्ठावर युजरमाडियाला परवानगी देतो?",
    instavc_change_camera_resolutions:
      "नवीन getUserMedia विनंती केल्याशिवाय आपण कॅमेरा रिझोल्यूशन बदलू शकता?",
    instavc_browser_support_webrtc:
      "ब्राउझर वेबआरटीसी (एकतर 1.0 किंवा 1.1) चे समर्थन करतो?",
    instavc_browser_support_ortc:
      "ब्राउझर ओआरटीसी (वेबआरटीसी 1.1) चे समर्थन करतो?",
    instavc_session_reconnect: "पुन्हा कनेक्ट करा",
    instavc_goto: "जा",
    instavc_request_for_access: "प्रवेशासाठी विनंती",
    instavc_enter_name: "आपले नाव प्रविष्ट करा",
    instavc_confirm: "पुष्टी",
    instavc_ok: "ठीक आहे",
    instavc_askquestion: "प्रश्न विचारा...",
    instavc_recieve: "प्राप्त",
    instavc_delay: "विलंब (कु.)",
    instavc_audio_opus: "ऑडिओ / स्वतंत्र गीतरचना",
    instavc_video_vp8: "व्हिडिओ / व्हीपी 8",
    instavc_share_screen: "शेअर स्क्रीन",
    instavc_prologin: "इंस्टाव्हीसी प्रो लॉगिन",
    commissions: "कमिशन",
    repeat_by: "पुन्हा करा",
    to: "करण्यासाठी",
    asgnQue_Assign_Question: "प्रश्नावली नियुक्त करा",
    asgnQue_assigned_question: "नियुक्त प्रश्नावली",
    //assignQuestList	", : नियुक्त प्रश्नावली",
    mins: "मिनिटे",
    asgQues_no_questions: "प्रश्न नाही!",
    mngGrd_grades: "ग्रेड",
    mngGrd_modify_grades: "श्रेणी सुधारित करा",
    mngGrd_grade_info: "ग्रेड माहिती",
    mngQues_question_details: "ग्रेड माहिती",
    mdlGrp_questionnaire_name: "प्रश्नावली नाव",
    crteContent_media_files: "मीडिया फायली",
    viewCon_enable: "सक्षम करा",
    viewCon_media_files: "मीडिया फायली",
    conRow_by: "द्वाराः",
    create_new_content: "सामग्री तयार करा",
    mngCon_all: "सर्व",
    mngCon_content_list: "सामग्री याद्या",
    mdlUplMedia_upload_media: "मीडिया अपलोड करा",
    mdlUplMedia_upload_url: "URL अपलोड करा",
    mdlUplMedia_Upload_media_system:
      "तुमच्या सिस्टीमवरून उच्च रिझोल्यूशन फाइल्स अपलोड करा, ते .jpg, .png, .jpeg, .mp3, .mp4 ला सपोर्ट करते",
    mdlUplMedia_upload_media_url: "मीडिया URL अपलोड करा",
    mdlUplMedia_upload_youtube_url: "टीप: यूट्यूब यूआरएल अपलोड करा",
    mngContent_grade_settings: "ग्रेड सेटिंग्ज",
    conList_no_content_created: "अद्याप कोणतीही सामग्री तयार केली गेली नाही!",
    grpList_all_content_group: "सर्व सामग्री गट",
    conList_content_list: "सामग्री याद्या",
    showMedia_of: "च्या",
    showMedia_previous: "मागील",
    showQues_min_left: "मिनिट बाकी",
    viewUserScore_GPA_score: "आपले जीपीए स्कोअर:",
    //"scheView_edit_content" : "Edit content", : सामग्री संपादित करा",
    scheView_scheduled_by: "शेड्यूल केलेलेः",
    scheView_delete: "हटवा",
    scheView_download_calander: "कॅलेंडर डाउनलोड करा",
    scheView_settings: "सेटिंग्ज",
    scheView_webinar_event: "वेबिनार इव्हेंट",
    scheView_list_webinar:
      "या वेबिनार इव्हेंटची सूची इन्स्टॅव्हक / वेबिनारवर ठेवा आणि नोंदणी स्वीकारा.",
    scheView_enable_webinar_chat: "वेबिनार गप्पा सक्षम करा",
    scheView_enable_hand_rise: "वेबिनारमध्ये हात उंचावणे सक्षम करा",
    webnrDtls_webinar_details: "वेबिनार तपशील",
    webnrDtls_webinar_list: "वेबिनार सूची",
    webnrDtls_webinar_title: "वेबिनार शीर्षक",
    webnrList_webinar_list: "वेबिनार सूची",
    webnrList_webinar_title_falls: "वेबिनार शीर्षक येथे फॉल्स",
    addBook_address_book: "अ‍ॅड्रेस बुक",
    meetingList_view_content: "सामग्री पहा",
    meetingList_recording: "रेकॉर्डिंग",
    scheInvt_address_book: "अ‍ॅड्रेस बुक",
    scheInvt_host: "होस्टः",
    invitBody_copy: "कॉपी",
    docShare_upload_doc_system_pdf:
      "आपल्या सिस्टमवरून दस्तऐवज अपलोड करा, ते .पीडीएफ, एक्सेल, शब्द दस्तऐवज समर्थन करते",
    docShare_upload_doc: "दस्तऐवज अपलोड करा",
    showDocViewprevious: "मागील",
    borcstScreen_alert_unsupported:
      "असमर्थित प्ले ऑर्डरची विनंती केली. समर्थित स्वरूपात वेबर्टिक आणि एचएलएस आहेत. PlayOrder = webrtc, hls सारखे काहीतरी ",
    borcstScreen_alert_no_stream_spec:
      "कोणताही प्रवाह निर्दिष्ट केलेला नाही. कृपया url मध्ये? Id = {STREAM_ID} जोडा",
    borcstScreen_support_HTML5: "HTML5 व्हिडिओला समर्थन देते",
    broadcast_alert_unsupported:
      "असमर्थित प्ले ऑर्डरची विनंती केली. समर्थित स्वरूपात वेबर्टिक आणि एचएलएस आहेत. ऑर्डर = वेब्रिटीसी, एचएलएस सारखे काहीतरी वापरा",
    broadcast_alert_no_stream_spec:
      "कोणताही प्रवाह निर्दिष्ट केलेला नाही. कृपया जोडा? id = {STREAM_ID}url वर",
    broadcast_user_details: "वापरकर्त्याचा तपशील",
    broadcast_submit_next: "प्रस्तुत करणे",
    broadcast_support_HTML5: "HTML5 व्हिडिओला समर्थन देते",
    brdcstConf_whiteboard: "व्हाइटबोर्ड",
    brdcstConf_screen_share: "स्क्रीन शेअर",
    myMeetItem_for: "च्या साठी",
    myMeetItem_host: "होस्ट",
    //MyMeeting	",",
    roomSet_package: "पॅकेज",
    roomSet_purchased_on: "वर विकत घेतले",
    roomSet_expired_on: "रोजी कालबाह्य",

    //conference - component",   :   घटक",
    //AddSipDevice	", : सिप डिव्हाइस जोडा",
    addSipDev_add_sip_details: "एसआयपी तपशील जोडा",
    addSipDev_sip_address: "एसआयपी पत्ता",
    addSipDev_connect: "कनेक्ट करा",
    addSipDev_enter_sip_address: "एसआयपी पत्ता प्रविष्ट करा",
    //ConfNotification	", : परिषद सूचना",
    confNotf_notification: "अधिसूचना",
    confNotf_user_name: "वापरकर्त्याचे नाव",
    PartList_in_webinar: "वेबिनारमध्ये",
    waitingRoom_chat: "गप्पा",
    waitingRoom_mins: "मिनिटे",
    simulcast_invalid_url: "अवैध url",
    conference_screen_share: "स्क्रीन शेअर",
    conference_chat: "गप्पा",
    conference_lock_conf: "लॉक कॉन्फरन्स",
    conference_content_share: "सामग्री सामायिक करा",
    conference_alert_err_sip_device: "सिप डिव्हाइस कनेक्ट करताना त्रुटी",
    conference_alert_invalid_url: "अवैध url",
    confTools_video_sync: "आपला व्हिडिओ संकालन",
    confTools_microphone: "मायक्रोफोन",
    whiteboard: "व्हाइटबोर्ड",
    meetRec_page_view: "पृष्ठ दृश्य",
    header_content: "सामग्री",
    header_loading: "लोड करीत आहे",
    confSetup_invalid_link: "अवैध दुवा",
    newChat_panel_chat: "पॅनेल चार्ट",
    modlCreate_poll: "मतदान",
    mngContent_mngContent_pollings: "मतदान",
    showQue_obtained_marks: "गुण प्राप्त केले",
    viewUser_your_grade: "आपला ग्रेड",
    package_one_host: "होस्ट आणि",
    pastMeeting_rn: "आर. एन",
    pastMeeting_chat_history_deleted: "गप्पा इतिहास यशस्वीरित्या हटविला",
    pastMeeting_download_webinar: "वेबिनार डाउनलोड करा",
    // "pastMeeting_participants" : "Participants", : सहभागी",",
    pastMeeting_chat_history: "गप्पा इतिहास",
    pastMeeting_recordings: "रेकॉर्डिंग",
    pastMeeting_webinar_user: "वेबिनार वापरकर्ते",
    pastMeeting_webinar_chat: "वेबिनार गप्पा",
    pastMeeting_guest_list: "पाहुण्यांची यादी",
    pastMeeting_no_guest_in_meeting: "या सत्रात कोणतेही अतिथी नाहीत!",
    pastMeeting_meeting_chat_history: "सत्र गप्पा इतिहास",
    pastMeeting_webinar_chat_history: "वेबिनार चॅट इतिहास",
    //containers/schedule/components/Schedules.js	", : कंटेनर / वेळापत्रक / घटक / वेळापत्रक. जे.एस.",
    schedul_webinar_description: "वेबिनार वर्णन",
    schedul_setting: "सेटिंग्ज",
    //containers/schedule/components/SchedulesView.js", : कंटेनर / वेळापत्रक / घटक / वेळापत्रक दृश्य. जे.एस.",
    schedulView_edit: "सुधारणे",
    schedulView_audio_conference: "Audio Conference",
    schedulView_enable_mix_video: "डीफॉल्टनुसार मिक्स व्हिडिओ सक्षम करा",

    contact_alert_user_offline: "वापरकर्ता ऑफलाइन",
    //dashboard - dashboard.js	", ",
    dashboard_quick_start_conf: "द्रुत प्रारंभ परिषद",
    //Additionalcamera	",",
    addCam_add_device: "डिव्हाइस जोडा",

    // genral same lang",",
    content: "सामग्री",
    address_book: "अ‍ॅड्रेस बुक",
    rn: "आर.एन.",

    media_title: "मीडियाटिटेल",
    add_url_add: "URL पत्ता जोडा ...",
    val_shuld_grtr_from_val: "मूल्य व्हॅल्यूपेक्षा जास्त असणे आवश्यक आहे",
    to_val: "मुल्य",
    Webinar: "वेबिनार",
    notepad: "नोटपैड",
    filter_block: "फिल्टर ब्लॉक",
    file_size: "फाईलचा आकार",
    download_ical: "आयकॅल डाउनलोड करा",
    download: "डाउनलोड करा",
    update_event: "कार्यक्रम अद्यतनित करा",
    create_event: "कार्यक्रम तयार करा",
    from: "कडून",
    to: "करण्यासाठी",
    webinar_one: "वेबिनार एक",

    //new
    social_integration: "सामाजिक एकत्रीकरण",
    advanced: "प्रगत",
    add_youtube: "यूट्यूब जोडा",
    plugins: "प्लगइन्स",
    subtitles: "उपशीर्षके",
    view_local: "स्थानिक पहा",
    hide_local: "स्थानिक लपवा",
    switch_conf_mode: "कॉन्फरन्स मोडवर स्विच करा",
    switch_pres_mode: "प्रस्तुतकर्ता मोडवर स्विच करा",
    conference_locked: "कॉन्फरन्स लॉक",
    conference_unlocked: "परिषद अनलॉक केली",
    sharing_tools: "सामायिकरण साधने",
    record: "विक्रम",
    recording: "मुद्रित करणे",
    plz_wait_host_shr_video: "कृपया थांबा! होस्ट व्हिडिओ सामायिक करणार आहे",
    supported_sources_include: "समर्थित स्त्रोतांचा समावेश आहे",

    team_plugins: "कार्यसंघ प्लगइन्स",
    open: "उघडा",
    click: "क्लिक करा",
    more_app: "अधिक अॅप्स",
    upload_custom_app: "सानुकूल अ‍ॅप अपलोड करा",
    download_team_plugin: "टीम प्लगइन डाउनलोड करा",
    install_mng_app_microsoft_team:
      "मायक्रोसॉफ्ट टीममध्ये अॅप कसे स्थापित आणि व्यवस्थापित करावे",
    microsoft_step1: "चरण 1: मायक्रोसॉफ्ट टीम्स उघडा",
    microsoft_step1_para1:
      "प्रारंभ करण्यासाठी, प्रथम आपल्याला या पृष्ठाच्या शीर्षस्थानी उपलब्ध असलेल्या सिस्टमवर टीम प्लगइन डाउनलोड करण्याची आवश्यकता आहे. नंतर आपल्या मायक्रोसॉफ्ट टीम्स उघडा आणि निवडा",
    microsoft_step1_para2:
      " टीम अ‍ॅप्स पाहण्यासाठी साइड नेव्हिगेशन मधील पर्याय.",
    microsoft_step2: "चरण 2: अधिक अॅप्सवर जा",
    microsoft_step2_para1:
      "येथे आपल्याला अधिक अ‍ॅप्स नावाच्या बटणासह काही अ‍ॅप्स आढळू शकतात. यावर क्लिक करा",
    microsoft_step2_para2:
      "पुढील सानुकूल अपलोड पर्याय आणि इतर स्टोअर पर्यायांची तपासणी करण्यासाठी.",
    microsoft_step3: "चरण 3: अ‍ॅप अपलोड करा",
    microsoft_step3_para1: "एकदा आपण स्टोअर उघडल्यानंतर आपल्याला एक सापडेल",
    microsoft_step3_para2:
      "डाव्या सुचालन मध्ये पर्याय. त्यावर क्लिक करा आणि आपले डाउनलोड केलेले प्लगइन अ‍ॅप येथे अपलोड करा.",
    microsoft_step4: "चरण 4: स्टोरेजमधून इंस्टाव्हीसी अॅप निवडा",
    microsoft_step4_para1:
      "जेव्हा विंडो सूचित करेल, तेव्हा आपल्या सिस्टममधून (चरण 1) डाउनलोड केलेले इन्स्टाव्हीसी प्लगइन अॅप निवडा आणि क्लिक करा.",
    microsoft_step5: "चरण 5: मायक्रोसॉफ्ट टीममध्ये अपलोड केलेले अॅप",
    microsoft_step5_para1:
      "फाईल अपलोड केल्यानंतर ती मायक्रोसॉफ्ट टीम अॅप्स लिस्टमध्ये अपलोड होते. त्यानंतर आपण अ‍ॅपवर क्लिक करून ते कार्यसंघांमध्ये जोडू शकता.",
    microsoft_step6: "चरण 6: इंस्टाव्हीसी अॅप उघडा",
    microsoft_step6_para1:
      "एकदा आपण इन्स्टाव्हीसी अ‍ॅपवर क्लिक केल्यास आपण आता बटणासह प्लगइन अॅपची संपूर्ण माहिती पाहू शकता",
    microsoft_step6_para2: "मायक्रोसॉफ्ट टीममध्ये हा अ‍ॅप जोडण्यासाठी बटण",
    microsoft_step7: "चरण 7: इंस्टाव्हीसी मायक्रोसॉफ्ट टीममध्ये जोडले गेले",
    microsoft_step7_para1:
      "आता आपला अ‍ॅप सुलभ आणि सानुकूल करण्यायोग्य वापरासाठी डावीकडील नेव्हिगेशनवरील मायक्रोसॉफ्ट संघात जोडला जाईल.",

    ddyymm: "डीडी / एमएम / वायवाय ",
    fill_details_for_webinar: "कृपया येथे वेबिनारसाठी आपली नोंदणी तपशील भरा",
    microsoft_teams: "मायक्रोसॉफ्ट टीम्स",
    microsoft_outlook: "मायक्रोसॉफ्ट आउटलुक",
    select_the_plan: "कृपया योजना निवडा",
    enter_company_code: "कृपया कंपनी कोड प्रविष्ट करा",
    enter_code: "कृपया कोड प्रविष्ट करा",
    enter_valid_coupon_code: "कृपया वैध कूपन कोड प्रविष्ट करा",
    coupon_alreadt_taken: "हा कूपन कोड आधीच घेतला आहे",
    error_updating_plan: "योजना अद्यतनित करताना त्रुटी",
    unit: "युनिट",
    referrals: "संदर्भ",
    sel_coupon: "कृपया कूपन निवडा",
    share_val_0_99: "भाग मूल्य 0 ते 99 दरम्यान असावे",
    enter_share_val: "कृपया शेअर मूल्य प्रविष्ट करा",
    valid_commission_per: "कृपया वैध कमिशन टक्केवारी प्रविष्ट करा",
    enter_commission_per: "कृपया कमिशन टक्केवारी प्रविष्ट करा",
    enter_commission_name: "कृपया कमिशनचे नाव प्रविष्ट करा ",
    sync_successfully: "वापरकर्ते यशस्वीपणे संकालन करतात",
    room_deleted_suc: "खोली यशस्वीरित्या हटविली	",
    lic_deleted_suc: "परवाना यशस्वीरित्या हटविला",
    female: "स्त्री",
    male: "पुरुष",
    insta_conference: "इंस्टा कॉन्फरन्स",
    quick_meeting_by: "द्वारे जलद सत्र",
    in_lobby: "लॉबी मध्ये",
    switch_to_broadcast: "प्रसारणाकडे स्विच करा",
    Broadcasters_5: "प्रसारक (5)",
    Participants_5: "सहभागी (5)",
    search_participants: "सहभागी शोधा",
    host_controls: "होस्ट नियंत्रणे",
    deleteroom: "खोली हटवा",
    pm: "दुपारी",
    am: "सकाळी",
    email_exist_inroom: "या कक्षात ईमेल आधीपासून विद्यमान आहे",
    type_a_message: "एक संदेश टाइप करा ...",
    please_enter_user_limit: "कृपया वापरकर्त्याची मर्यादा प्रविष्ट करा",
    user_limit_exceeded: "वापरकर्त्याची मर्यादा ओलांडली आहे",
    sel_country_code: "कृपया देशाचा कोड निवडा",
    available_storage: "उपलब्ध संचयन",
    enter_phone_number: "फोन नंबर प्रविष्ट करा",
    startdate_less_enddate: "कृपया शेवटच्या तारखेपेक्षा प्रारंभ तारीख निवडा",
    havent_add_data: "आपण अद्याप कोणताही डेटा जोडला नाही, कृपया डेटा जोडा",
    professional_skills: "व्यावसायिक कौशल्य",
    enter_prof_skills: "व्यावसायिक कौशल्ये प्रविष्ट करा",
    Present_Invitations: "आमंत्रणे सादर करा",
    sending: "पाठवून...",
    sent: "पाठविला",
    invite_10ppl_only: "आपण केवळ 10 लोकांना आमंत्रित करू शकता",
    join_meeting: "सत्रात सामील व्हा",
    enter_doc_title: "दस्तऐवज शीर्षक प्रविष्ट करा",
    meeting_name: "सत्राचे नाव",
    select_the_weeks: "कृपया आठवडे निवडा",
    grade: "ग्रेड",
    coference_ID: "कॉन्फरन्स आयडी ...",
    dont_find_room_meetingid:
      "आम्हाला कोणतीही खोली सापडली नाही, जी या सत्र आयडीशी संबंधित आहे",
    wireless_share: "वायरलेस शेअर",
    video_layout: "व्हिडिओ लेआउट",
    speaker_screen: "स्पीकर स्क्रीन",
    presentation_screen: "सादरीकरण स्क्रीन",
    multiple_display: "एकाधिक प्रदर्शन",
    hellow: "हेलोव",
    enter_passcode: "पासकोड प्रविष्ट करा",
    another_meeting_stillon:
      "दुसरे सत्र अद्याप सुरू आहे, तुम्ही आत्ता हे सत्र सुरू करू शकत नाही",
    SIP_device: "एसआयपी डिव्हाइस",
    instavc_whiteBoard: "इंस्टाव्हीसी व्हाइटबोर्ड",
    speaker: "स्पीकर",
    instavc_notepad: "इंस्टाव्हीसी नोटपॅड",
    promote_in: "मध्ये जाहिरात करा",
    guest: "पाहुणे",
    breakout_rooms: "ब्रेकआऊट रूम",
    stop_broadcast: "प्रसारण थांबवा ",
    noise_suppress: "आवाज दडपशाही",
    echo_cancel: "प्रतिध्वनी रद्द करणे:",
    enter_name_here: "येथे नाव प्रविष्ट करा",
    Viewer: "दर्शक",
    SIP_user: "एसआयपी वापरकर्ता",
    remove_participants: "सहभागी काढा",
    disable_audio_video: "दूरस्थ ऑडिओ आणि व्हिडिओ अक्षम करा",
    disable_audio: "ऑडिओ अक्षम करा",
    enable_audio: "ऑडिओ सक्षम करा",
    disable_video: "व्हिडिओ अक्षम करा",
    enable_video: "व्हिडिओ सक्षम करा",
    audio_video: "ऑडिओ आणि व्हिडिओ",
    audio_only: "ऑडिओ केवळ",
    video_only: "केवळ व्हिडिओ",
    outlook_addins: "आउटलुक अ‍ॅड-इन्स",
    install_microsoft:
      "मायक्रोसॉफ्ट आउटलुकमध्ये अ‍ॅड-इन कसे स्थापित आणि व्यवस्थापित करावे",
    outlook_step1: "चरण 1: दुवा कॉपी करा आणि आउटलुक उघडा",
    first_copy_link: "प्रथम लिंक कॉपी करा",
    add_plugin_oulook: "आपल्या दृष्टीकोनमध्ये प्लगइन जोडण्यासाठी येथून",
    outlook_step2: "चरण 2: अ‍ॅड-इन्स मिळवा",
    outlook_step2_para:
      "आता दृष्टिकोन उघडा आणि मुख्यपृष्ठ टॅब अंतर्गत आपल्याला अ‍ॅड-इन्स मिळवा एक पर्याय सापडेल. अ‍ॅड-इन्स आणि इतर सानुकूल पर्याय पाहण्यासाठी त्यावर क्लिक करा.",
    outlook_step3: "चरण 3: माझे अ‍ॅड-इन्स",
    outlook_step3_para:
      "आपण आता डाव्या नेव्हिगेशनसह अ‍ॅड-इन पृष्ठ पाहू शकता. आपली अ‍ॅड-इन व्यवस्थापित करण्यासाठी माझ्या अ‍ॅड-इन्स वर जा.",
    outlook_step4: "चरण 4: सानुकूल अ‍ॅड-इन्स जोडा",
    outlook_step4_para:
      "माझे अ‍ॅड-इन पृष्ठामध्ये सानुकूल अ‍ॅड-इन अंतर्गत सानुकूल अ‍ॅड-इन ड्रॉपडाउन आपल्याला आढळू शकते. ड्रॉप डाऊनमधून URL वरून जोडा निवडा.",
    outlook_step5: "चरण 5: URL वरून खाजगी अ‍ॅड-इन जोडा",
    outlook_step5_para:
      "आपण आता URL वरून खाजगी अ‍ॅड-इन करण्यास विचारत असलेले पॉप अप पाहू शकता. आता आपण कॉपी केलेला दुवा इनपुट फील्डमध्ये (चरण 1) पेस्ट करा आणि ओके क्लिक करा, ज्यामुळे अ‍ॅड-इन मध्ये दृष्टीकोन स्थापित होईल.",
    outlook_step6: "चरण 6: माझ्या अ‍ॅड-इन्समध्ये इन्स्टाव्हीसी जोडले",
    outlook_step6_para:
      "जोडल्यानंतर, आपण माझ्या माझे अ‍ॅड-इन्स सूचीमध्ये जोडलेले अ‍ॅड चेक करू शकता. येथून आपण आपले अ‍ॅड-इन पुढे व्यवस्थापित करू शकता",
    outlook_step7: "चरण 7: आउटलुक बंद करा आणि पुन्हा उघडा",
    outlook_step7_para:
      "स्थापित केल्यानंतर, आपण एकदा पूर्ण दृष्टीकोन बंद केला असल्याचे सुनिश्चित करा आणि अ‍ॅड-इन पाहण्यासाठी पुन्हा उघडले.",
    outlook_step8: "चरण 8: नवीन आयटमवर जा",
    outlook_step8_para:
      "दृष्टिकोन उघडल्यानंतर, आपण आता इंस्टाव्हीसीच्या दृष्टिकोनमध्ये जोडलेले पाहण्यासाठी नवीन मीटिंग मीटिंगला जाऊ शकता.",
    outlook_step9: "चरण 9: इंस्टाव्हीसी बैठक उघडा",
    outlook_step9_para:
      "एकदा आपण मीटिंग्ज उघडल्यानंतर आपल्यास मीटिंग्ज टॅब अंतर्गत वरच्या पट्टीमध्ये इंस्टाव्हीसी मीटिंग addड-इन सक्षम केलेल्या कम्पोज मेल विंडोसह उघडले जाईल.",
    outlook_step10: "चरण 10: वेळापत्रक तयार करा",
    outlook_step10_para:
      "कम्पोझ मेल लेआउट वरून, नवीन शेड्यूल तयार करण्यासाठी इन्स्टाव्हक मीटिंग्जवर क्लिक करा. पहिल्यांदाच इन्स्टाव्हीसी मीटिंग लॉगिन बरोबर उजवीकडे असेल. आधीपासून लॉग इन केलेल्या वापरकर्त्यांसाठी, त्यांना खोल्यांच्या सूचीत निर्देशित केले जाईल आणि वेळापत्रक तयार केले जाईल.",
    outlook_step11: "चरण 11: इंस्टाव्हीसी बैठक उघडा",
    outlook_step11_para:
      "आपण डाव्या बाजूस वेळापत्रक तयार करू शकता आणि विशिष्ट खोलीत बैठकीचे वेळापत्रक तयार करण्यासाठी उजवीकडील एक खोली निवडू शकता. एकदा आपण वेळापत्रक तयार केल्यास, आपण आता प्रारंभ बैठक प्रारंभ करू शकता. येथून आपण बैठक क्लिक करू शकता आणि प्रारंभ करू शकता.",
    outlook_step12: "चरण 12: दिनदर्शिकेत वेळापत्रक पहा",
    outlook_step12_para:
      "एकदा आपण वेळापत्रक तयार केले, पुढच्या वेळी आपण कॅलेंडर उघडता तेव्हा आपण आपली वेळापत्रक दिनदर्शिकेमध्ये देखील पाहू शकता.",
    outlook_step13: "चरण 13: वेळापत्रक तयार केले",
    outlook_step13_para:
      "एकदा आपण वेळापत्रक तयार केल्यावर आपण नंतर तयार केलेल्या मेलसह उजव्या बाजूस प्रारंभ बैठक बटन देखील पाहू शकता.",
    sel_declaration: "कृपया घोषणा निवडा",
    enter_company_code: "कृपया कंपनी कोड प्रविष्ट करा",
    invalid_company_code: "अवैध कंपनी कोड",
    affiliate_acc: "आपले संबद्ध खाते मंजूरीसाठी प्रलंबित आहे",
    aff_acc_approved: "आपले संबद्ध खाते मंजूर झाले आहे",
    aff_acc_rej: "आपले संबद्ध खाते नाकारले आहे",
    aff_TC: "संबद्ध अटी व शर्ती",
    ref_par_agreement: "रेफरल पार्टनर एग्रीमेंट",
    aff_partner_agreement:
      'हे कव्हर पेज आणि संलग्न व्यवसाय अटींचा समावेश असलेला हा भागीदार करार (एकत्रितपणे, हा "करार") पीपललिंक युनिफाइड कम्युनिकेशन्स प्रायव्हेट लिमिटेड (पीपललिंक म्हणून ओळखला जाणारा) आणि "पार्टनर" किंवा "आपण" यांच्याद्वारे बनविला गेला आहे . "भागीदार" किंवा "आपण" म्हणजे सबमिट केलेल्या फॉर्ममध्ये तपशीलवार व्यक्ती किंवा कंपनी (कंपनीचे नाव आणि इतर माहितीसह). एकदा आपण या कराराची आपली स्वीकृती दर्शविण्यासाठी आपण रेफरल पार्टनर प्रोग्राम फॉर्म ("फॉर्म") सबमिट करुन सबमिट केल्यावर करार अनिवार्य होईल. पीपलीलिंक आणि पार्टनरला कधीकधी "पार्टी" आणि एकत्रितपणे "पक्ष" म्हणून संबोधले जाते.',
    background: "पार्श्वभूमी",
    aff_market_advertise:
      'पीपलीलिंक इंस्टाव्हीसी युनिफाइड संप्रेषण सेवा आणि समाधानाची ऑफर देते. या कराराच्या अनुसार, पीपीलिंक उत्पादनांची जाहिरात आणि संभाव्य पीपलिंक ग्राहकांना ("संदर्भ") आणि त्यांच्या कराराच्या निराकरणाद्वारे निराकरण करण्याच्या भागीदाराची इच्छा आहे.',
    agreement: "करार",
    aff_parties_agree: "पक्ष पुढीलप्रमाणे सहमत आहेतः",
    heading1: "कार्यक्रम समिती",
    heading2: "पात्र संदर्भ, समिती",
    heading3: "मुदत व नियम",
    heading4: "सामान्य",
    the_program: "कार्यक्रम.",
    to_participate_program_partner:
      'प्रोग्राममध्ये भाग घेण्यासाठी पार्टनरने पीपललिंक किंवा त्याच्याशी संबंधित वेबसाइट्स ("साइट") वर आढळलेल्या प्रोग्राममध्ये सहभागासाठी ऑनलाइन अर्ज पूर्ण केला पाहिजे आणि हा करार प्रविष्ट केला पाहिजे. पीपलीलिंक कोणताही अर्ज आपल्या विवेकबुद्धीनुसार स्वीकारू किंवा नाकारू शकेल.',
    aff_str11: "कायदेशीर करार",
    aff_str12: "जाहिरात, संदर्भित क्रियाकलाप:",
    aff_str13: "प्रतिबंधित क्रियाकलाप",
    aff_str14: "पीपलीलिंक गुणांचा परवानगीयोग्य वापर",
    aff_str15: "उत्तरदायित्व",
    aff_str16: "ग्राहक संबंध",
    aff_str11_para:
      "प्रोग्राममधील सहभागाच्या भागाच्या रूपात आणि पीपलीलिंकचे भागीदार म्हणून काम करण्यासाठी भागीदार याद्वारे या कराराच्या अटी आणि प्रोग्राम, मार्गदर्शक तत्त्वे आणि पीटरलिंकने वेळोवेळी निश्चित केलेल्या कोणत्याही विनंत्या आणि नियमांना मान्य करतो आणि त्यास मान्यता देतो प्रोग्रामरमध्ये भागीदारांच्या सध्या सुरू असलेल्या सहभागासंदर्भात आणि पीपलीलिंक उत्पादनांची जाहिरात, सोल्युशन्स आणि रेफरल्सची सेवा. या कराराअंतर्गत असलेल्या त्याच्या सर्व क्रियाकलापांमध्ये आणि भागीदाराच्या पीपललिंकच्या जाहिरातींशी संबंधित अशा विशिष्ट क्रियाकलापांमध्ये, भागीदार पीपलिंकला सहकार्य करेल आणि चांगल्या श्रद्धेने कार्य करेल. हा करार प्रविष्ट करून भागीदार पुढे पीपललिंकच्या सेवा अटींमध्ये सेट केलेल्या नियम व नियम ओळखतो आणि स्वीकारतो",
    aff_str12_para:
      "भागीदार परवानाधारक गुण आणि विपणन साहित्य वापरुन विविध विपणन चॅनेलमध्ये पीपलिंक उत्पादने आणि सोल्यूशन्सच्या निरंतर, सक्रिय पदोन्नतीमध्ये गुंतण्यास सहमत आहे आणि या कराराच्या अटींचे पालन करीत असे करतो.",
    aff_str13_para:
      'भागीदार विपणन सामग्रीस कोणत्याही प्रकारे बेकायदेशीर असणारी सामग्री किंवा किंवा अन्यथा हानिकारक, धमकी, बदनामीकारक, अश्लिल, आक्षेपार्ह, त्रास देणारी, लैंगिकरित्या सुस्पष्ट, हिंसक, भेदभाव करणारी किंवा अन्यथा आक्षेपार्ह असलेल्या पीपलिंकच्या विवेकबुद्धीने संबद्ध करण्यास सहमत आहे. भागीदार पीपलिंक सेवा आणि समाधानास प्रोत्साहित करण्यासाठी एकाधिक असंबंधित प्राप्तकर्त्यांना ("स्पॅमिंग") अवांछित इलेक्ट्रॉनिक संदेश न पाठविण्यास सहमत आहे किंवा अन्यथा या कराराअंतर्गत विचार केलेल्या क्रियांच्या संदर्भात कायद्याने प्रतिबंधित कोणत्याही प्रकारचे इलेक्ट्रॉनिक संप्रेषणांमध्ये व्यस्त राहण्यास सहमत नाही.',
    aff_str14_para1:
      "परवानाधारक गुणांचा वापर करून आणि विपणन साहित्य तयार करण्यात यासह सर्व अटींचे पालन करण्यास भागीदार स्पष्टपणे सहमत आहे.",
    aff_str14_para2:
      "मार्गदर्शकतत्त्वांद्वारे आणि अन्यथा, पॉपलिंक मार्केटिंग मटेरियल तयार करण्यास आणि पीपलिंक सेवेला प्रोत्साहन देण्यासाठी परवानाधारक गुणांचा भागीदार परवानगीनुसार वेळोवेळी वैशिष्ट्य आणि इतर सूचना प्रदान करेल. भागीदार पुढे अशी सर्व वैशिष्ट्ये आणि सूचनांचे पालन करण्यास सहमत आहे",
    aff_str14_para3:
      "भागीदाराने हे सुनिश्चित केले पाहिजे की त्याच्या विपणन साहित्यावर दिसणारे सर्व परवानेकृत मार्गदर्शक पीपललिंकने मार्गदर्शकतत्त्वांमध्ये मंजूर केलेल्या फॉर्ममध्ये आहेत किंवा अन्यथा, कोणत्याही पीपलीलिंक मार्क्समध्ये सुधारणा करू शकत नाही किंवा अन्य मार्केटिंग मटेरियलमध्ये लोकलिंकद्वारे प्रदान केलेल्या वाजवी सूचनांच्या विरोधात लक्षणीय ब दल करू नये आणि पुढे त्याचे पालन केले जाईल. विपणन सामग्रीचे फॉर्म, सामग्री आणि प्रदर्शन या संदर्भात पीपललिंककडून वाजवी सूचनांसह. कोणत्याही कारणास्तव या कराराची समाप्ती झाल्यावर किंवा पीपलीलिंकच्या लेखी विनंतीवरून, येथे देण्यात आलेला परवाना कालबाह्य होईल आणि भागीदार त्वरित या कराराअंतर्गत सर्व क्रियाकलाप बंद करेल. ",
    aff_str15_para:
      "या कराराच्या अंतर्गत कार्य करण्याच्या भागीदारांवर पूर्णपणे जबाबदार असेल, या कराराच्या संबंधात तयार केलेल्या आणि वापरलेल्या भागीदाराच्या ऑपरेशन्स आणि सामग्रीची मर्यादा न घालता. पीपलीलिंक मार्क तृतीय पक्षाच्या ट्रेडमार्क अधिकारांचा भंग करतो असा आरोप करणार्‍या दाव्याशिवाय, पॉपलिंक भागीदारांच्या विपणन सामग्रीच्या विकास, ऑपरेशन किंवा सामग्रीसाठी जबाबदार नाही आणि भागीदार पीपललिंकच्या कोणत्याही दाव्यांस, कृती, कारणाविरूद्ध हानी पोहोचवू शकत नाही. भागीदारांच्या विपणन साहित्याचा विकास, ऑपरेशन, सामग्री आणि देखभाल संबंधित कारवाई, नुकसान किंवा खर्च (मुखत्यार शुल्कासह).",
    aff_str16_para:
      "टर्म दरम्यान आणि त्या नंतर, पीपलिंक सेवा, पीपलिंक सेवेच्या वापरासाठी पीटरलिंक कराराचा संदर्भ देणारी कोणतीही आणि सर्व माहिती यासह पीपलिंक आणि रेफरल्समधील भागीदारांद्वारे तयार केलेल्या सर्व संबंधांचे एकमेव मालक असतील. पीपलिंक सेवेसाठी अटी, गोपनीयता धोरण आणि पीपललिंकचे नियम आणि कार्यपद्धती या रेफरल्सवर लागू होतील आणि पार्टनरला पूर्व सूचना न देता पीपली लिंकद्वारे बदलले जाऊ शकतात आणि भागीदार अटींनुसार पीपलिंकशी त्यांचे संबंधांचे स्वरूप संदर्भित करण्यास सहमती देतात.",
    aff_str20_para1:
      "जोडीदाराने पीपलिंकला संदर्भित केले आहे आणि जे खाली कलम 3 (बी) मध्ये वर्णन केलेल्या प्रक्रियेनुसार साइन-अप प्रक्रिया पूर्ण करतात;",
    aff_str20_para2:
      "पॉपलिंक सेवेच्या संबंधात पीपललिंकचा कोणताही रेकॉर्ड नाही किंवा जो जोडीदाराने पीपललिंकशी संबंधीत कोणत्याही करारासंबंधात किंवा पीपलीलिंक सेवेच्या संदर्भात चालू असलेल्या वाटाघाटींमधले नाही.",
    aff_str20_para3:
      "जे अटी स्वीकारतात आणि रेफरलच्या स्वतःच्या निर्णयावर अवलंबून असतात आणि भागीदाराकडून कोणतीही आर्थिक किंवा इतर प्रोत्साहन न घेता, पीपलिंक वेबसाइटवर सूचीबद्ध केलेल्या कोणत्याही पब्लिकलिंक सेवा योजनेच्या बंडलची किमान वार्षिक सदस्यता किंवा अन्यथा (iv) ज्यांना नाकारले जात नाही पीपलीलिंक सेवा प्राप्त करण्यासाठी किमान एक पेमेंट (वार्षिक प्रीपे) किंवा तीन पेमेंट (वार्षिक मुदत, मासिक बिलिंग) करा.",
    aff_str21: "संदर्भ प्रक्रिया.",
    aff_str22: "कमिशन. जबाबदा .्या.",
    aff_str221: "संदर्भ शुल्क",
    aff_str222: "रेफरल कडून चालू विक्री",
    aff_str223: "संबंधित शुल्क",
    aff_str23: "विक्री / कमिशन अहवाल.",
    aff_str21_para:
      "प्रत्येक रेफरलला पीपलीलिंकला जोडीदारास पीपीलिंकने दिलेल्या ऑनलाइन url च्या माध्यमातून पीटरलिंकचा संदर्भ दिला जाईल. विक्री प्रक्रियेस रेफरलमध्ये प्रोत्साहन देण्यासाठी पक्षांकडून सुरू असलेल्या सद्भावना सहकार्यास अधीन असलेल्या, पीपलीलिंक सर्व रेफरल्सच्या विक्री प्रक्रियेस जबाबदार असतील.",
    aff_str22_para:
      "पीपलीलिंक रेफरल्स वरून सर्व फील्स थेट पीटरलिंक सेवेसाठी रेफरल्सकडून गोळा करतात.",
    aff_str22_para1:
      "अर्हताप्राप्त रेफरल बनल्यानंतर, पीपली लिंक येथे असलेल्या सूचीबद्ध फीच्या आधारे थकबाकीमध्ये भागीदार रेफरल फी भरेल.",
    aff_str22_para12:
      "(कोणत्याही सूट वगळता) पात्र रेफरलद्वारे देय अशा रेफरल फी देय होतील आणि सशुल्क सेवा प्रारंभ तारखेच्या मंजूर तारखेच्या पूर्ततेच्या तारखेनंतर अंदाजे (<जोडा) नव्वद  दिवसात जोडीदारास दिले जाईल.",
    aff_str22_para2:
      "- सुरुवातीच्या संदर्भात सादर केल्याच्या तारखेच्या पहिल्या days ० दिवसांच्या आत होणार्‍या अर्हता रेफरलकडून अतिरिक्त विक्रीसाठी भागीदारास रेफरल फी प्राप्त होईल.",
    aff_str22_para3:
      " सर्व कर, कर्तव्ये, सरकारी शुल्क आणि रेफरल शुल्कावरील आकारण्यासारख्या शुल्काची भरपाई करण्यासाठी भागीदार जबाबदार असेल आणि भागीदार पीपलीलिंकच्या देयकामुळे उद्भवलेल्या किंवा कोणत्याही शुल्काशी संबंधित असलेल्या कोणत्याही दाव्यांविरूद्ध आणि विरोधात पब्लिकलिंकला हानीकारक नाही संदर्भ शुल्क",
    aff_str23_para:
      "पीपलिंक त्यांच्या ऑनलाइन डॅशबोर्ड अहवालात भागीदार आणि रेफरल्समधून घेतलेल्या अर्हता संदर्भित कमिशनच्या कमिशनच्या विक्री कार्याचा सारांश देईल. पीपरीलिंक रेफरल्स आणि अर्हताप्राप्त संदर्भांविषयी नावे किंवा इतर वैयक्तिक माहिती उघड करणार नाही.",
    aff_str31: "प्रारंभिक टर्म",
    aff_str32: "नूतनीकरण मुदत.",
    aff_str33: "लवकर समाप्ती. कारण न.",
    aff_str34: "कारणांसाठी",
    aff_str35: "समाप्तीचा प्रभाव.",
    aff_str31_para:
      'हा करार प्रभावी तारखेपासून प्रभावी होईल आणि त्यानंतर बारा (12) महिने ("आरंभिक मुदत") चालू राहील, जोपर्यंत पीपलिंकने भागीदारांच्या कार्यक्रमास भाग घेण्यासाठी नकार दर्शविला नाही.',
    aff_str32_para:
      "आरंभिक मुदतीची मुदत संपल्यानंतर, हा करार अन्य पक्षाला कमीतकमी तीस (30०) समाप्तीची लेखी सूचना न दिल्यास बारा (१२) महिन्यांच्या (प्रत्येक नूतनीकरण मुदत) अतिरिक्त सलग अटींसाठी आपोआप नूतनीकरण होईल. ) आरंभिक मुदत किंवा कोणत्याही नूतनीकरण मुदतीच्या समाप्तीच्या अगोदरचे दिवस.",
    aff_str33_para:
      "पॉपलिंकला भागीदारला पाच (5) दिवस आधीची लेखी सूचना देऊन कोणत्याही वेळी किंवा कोणत्याही कारणाने हा करार संपुष्टात आणण्याचा अधिकार आहे.",
    aff_str34_para:
      " एकतर पक्ष हा करार कधीही रद्द करू शकेल, ज्याने या कराराचा भौतिकपणे उल्लंघन केला असेल अशा पक्षाला लिखित सूचनेनंतर त्वरित प्रभावीपणे प्रदान केले जाईल की हा करार संपुष्टात येण्यापूर्वी टर्मिनेशन पार्टी अशा सामग्री उल्लंघनाची लेखी सूचना आणि तीस ()०) दिवसांनंतर प्रदान करेल उल्लंघन करणा्या पक्षाला अशा उल्लंघनाची चिकित्सा करण्याची संधी.",
    aff_str35_para:
      "या कराराच्या समाप्तीच्या तारखेपासून आणि त्यानंतर या कराराअंतर्गत भागीदाराचे हक्क संपुष्टात येतील आणि भागीदारास या कराराच्या समाप्तीपूर्वी मिळविलेल्या किंवा मिळवलेल्या कमिशन किंवा पेमेंट्स व्यतिरिक्त या करारा अंतर्गत कोणतेही रेफरल फी किंवा इतर कोणत्याही देयके मिळण्याचा हक्क असणार नाही. .",
    aff_str41: "असाइनमेंट",
    aff_str42: "बौद्धिक मालमत्ता अधिकार.",
    aff_str43: "माफी नाही",
    aff_str44: "मर्यादित हमी",
    aff_str45: "वॉरंटीचा अस्वीकरण",
    aff_str46: "दायित्वाची मर्यादा.",
    aff_str47: "स्वतंत्र कंत्राटदार",
    aff_str48: "नुकसान भरपाई",
    aff_str49: "मजूर सक्ती करा",
    aff_str410: "संपूर्ण करार; तीव्रता.",
    aff_str411: "काउंटरपार्ट्स; सूचना",
    aff_str412: "शासित कायदा; कार्यक्षेत्र; वाद निराकरण.",
    aff_str41_para:
      "पीपललिंक कधीही हा करार सोपवू शकते. भागीदार हा करार पीपललिंकच्या पूर्व लिखित संमतीशिवाय नियुक्त करू शकत नाही किंवा हस्तांतरित करू शकत नाही, अशी संमती अनावश्यकपणे रोखली जाऊ नये.",
    aff_str42_para:
      "पीपलीलिंक मार्क्समधील सर्व बौद्धिक मालमत्ता अधिकार (जसे की ट्रेडमार्क, ट्रेड नावे, लोगो, पेटंट्स, कॉपीराइट्स, डोमेन नावे आणि डेरिव्हेटिव्ह हक्का) पीपलीलिंक आणि त्याच्या सहाय्यक कंपन्यांची अनन्य मालमत्ता राहील. परवानाधारक गुण वापरण्याचा जोडीदाराचा हक्क पीपललिंकच्या निर्णयावर अवलंबून आहे आणि या कराराच्या अटी, मार्गदर्शक तत्त्वे आणि सर्व लागू कायद्यांचे आणि नियमांचे भागीदाराच्या पालनाच्या अधीन आहे. भागीदार सहमत आहे की (अ) या कराराचा भंग करण्याच्या योग्यतेने कोणताही पीपललिंक आयपी अधिकार वापरू नये; (ब) कोणत्याही पीपलीलिंक आयपी हक्कांवर लढा देण्यासाठी किंवा हानीकारक काहीही करू   नका; (सी) कोणत्याही पीपललिंक आयपी हक्कांशी संबंधित असलेल्या बौद्धिक मालमत्तेचे हक्क (जसे की ट्रेडमार्क, ट्रेड नावे, लोगो, पेटंट्स, कॉपीराइट्स, डोमेन नावे आणि डेरिव्हेटिव्ह हक्क मर्यादित नसलेले) तयार किंवा प्राप्त करू नका); (ड) ज्या भागीदारास वास्तविक ज्ञान आहे अशा कोणत्याही पीपलीलिंक आयपी अधिकारांच्या कोणत्याही अनधिकृत वापराबद्दल त्वरित पीपल लिंकला सूचित करा; आणि (इ) मार्गदर्शक तत्त्वांचे पालन करण्यासाठी नेहमीच परवानाकृत चिन्ह आणि इतर कोणत्याही पीपल लिंकचा वापर करा. पीपलिंक भागीदारांद्वारे सादर केलेल्या कोणत्याही विपणन साहित्याचे नियमितपणे पुनरावलोकन करू शकते आणि भागीदाराने सादर केलेल्या कोणत्याही विपणन सामग्री काढून टाकण्याचे आणि / किंवा दुरुस्ती करण्याचे आदेश देण्याचे विशेष अधिकार व विवेकबुद्धी असेल.",
    aff_str43_para:
      "या कराराच्या कोणत्याही तरतूदीची दुसर्‍या पक्षाच्या कठोर कामगिरीची अंमलबजावणी करण्यात पक्षाचे अपयश, त्यानंतर अशा प्रकारच्या तरतूदी किंवा या कराराच्या कोणत्याही अन्य तरतूदीची अंमलबजावणी करण्याच्या पहिल्या पक्षाच्या अधिकारास माफ करणार नाही. ",
    aff_str44_para:
      "दोन्ही पक्षांनी हमी दिली आहे की या टर्म दरम्यान ते नेहमीच सर्व लागू कायदे, नियम, सराव संहिता तसेच या कराराच्या अटी, गोपनीयता धोरण आणि मार्गदर्शक तत्त्वांचे पालन करतात. मुदतीच्या दरम्यान आणि कोणत्याही कारणास्तव संपुष्टात आल्यानंतर, भागीदार स्पष्टपणे असे कोणतेही कार्य करत नाही जे पीपलिंकच्या व्यवसायाचे, हितसंबंधांना किंवा प्रतिष्ठाला हानी पोहचेल अशी अपेक्षा असेल आणि कोणतेही विवादास्पद टिप्पणी करणार, प्रकाशित किंवा परवानगी देणार नाही पीपलीलिंक, त्याचे प्रतिनिधी किंवा पीपललिंक सेवेबद्दल.",
    aff_str45_para:
      "मागील उपकलम (ई) अंतर्गत पीपल्सलिंकची एक्स्प्रेस वॉरंटी व्यतिरिक्त, पीपलीलिंक कोणत्याही प्रकारचे हमी, व्यक्त किंवा सूचित केलेले नाही उद्देश, उपलब्धता, सुरक्षा, शीर्षक आणि / किंवा या कराराच्या विषयाचे उल्लंघन न करणे.",
    aff_str46_para:
      "पीपीलिंक किंवा कोणताही अधिकारी, कर्मचारी, दिग्दर्शक किंवा पीपललिंकचा कोणताही अन्य प्रतिनिधी या कराराच्या किंवा तिच्या समाप्तीच्या अंतर्गत किंवा करारानुसार, करारात, प्री-कॉन्ट्रॅक्टमध्ये, अत्याचाराने किंवा अन्यथा भागीदार किंवा कोणत्याही तृतीय पक्षाकडे जबाबदार असेल (i ) कोणतेही आर्थिक नुकसान (महसूल, नफा, करार, व्यवसाय किंवा अपेक्षित बचतीसह) किंवा (ii) सद्भावना किंवा प्रतिष्ठा कमी होणे. अशा नुकसानामध्ये मर्यादा न ठेवता कोणतीही विशेष, अप्रत्यक्ष, प्रासंगिक, वैधानिक, दंडात्मक किंवा परिणामी नुकसान किंवा हानी तसेच ऑपरेशनच्या व्यत्ययामुळे होणारे कोणतेही नुकसान किंवा नुकसान यांचा समावेश आहे. या कराराअंतर्गत भागीदारांकडे कोणत्याही अन्य परिस्थितीत किंवा संबंधांबद्दलचे समजून घेताही, पीपीलिंकचे या कराराअंतर्गत भागीदाराचे संपूर्ण उत्तरदायित्व या कराराअंतर्गत भागीदाराने केलेल्या कोणत्याही प्रकारच्या नुकसानीसंदर्भातील कोणत्याही दाव्यांसाठी आणि फक्त भारतीय रुपयांपेक्षा जास्त नसावे. हा करार प्रविष्ट करून भागीदार पीपललिंकच्या दायित्वातील मर्यादा ओळखतो. ",
    aff_str47_para:
      "यामध्ये पक्ष स्वतंत्र कंत्राटदार म्हणून त्यांच्या वतीने कार्य करतात. या करारामधील काहीही संयुक्त करार, एजन्सी, फ्रेंचायझी, विक्री प्रतिनिधी, रोजगार किंवा या करारामध्ये नमूद केलेल्या संबंधांच्या पलीकडे पक्षांमधील कोणतेही इतर संबंध तयार करू शकत नाही आणि भागीदार स्पष्टपणे पीपललिंकच्या वतीने कार्य करण्यास प्रतिबंधित आहे. या करारा अंतर्गत परवानाधारक गुणांचे भागीदार प्रदर्शन, जोडीदाराने सादर केलेली इतर सामग्री किंवा भागीदार आणि तृतीय पक्षामधील संपर्क येथे वर्णन केलेल्या संबंधांचे चुकीचे वर्णन करु शकत नाही. ",
    aff_str48_para:
      'भागीदार कोणत्याही प्रकारच्या परिणामी, कोणत्याही जबाबदा li्या, दायित्वे, तोटे आणि खर्चास (वाजवी वकिलांच्या शुल्कासहित परंतु मर्यादित नाही) कोणत्याही हानीकारक नसल्यास, पीपलिंक आणि त्याच्या सहाय्यक कंपन्या, संबद्ध कंपन्या, अधिकारी आणि कर्मचारी ("पीपलीलिंक इंडेम्फाइड पार्टीज") नुकसान भरपाई, संरक्षण आणि धरून ठेवेल. पुढीलपैकी कोणाकडून उद्भवलेल्या पीपलीलिंक क्षतिग्रस्त पक्षांविरूद्ध कोणत्याही तृतीय पक्षाद्वारे दावा, खटला, कारवाई, मागणी किंवा कार्यवाही: (i) जोडीदाराने केलेल्या कराराचा भंग; (ii) भागीदार किंवा त्याचे कर्मचारी, एजंट किंवा कंत्राटदार यांचे दुर्लक्ष, घोर दुर्लक्ष किंवा हेतूपुरस्सर गैरवर्तन; किंवा (iii) भागीदार किंवा त्याचे कर्मचारी, एजंट्स, कंत्राटदार किंवा येथे उल्लेख केलेल्या कायद्यांचे आणि नियमांचे पालन करण्यास आमंत्रित केलेले अपयश.',
    aff_str49_para:
      'सक्तीने काम करणार्‍या परिस्थितीमुळे जर एखाद्या पक्षाला असे करण्यास मनाई केली गेली तर पक्षाला त्याची कोणतीही जबाबदा perform्या पार पाडण्यास भाग पाडले जाऊ शकत नाही. "फोर्ज मॅज्योर" इव्हेंट्समध्ये पक्षांच्या वाजवी नियंत्रणापलीकडे घटनांचा समावेश असेल, ज्यात देवाची कृत्ये, सरकारची कामे, निसर्गाची कृत्ये, संप किंवा दंगली, तसेच पीपलीलिंकस पुरवठा करणारे किंवा वस्तू, साहित्य किंवा सॉफ्टवेअर मधील दोषपूर्ण कामगिरी तृतीय पक्षाची. बलात्काराची परिस्थिती तीस ()०) दिवसांपेक्षा जास्त काळ राहिल्यास, एखादा पक्ष अन्य पक्षाला लेखी सूचना दिल्यास हा करार संपुष्टात आणू शकेल. ',
    aff_str410_para:
      "हा करार या विषयाशी संबंधित पक्षांमधील संपूर्ण कराराचे प्रतिनिधित्व करतो आणि पक्षांच्या संबंधित जबाबदा .्या आणि वचनबद्धतेचे येथे प्रतिनिधित्व करते. या करारामध्ये तयार केलेल्या करारावर पक्षांमधील अन्य कोणतीही कागदपत्रे किंवा तोंडी किंवा लेखी करार कोणत्याही प्रकारे प्रतिबिंबित होत नाहीत आणि दोन्ही बाजूंनी लिहिलेल्या लेखनाशिवाय या करारामध्ये बदल केला जाऊ शकत नाही. जेव्हा जेव्हा शक्य असेल तेव्हा या कराराच्या प्रत्येक तरतूदीचा अर्थ लागू कायद्यानुसार प्रभावी आणि वैध म्हणून अशा प्रकारे केला जाईल परंतु या कराराच्या कोणत्याही तरतूदीस लागू कायद्यानुसार प्रतिबंधित किंवा अवैध असेल तर अशा तरतूदी केवळ त्यास अकार्यक्षम असतील. अशा प्रकारच्या तरतूदी किंवा या कराराच्या उर्वरित तरतुदी अवैध केल्याशिवाय अशा प्रतिबंध किंवा अवैधतेची मर्यादा.",
    aff_str411_para:
      "या करारास भागांमध्ये साइन इन केले जाऊ शकते आणि अशा भागांवर वैध आणि बंधनकारक असेल जेणेकरून मूळ स्वाक्षर्‍याची देवाणघेवाण झाली असेल.",
    aff_str412_para:
      "हा करार हैदराबाद, तेलंगाना, भारत यांच्या कार्यक्षेत्रातील कायद्याच्या आधारे जाईल, कायद्याच्या संघर्षाच्या कोणत्याही तत्त्वांवर परिणाम न करता. अधिकार क्षेत्र हे तेलंगाना, तेलंगानाच्या हैदराबादच्या जिल्हा न्यायालयांत असेल. या करारामुळे उद्भवणार्‍या कोणत्याही खटल्याचा एकमेव आणि विशेष अधिकार क्षेत्र व भारत हा हैदराबाद, तेलंगण, भारत येथे स्थित एक योग्य जिल्हा किंवा राज्य न्यायालय असेल आणि पक्ष स्थळांवर आधारित कोणतेही आक्षेप किंवा बचाव न करण्याचे मान्य करतात. किंवा मंच नसलेली सोय. या कराराअंतर्गत किंवा त्यासंबंधित कोणतीही कायदेशीर कारवाई करण्यास सुरवात करण्यापूर्वी, पक्षाने दुसर्‍या पक्षाला एखाद्या विवादाची लेखी सूचना दिली असेल आणि तीस (तीस) च्या आत पक्षात अशा वादाचे त्वरित निराकरण करण्याच्या उद्देशाने पक्ष सक्रियपणे आणि चांगल्या श्रद्धेने वाटाघाटी करतील. ) अशा सूचना प्राप्त झाल्याचे व्यवसाय दिवस. ",
    aff_str40: "करारामध्ये बदल",
    aff_str40_para:
      "पीप्लिंक या करारास वेळोवेळी त्याच्या उचित विवेकबुद्धीनुसार साइटवर बदल पोस्ट करुन (www.peoplelinkvc.com/affiliatestermsofservice वर) किंवा ईमेलद्वारे भागीदारांना सूचित करू शकतात. जर भागीदाराने अशा प्रकारच्या बदलांवर आक्षेप घेतला तर भागीदार हा करार कारणासाठी संपुष्टात आणू शकेल. या करारामधील बदलांविषयी नोटीस प्राप्त झाल्यानंतर भागीदारांचा प्रोग्राममधील सहभागात बदल केल्यानुसार या कराराची बंधनकारक स्वीकृती असेल.",
    qualified_ref: "पात्र रेफरल्स",
    mean_referrals: "म्हणजे रेफरल्स",
    apply: "अर्ज करा",
    company_code_validate: "कृपया प्रमाणित करण्यासाठी कंपनी कोड प्रविष्ट करा",
    golive_company_code: "गोलिव्ह कंपनी कोड",
    accept_TC: "मी वरील अटी व शर्ती स्वीकारतो",
    by_sub_referral:
      "रेफरल पार्टनर अनुप्रयोग सबमिट करून, भागीदार हा करार वाचतो, समजतो आणि स्वीकारतो की त्याचे प्रतिनिधित्व करतो आणि वॉरंट करतो.",
    term: "अटी",
    found_at: "येथे आढळले",
    our_privacy_policy: "आणि आमचे गोपनीयता धोरण",
    privacy_policy: "गोपनीयता धोरण",
    as_applicable: "लागू म्हणून.",
    "screen-sharing": "स्क्रीन सामायिकरण",
    whiteboard_access: "व्हाइटबोर्ड प्रवेश",
    Document_access: "दस्तऐवज प्रवेश",
    share_the_screen: "स्क्रीन सामायिक करा!",
    to_collaborate: "सहयोग करण्यासाठी!",
    share_document: "दस्तऐवज सामायिक करा!",

    exit_or_end: "बाहेर पडायचे की सत्र संपवायचे?",
    exit_from_meeting: "सत्रातून बाहेर पडायचे?",
    are_sure_exit_meeting_everyone:
      "तुमची खात्री आहे की तुम्ही सत्रातून बाहेर पडू इच्छिता? तुम्ही प्रत्येकासाठी मीटिंग संपवू शकता किंवा तुम्ही सेशनमधून बाहेर पडू शकता.",
    are_sure_exit_meeting:
      "तुमची खात्री आहे की तुम्ही सत्रातून बाहेर पडू इच्छिता?",
    exit_meeting: "सत्रातून बाहेर पडा",
    end_for_all: "सर्वांसाठी सत्र समाप्त करा",
    end_meeting: "सत्र समाप्त करा",
    will_let_alone_exit:
      "तुम्हाला सत्रातून एकटे बाहेर पडू देईल किंवा सोडू देईल.",
    will_end_for_everyone:
      "कॉन्फरन्समधील प्रत्येकासाठी सत्र समाप्त करेल (सर्व सहभागी आणि उपस्थित).",
    user_already_exists: "वापरकर्ते आधीपासूनच अस्तित्वात आहेत",
    already_user_avail: "कॉन्फरन्समध्ये आधीपासूनच काही वापरकर्ते उपलब्ध आहेत. ",
    if_like_continue: "आपण पुढे चालू ठेवू इच्छित असल्यास वर क्लिक करा ",
    force_start_meetinh: "दुसरे सत्र सक्तीने सुरू करा ",
    otherwise_click: "अन्यथा क्लिक करा ",
    to_go_back: "परत जाण्यासाठी ",

    //New by Keerthi - 17th Sep 2020
    lang_settings: "भाषा सेटिंग्ज",
    lang_info: "अनुप्रयोग वापरण्यासाठी तुमची पसंतीची भाषा निवडा.",
    select_language: "भाषा निवडा",
    settings_languages: "भाषा",

    rec_plugin: "Recording Plugin",
    rec_heading1:
      "How to install and manage InstaVC Screen-Video Recorder with the plugin",
    rec_step1: "Step 1: Copy & open Link in Chrome",
    rec_step1_para: "First copy the link ",
    rec_step1_para_br:
      "from here and open it in chrome to add the plugin to your browser. Click on ",
    rec_step1_para_bold: "Add to Chrome",
    rec_step1_para_ct: "to add this extension.",

    rec_step2: "Step 2: Pop Up for Permission",
    rec_step2_para_br:
      "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
    rec_step2_para_bold: "Add Extension",
    rec_step2_para_ct: "to proceed.",

    rec_step3: "Step 3: Extension Added to Chrome",
    rec_step3_para:
      "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

    rec_step4: "Step 4: Pin the plugin on the toolbar",
    rec_step4_para_br:
      "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
    rec_step4_para_bold: "InstaVC Screen-Recording",
    rec_step4_para_ct: "and click on the pin icon to add.",

    rec_step5: "Step 5: Extension/Plugin Pinned to Toolbar",
    rec_step5_para:
      "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access.",

    rec_step6: "Step 6: InstVC Recorder Setup",
    rec_step6_para_br:
      "Once you have installed the plugin and the next time when you open it, you can now see the ",
    rec_step6_para_bold: "InstaVC Recorder Setup",
    rec_step6_para_ct:
      "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
    rec_step6_para_bold1: "Next",
    rec_step6_para_ct1: "to continue.",

    rec_step7: "Step 7: Additional Permissions",
    rec_step7_para_br:
      "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
    rec_step7_para_bold: "Allow",
    rec_step7_para_ct: "to continue.",

    rec_step8: "Step 8: Permissions Allowed",
    rec_step8_para:
      "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

    rec_heading2: "Desktop Screen-Recording Plugin",

    rec_step9: "Step 9: Desktop Screen-Recording",
    rec_step9_para_br:
      "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
    rec_step9_para_bold: "Desktop Screen Recording",
    rec_step9_para_ct: "and click on the",
    rec_step9_para_bold1: "Record",
    rec_step9_para_ct1: "button to start.",

    rec_step9a: "Step 9(a): Share your Screen Popup",
    rec_step9a_para_br:
      "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
    rec_step9a_para_bold: "Share",
    rec_step9a_para_ct:
      "button and go to that screen which you want to start recording.",

    rec_step9b: "Step 9(b): Desktop Screen Recording Started",
    rec_step9b_para_br:
      "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
    rec_step9b_para_bold: "Stop Sharing",
    rec_step9b_para_ct: "or",
    rec_step9b_para_bold1: "Hide",
    rec_step9b_para_ct1:
      ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

    rec_step9c: "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
    rec_step9c_para_br:
      "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
    rec_step9c_para_bold: "Restart, Pause",
    rec_step9c_para_ct: "and",
    rec_step9c_para_bold1: "Stop",
    rec_step9c_para_ct1: "buttons. You can click any of those accordingly.",

    rec_step9d: "Step 9(d):Recent Recording View",
    rec_step9d_para_br:
      "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
    rec_step9d_para_bold: "Download",
    rec_step9d_para_ct:
      "option in the top and the recording details in the right column.",

    rec_heading3: "Browser Tab Screen-Recording Plugin",

    rec_step10: "Step 10: Browser Tab Screen-Recording",
    rec_step10_para_br: "When we want to select ",
    rec_step10_para_bold: "Browser Tab",
    rec_step10_para_ct:
      "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
    rec_step10_para_bold1: "Record",
    rec_step10_para_ct1: "button to start recording.",

    rec_step10a: "Step 10(a): Browser Tab is being Recorded",
    rec_step10a_para:
      "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",

    rec_step10b: "Step 10(b): Record another tab",
    rec_step10b_para_br:
      "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
    rec_step10b_para_bold: "Record This Tab",
    rec_step10b_para_ct:
      "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

    rec_step10c: "Step 10(C): Stop and View recording",
    rec_step10c_para_br:
      "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
    rec_step10c_para_bold: "Download",
    rec_step10c_para_ct:
      "Option at the top and the recording details in the right column.",

    rec_heading4: "Webcam Recording",

    rec_step11: "Step 11: Start Webcam Screen Recording",
    rec_step11_para_br:
      "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
    rec_step11_para_bold: "Record",
    rec_step11_para_ct: "button to start with.",

    rec_step11a: "Step 11(a): Webcam opens Self Video and starts Recording",
    rec_step11a_para_br:
      "The recording opens a web page with yourself video with",
    rec_step11a_para_bold: "Pause",
    rec_step11a_para_ct: "and",
    rec_step11a_para_bold1: "Stop",
    rec_step11a_para_ct1: "recording options at the bottom.",

    rec_step11b: "Step 11(b): View Webcam Recorded Video",
    rec_step11b_para:
      "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",

    rec_heading5: "Top Menus in Recording Plugin",

    rec_step12: "Step 12: Navigation Menus",
    rec_step12_para_br:
      "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
    rec_step12_para_bold: "Hamburger Menu",
    rec_step12_para_ct: "Click on it to open.",

    rec_step12a: "Step 12(a): Open Hamburger Menu",
    rec_step12a_para_br: "On click of",
    rec_step12a_para_bold: "Hamburger Menu",
    rec_step12a_para_ct: ", you can find 2 tabs named",
    rec_step12a_para_bold1: "My Recordings",
    rec_step12a_para_ct1: "and",
    rec_step12a_para_bold2: "Options",
    rec_step12a_para_ct2:
      "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
    rec_step12a_para_bold3: "My Recordings",
    rec_step12a_para_ct3: "to see the videos you have recorded till date.",

    rec_step12b: "Step 12(b): Access My Recordings",
    rec_step12b_para_br: "There is another way of accessing",
    rec_step12b_para_bold: "My Recordings",
    rec_step12b_para_ct:
      ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",

    rec_step12c: "Step 12(c): My Recordings",
    rec_step12c_para:
      "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

    rec_step12d: "Step 12(d): Delete All recordings",
    rec_step12d_para_br:
      "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
    rec_step12d_para_bold: "Delete All",
    rec_step12d_para_ct:
      "option to easily delete all recordings with a single click.",

    rec_step12e: "Step 12(e): Side Navigation",
    rec_step12e_para_br:
      "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
    rec_step12e_para_bold: "Options",
    rec_step12e_para_ct: "page",

    rec_heading6: "Plugin Options",

    rec_step13: "Step 13: Plugin Options",
    rec_step13_para_br:
      "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
    rec_step13_para_bold: "Options",
    rec_step13_para_ct: "to see the options that are enabled for you.",

    rec_step13a: "Step 13(a): Recorder Options",
    rec_step13a_para:
      "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

    rec_step13b: "Step 13(b): Recorder Options",
    rec_step13b_para:
      "Recorder Options contain various other options like Recording Settings and advanced.",

    rec_heading7: "Plugin Notifications",

    rec_step14: "Step 14: Plugin Notifications",
    rec_step14_para:
      "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

    rec_step14a: "Step 14(a): Open Notifications",
    rec_step14a_para:
      "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

    rec_heading8: "Recording Settings",

    rec_step15: "Step 15: Settings",
    rec_step15_para_br:
      "Then comes the last navigation menu on the top right corner named",
    rec_step15_para_bold: "Settings",
    rec_step15_para_ct:
      "where you can open and manage the recording settings accordingly.",

    rec_step15a: "Step 15(a): Advanced Settings Options",
    rec_step15a_para:
      "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

    crteContent_upload_medialist: "Uploaded Media List",
    content_upld_desc_txt:
      "The files you upload here will be available to users who view content.",
    content_browse_txt: "Browse Files to Upload",
    content_upld_types:
      "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

    video_qlty: "व्हिडिओ गुणवत्ता",
    audio_qlty: "ऑडिओ गुणवत्ता",
    cntnt_shrng: "सामग्री सामायिकरण",
    fdb_poor: "गरीब",
    fdb_good: "चांगले",
    fdb_avg: "सरासरी",
    fdb_excellent: "उत्कृष्ट",
    share_feedback: "आपला फीडबॅक सामायिक करा",
    ovrl_rating: "एकूण रेटिंग",
    fdb_cmnts: "आपल्या टिप्पण्यांचे खूप कौतुक केले आहे",
    no_thnks: "नको धन्यवाद",
    upload_size_max_15mb: "आपण अपलोड करू शकता कमाल आकार मर्यादा 15MB आहे",

    pastMeeting_feedback: "अभिप्राय",
    pastMeeting_comments: "टिप्पण्या",

    microsoft_webplugin: "मायक्रोसॉफ्ट आउटलुक वेब प्लगइन",
    microsoft_installable: "मायक्रोसॉफ्ट आउटलुक इंस्टॉल करण्यायोग्य प्लगइन",
    outlook_installable: "आउटलुक इंस्टॉलेबल",
    customization_installer: "सानुकूलन इंस्टॉलरमध्ये प्रवेश कसा करावा",
    plugin_step1: "चरण 1: फाइल डाउनलोड करण्यासाठी दुव्यावर क्लिक करा",
    click_link_download: "फाइल डाउनलोड करण्यासाठी दुवा क्लिक करा",
    first_click_link: "प्रथम खालील दुव्यावर क्लिक करा",
    to_download_file:
      "आपल्या सिस्टममध्ये फाइल डाउनलोड करण्यासाठी. नंतर स्थापना सुरू करण्यासाठी डाउनलोड केलेली फाईल उघडा आणि क्लिक करा",
    install_txt: "स्थापित करा",
    plugin_step2: "चरण 2: सानुकूलित स्थापित",
    plugin_step2_para:
      "Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
    plugin_step3: "चरण 3: आउटलुक उघडा आणि संमेलनांकडे जा",
    plugin_step3_para: "स्थापनेनंतर, Microsoft Outlook उघडा आणि सत्रावर जा.",
    plugin_step3_para1: "नवीन ईमेल > सत्र वर जा",
    plugin_step4: "पायरी 4: सत्र उघडा",
    plugin_step4_para:
      "एकदा सत्र विंडो उघडली की वरील टॅबच्या सूचीवर हलवा आणि त्यानंतर तुम्ही टॅबवर क्लिक करू शकता.",
    plugin_step4_para1: "पीपलिंक",
    plugin_step5: "चरण 5: वेळापत्रक परिषद",
    plugin_step5_para: "पीपलीलिंक अंतर्गत आपल्याकडे एक सब टॅब नावाचा आहे",
    plugin_step5_para1: "वेळापत्रक परिषद.",
    plugin_step5_para2:
      "त्यावर क्लिक करा आणि आपण विंडोच्या उजवीकडे शेड्यूल पर्याय पाहू शकता. येथे आपण इनव्हीसी वेळापत्रक व्यवस्थापित करू शकता.",
    plugin_step6: "चरण 6: वेळापत्रक व्यवस्थापित करा किंवा सानुकूलित करा",
    plugin_step6_para:
      "येथे आपण खोल्या, वेळांच्या सूचीनुसार वेळापत्रक व्यवस्थापित करू शकता किंवा सानुकूलित करू शकता आणि येथून नवीन वेळापत्रक तयार करू शकता जे आपल्याला ब्राउझरवर आणि बाह्य दृष्टीक्षेपात पुनर्निर्देशित करते.",
    plugin_step6_para1:
      "एकदा आपण वेळापत्रकानंतर ठीक झाल्यावर आपण क्लिक करू शकता",
    plugin_step6_para2: "दुवा मिळवा",
    plugin_step7: "दुवा व्युत्पन्न केला",
    plugin_step7_para:
      "मग येथे मेलमध्ये व्युत्पन्न केलेला आणि तयार केलेला दुवा प्राप्त झाला आहे जो आपण तो ऑनलाइन सामायिक करण्यासाठी किंवा पुढे जाऊ शकता.",

    instavc_schedulemeeting_namesplchar:
      "No special characters allowed except @ # $ % ^ & * _ - ?",

    sessions: "सत्रे",
    schedule_session: "शेड्यूल सत्र",
    join_session: "सत्रात सामील व्हा",
    no_of_sessions_attended_by_teacher:
      "शिक्षकांनी उपस्थित केलेल्या सत्रांची संख्या",
    no_of_sessions_attended_by_student:
      "विद्यार्थ्यांनी उपस्थित केलेल्या सत्रांची संख्या",
    teacher_attendance: "शिक्षकांची उपस्थिती",
    students_attendance: "विद्यार्थ्यांची उपस्थिती",
    virtual_classroom:
      "अतुलनीय अनुभवासह ऑनलाइन व्हर्च्युअल क्लासरूम प्लॅटफॉर्म",
    today_sessions: "आजची सत्रे",
    no_sessions: "कोणतीही सत्रे नाहीत...",
    session_quote:
      "मूलभूत आणि प्रगत मीटिंग वैशिष्ट्यांसह सत्र पासवर्ड तयार करणे किंवा डायनॅमिक मीटिंग आयडी सक्षम करणे यासारख्या पर्यायांसह नवीन सत्र शेड्यूल करा.",
    session_title: "सत्राचे शीर्षक",
    create_session_name: "एक सत्र नाव तयार करा",
    session_password: "सत्र पासवर्ड",
    meeting_password: "सत्र पासवर्ड तयार करा",
    selectClass: "वर्ग निवडा",
    selectSubject: "विषय निवडा",
    select_time: "वेळ निवडा",
    select_meeting_date_time: "सत्राची तारीख आणि वेळ निवडा",
    select_slot: "स्लॉट निवडा",
    select_numberof_participant_seats: "सहभागी जागांची संख्या निवडा",
    advanced_options: "प्रगत पर्याय",
    custom_registration_url: "सानुकूल नोंदणी URL",
    custom_feedback_url: "सानुकूल अभिप्राय URL",
    allow_guest_control: "अतिथींना नियंत्रित करण्याची परवानगी द्या",
    meeting_details: "सत्र तपशील",
    meeting_title: "सत्राचे शीर्षक",
    meeting_type: "सत्राचा प्रकार",
    seats: "जागा",
    meeting_Password: "सत्र पासवर्ड",
    meeting_only_url: "फक्त सत्र URL:",
    join_meeting_quote:
      "सहभागींना आमंत्रित न करता किंवा त्याशिवाय सत्रात सामील व्हा",
    copy_invitation: "आमंत्रण कॉपी करा",
    invite_users_list: "आमंत्रित करा - वापरकर्त्यांची यादी",
    update_meeting: "अद्यतन सत्र",
    custom: "सानुकूल",
    frequency: "वारंवारता",
    occurences_end: "घटना संपते",
    occurences: "घटना",
    hr: "तास",
    every_day: "रोज",
    hours: "तास",
    hour: "तास",
    errorTxt_slots: "तुम्हाला कस्टम वेळ - तास किंवा मिनिटे भरायची आहेत",
    participantSeats: "सहभागी जागा",
    participant_seat: "सहभागी आसनt",
    subjects: "विषय",
    visible: "दृश्यमान",
    hidden: "लपलेले",
    create_topic: "विषय तयार करा",
    edit_topic: "विषय संपादित करा",
    topicName: "विषयाचे नाव",
    topicDescripiton: "विषयाचे वर्णन",
    public: "सार्वजनिक",
    classDescription: "वर्ग वर्णन",
    editNewClass: "नवीन वर्ग संपादित करा",
    topics: "विषय",
    topicView: "विषय दृश्य",
    no_of_sessions_conducted: "आयोजित सत्रांची संख्या",
    no_of_students_attended_session:
      "तुमच्या सत्रात सहभागी झालेल्या विद्यार्थ्यांची संख्या",
    yourAssignments: "तुमची असाइनमेंट",
    attendance: "उपस्थिती",
    recent_topics: "अलीकडील विषय",
    no_subjects: "अद्याप कोणतेही विषय तयार केलेले नाहीत!",
    no_subjects_create:
      "वरील विषय तयार करा बटणावर क्लिक करून नवीन विषय तयार करा",
    no_topics: "अद्याप कोणतेही विषय तयार केलेले नाहीत!",
    no_topics_create: "वरील विषय तयार करा बटणावर क्लिक करून एक विषय तयार करा",
    assgnlist_noassignments: "अद्याप कोणतीही असाइनमेंट नियुक्त केलेली नाही!",
    assgnlist_assign_new_assign:
      "वरील असाइनमेंट बटणावर क्लिक करण्यासाठी नवीन असाइनमेंट नियुक्त करा",
    start_date_time: "प्रारंभ तारीख आणि वेळ",
    end_date_time: "समाप्ती तारीख आणि वेळ",
    join_conference_quote:
      "सत्रात सामील होण्यासाठी, खालील इनपुट बॉक्समध्ये सत्र ID प्रदान करा",
    edit_student: "विद्यार्थी संपादित करा",
    editTeacher: "शिक्षक संपादित करा",
    subject_name: "विषयाचे नाव",
    subject_description: "विषयाचे वर्णन",
    select_type: "प्रकार निवडा",
    others: "इतर",
    Institute_name: "संस्थेचे नाव",
    first_name_contact: "संपर्काचे पहिले नाव",
    last_name_contact: "संपर्काचे आडनाव",
    institute_type: "संस्थेचा प्रकार",
    institute_name: "संस्थेचे नाव",
    contact_number: "संपर्क क्रमांक",
    signup_as_institute: "संस्था म्हणून साइन अप करा",
    signup_as_student: "विद्यार्थी म्हणून साइन अप करा",
    state: "राज्य",
    city: "शहर",
    institute_name_error: "संस्थेचे नाव फक्त वर्ण असावे",
    institute_type_error: "संस्थेचा प्रकार निवडला पाहिजे",
    address_error: "पत्ता विशेष वर्ण स्वीकारू शकतो",
    student: "विद्यार्थी",
    institute: "संस्था",
    signUpas: "म्हणून साइन अप करा",
    submitted: "सादर केले",
    notSubmitted: "सबमिट केले नाही",
    review: "पुनरावलोकन करा",
    inReview: "पुनरावलोकनात",
    questionTitle: "प्रश्नाचे शीर्षक",
    questionDescription: "प्रश्न वर्णन",
    questionnaireTitle: "शीर्षक प्रश्न",
    started: "सुरुवात केली",
    testName: "चाचणी नाव",
    timeTaken: "घेतलेला वेळ",
    showAnswers: "उत्तरे दाखवा",
    downloadCertificate: "प्रमाणपत्र डाउनलोड करा",
    startTime: "सुरवातीची वेळ",
    endTime: "समाप्तीचा कालावधी",
    assignmentTitle: "असाइनमेंट शीर्षक",
    editor: "संपादक",
    save_submit: "सेव्ह करा आणि सबमिट करा",
    assigned_students: "नियुक्त केलेले विद्यार्थी",
    total_marks: "एकूण गुण",
    not_yet_Submitted: "अद्याप सबमिट केलेले नाही",
    completed: "पूर्ण झाले",
    due_date: "देय तारीख",
    marks_obtained: "गुण मिळाले",
    assign_marks: "गुण नियुक्त करा",
    home_inclass_copyright: "© 2022 InstaVC Inc. All Rights Reserved.",
    // " © 2022 InstaVC Inc. सर्व हक्क राखीव | पॉवर बाय Peoplelink Uniified Communications Pvt. लि",
    back_to_classes: "वर्गांकडे परत",
    className: "वर्गाचे नाव",
    attendanceReports: "उपस्थिती अहवाल",
    present: "उपस्थित",
    absent: "अनुपस्थित",
    ratio: "प्रमाण",
    sessionsAttended: "सत्रांना हजेरी लावली",
    totalSessions: "एकूण सत्रे",
    filters: "फिल्टर",
    teacher: "शिक्षक",
    userType: "वापरकर्ता प्रकार",
    class: "वर्ग",
    clear: "साफ",
    sessionsConducted: "सत्रे आयोजित केली",
    Topic: "विषय",
    uploadMediaSizeLimit: "15MB पर्यंत आकार मर्यादेसह.",
    assessments: "मूल्यांकन",
    assessment: "मूल्यांकन",
    totalStudents: "एकूण विद्यार्थी",
    totalAssignments: "एकूण असाइनमेंट",
    assignmentsCompleted: "असाइनमेंट पूर्ण झाले",
    assignmentsPending: "असाइनमेंट प्रलंबित",
    score: "स्कोअर",
    submittedDate: "सबमिट करण्याची तारीख",
    dueDateOfSubmission: "सादर करण्याची अंतिम तारीख",
    clearSelections: "निवडी साफ करा",
    noschedule_meetings: "तुमच्याकडे कोणतीही आगामी सत्रे नाहीत.",
    nopast_meetings: "तुमच्याकडे कोणतीही मागील सत्रे नाहीत",
    id: "आयडी",
    export: "निर्यात करा",
    import: "आयात करा",
    sample_excel: "नमुना एक्सेल",
    subject_access: "विषय प्रवेश",
    submitted_date_time: "सबमिट केलेली तारीख/वेळ",
    passed: "उत्तीर्ण",
    failed: "अयशस्वी",
    average_score: "सरासरी गुण",
    total_reviewed: "एकूण पुनरावलोकन केले",
    pending_review: "प्रलंबित पुनरावलोकन",
    total_students_finished: "एकूण विद्यार्थी संपले",
    total_students_passed: "एकूण विद्यार्थी उत्तीर्ण",
    total_students_failed: "एकूण विद्यार्थी नापास",
    total_students_absent: "एकूण गैरहजर विद्यार्थी",
    time_exceed: "वेळ मर्यादा ओलांडली",
    time_exceed_assgn_msg:
      "ही असाइनमेंट सबमिट करण्याची वेळ मर्यादा ओलांडली आहे",
    time_exceed_quess_msg: "ही प्रश्नावली सादर करण्याची कालमर्यादा ओलांडली आहे",
    class_code: "वर्गाचे नाव",
    subject_code: "विषय कोड",
    updateQuestion: "ചോദ്യം അപ്ഡേറ്റ് ചെയ്യുക",
    enroll: "नावनोंदणी करा",
    create_new_passwd: "नवीन पासवर्ड तयार करा",
    actions: "क्रिया",
    please_enter_topic_name: "कृपया विषयाचे नाव प्रविष्ट करा",
    please_enter_topic_description: "कृपया विषयाचे वर्णन प्रविष्ट करा",
    plz_select_questionary: "कृपया प्रश्नार्थी निवडा.",
    plz_select_duration_checkbox: "कृपया कालावधी चेकबॉक्स निवडा.",
    Plz_select_assignment: "कृपया असाइनमेंट निवडा.",
    plz_select_valid_date_time: "कृपया वैध तारीख वेळ निवडा.",
    Plz_enter_valid_marks: "कृपया वैध गुण प्रविष्ट करा.",
    Plz_enter_subject_title: "कृपया विषयाचे शीर्षक प्रविष्ट करा.",
    class_code:"वर्ग कोड",
    Plz_enter_class_name: "कृपया वर्गाचे नाव प्रविष्ट करा",
    Plz_enter_subject_description: "कृपया विषय वर्णन प्रविष्ट करा.",
    Plz_enter_subject_type: "कृपया विषय प्रकार प्रविष्ट करा.",
    Plz_enter_subject_code: "कृपया विषय कोड प्रविष्ट करा.",
    Plz_enter_valid_subject_code: "कृपया वैध विषय कोड प्रविष्ट करा",
    Plz_enter_class_code: "कृपया वर्ग कोड प्रविष्ट करा.",
    Plz_enter_valid_class_code: "कृपया वैध वर्ग कोड प्रविष्ट करा",
    plz_enter: "कृपया प्रविष्ट करा",
    Plz_enter_valid: "कृपया विषय निवडा.",
    Plz_enter_title: "कृपया शीर्षक प्रविष्ट करा.",
    Plz_enter_description: "कृपया वर्णन प्रविष्ट करा.",
    Plz_select_class: "कृपया वर्ग निवडा",
    Plz_select_subject: "कृपया विषय निवडा.",
    something_went_wrong: "काहीतरी चूक झाली.",
    data_is_not_selected: "डेटा निवडलेला नाही",
    data_added_successfully: "डेटा यशस्वीरीत्या जोडला",
    plz_enter_question: "कृपया प्रश्न प्रविष्ट करा",
    plz_enter_marks: "कृपया गुण प्रविष्ट करा",
    Plz_select_type: "कृपया प्रकार निवडा",
    opt_should_have_minimum: "पर्यायांमध्ये किमान २ असावेत",
    opt_should_not_empty: "पर्याय रिकामे नसावेत",
    opt_should_not_duplicate: "पर्याय डुप्लिकेट नसावेत",
    plz_select_the_answer: "कृपया उत्तर निवडा",
    question_updated_successfully: "प्रश्न यशस्वीरित्या अपडेट केला",
    question_created_successfully: "प्रश्न यशस्वीरित्या तयार केला",
    marks_less_than_total_marks:
      "प्रविष्ट केलेले गुण एकूण गुणांपेक्षा कमी असावेत",
    marks_not_negative: "गुण नकारात्मक नसावेत",
    assgn_successfully_verifed: "असाइनमेंट सेव्ह यशस्वीरित्या सत्यापित.",
    assgn_save_submited_succes:
      "असाइनमेंट सेव्ह केले आणि यशस्वीरित्या सबमिट केले",
    assgn_save_succes: "असाइनमेंट यशस्वीरित्या सेव्ह करा",
    Plz_enter_valid_content: "कृपया वैध सामग्री प्रविष्ट करा.",
    Assgn_updated_success: "असाइनमेंट यशस्वीरित्या अपडेट केले",
    Assgn_created_success: "असाइनमेंट यशस्वीरित्या तयार केले",
    Assgn_assigned_success: "असाइनमेंट यशस्वीरित्या नियुक्त केले",
    Assgn_disabled_success: "असाइनमेंट यशस्वीरित्या अक्षम केले.",
    Assgn_enabled_success: "असाइनमेंट यशस्वीरित्या सक्षम केले.",
    Assgn_deleted_success: "असाइनमेंट यशस्वीरित्या हटवले.",
    Quest_creat_success: "प्रश्नावली यशस्वीरित्या तयार केली",
    Quest_updated_success: "प्रश्नावली यशस्वीरित्या अपडेट केली",
    Poll_created_success: "मतदान यशस्वीरित्या तयार केले",
    Poll_updated_success: "मतदान यशस्वीरित्या अपडेट केले",
    opt_minimum: "पर्यायांमध्ये किमान 2 पर्याय असावेत",
    Poll_deleted_success: "मतदान यशस्वीरित्या हटवले",
    Poll_enabled_success: "मतदान यशस्वीरित्या सक्षम केले",
    Poll_disabled_success: "मतदान यशस्वीरित्या अक्षम केले",
    Quest_deleted_success: "प्रश्न यशस्वीरित्या हटवला",
    Invit_send_success: "आमंत्रण यशस्वीरीत्या पाठवले",
    teacher_deleted_success: "शिक्षक यशस्वीरित्या हटवले",
    error_some_thing_went_wrong: "एरर, काहीतरी चूक झाली.",
    user_updated_success: "वापरकर्ता स्थिती यशस्वीरित्या अद्यतनित केली",
    teacher_updated_success: "शिक्षक यशस्वीरित्या अद्यतनित केले",
    student_remove_success: "विद्यार्थी यशस्वीरित्या काढला",
    teachers_created_success: "शिक्षक यशस्वीरित्या तयार केले",
    error_occured_try_again: "एक त्रुटी आली, पुन्हा प्रयत्न करा!",
    please_select_less: "कृपया 15MB फाइल आकारापेक्षा कमी निवडा.",
    submit_success: "यशस्वीरित्या सबमिट केले",
    grad_updat_success: "ग्रेड अद्यतने यशस्वीरित्या",
    Quest_delet_succes: "प्रश्नावली यशस्वीरित्या हटवली",
    Quest_disab_succes: "प्रश्नावली यशस्वीरित्या अक्षम केली",
    Quest_enabled_succes: "प्रश्नावली यशस्वीरित्या सक्षम केली",
    student_add_succes: "विद्यार्थी यशस्वीरित्या जोडला गेला",
    plz_select_atleast_std: "कृपया किमान 1 विद्यार्थी निवडा",
    fail_add_some_student: "काही विद्यार्थी जोडण्यात अयशस्वी",
    std_add_succes: "विद्यार्थी यशस्वीरित्या जोडले गेले",
    sub_updat_succes: "विषय यशस्वीरित्या अपडेट केला",
    sub_creat_succes: "विषय यशस्वीरित्या तयार केला",
    sub_dlt_succes: "विषय यशस्वीरित्या हटवला",
    sub_enabl_succes: "विषय यशस्वीरित्या सक्षम केला",
    sub_disab_succes: "विषय यशस्वीरित्या अक्षम केला",
    tchr_add_success: "शिक्षक यशस्वीरित्या जोडले",
    plz_slc_atlst_tchr: "कृपया किमान 1 शिक्षक निवडा",
    tchr_remo_success: "शिक्षक यशस्वीरित्या काढले",
    plz_etr_valid_duration: "कृपया वैध कालावधी प्रविष्ट करा",
    topic_updat_success: "विषय यशस्वीरित्या अपडेट केला",
    class_dlt_success: "वर्ग यशस्वीरित्या हटवला",
    class_upt_succes: "वर्ग यशस्वीरित्या अपडेट केला",
    class_creat_succes: "वर्ग यशस्वीरित्या तयार केला",
    plz_select_quest: "कृपया प्रश्नावली निवडा",
    first_add_data: "डेटा जोडण्यासाठी प्लस बटणावर क्लिक करा",
    certfct_generat_success: "प्रमाणपत्र यशस्वीरित्या व्युत्पन्न केले",
    plz_select_min_seats: "कृपया किमान 2 जागा निवडा",
    plz_enter_mtng_name: "कृपया सत्राचे नाव प्रविष्ट करा",
    fail_to_updt_mtng_try_again:
      "सत्र अपडेट करण्यात अयशस्वी! पुन्हा प्रयत्न करा",
    fail_update_scdle: "शेड्यूल अपडेट करण्यात अयशस्वी",
    std_delet_success: "विद्यार्थी यशस्वीरित्या हटवला",
    std_updat_succes: "विद्यार्थ्याने यशस्वीरित्या अपडेट केले",
    std_creat_succes: "विद्यार्थी यशस्वीरित्या तयार केला",
    fail_create_some_std: "काही विद्यार्थी तयार करण्यात अयशस्वी",
    std_creat_success: "विद्यार्थी यशस्वीरित्या तयार केले",
    tchr_creat_succes: "शिक्षक यशस्वीरित्या तयार केले",
    fail_crt_some_user: "काही वापरकर्ते तयार करण्यात अयशस्वी",
    fail_create_mtg_try_again: "सत्र तयार करण्यात अयशस्वी! पुन्हा प्रयत्न करा",
    fail_create_schedu: "वेळापत्रक तयार करण्यात अयशस्वी",
    plz_enter_metng_title: "कृपया सत्राचे शीर्षक प्रविष्ट करा",
    invalid_phn_nmb: "अवैध दूरध्वनी क्रमांक",
    plz_enter_phn_num: "कृपया फोन नंबर प्रविष्ट करा",
    topic_crt_succes: "विषय यशस्वीरित्या तयार झाला",
    topic_enabled_succes: "विषय यशस्वीरित्या सक्षम केला",
    topic_disabl_success: "विषय यशस्वीरित्या अक्षम केला",
    topic_delet_success: "विषय यशस्वीरित्या हटवला",
    Media_delet_success: "मीडिया यशस्वीरित्या हटवला",
    plz_enter_title_upload_doc:
      "कृपया प्रथम शीर्षक प्रविष्ट करा आणि दस्तऐवज अपलोड करा",
    doc_add_succes: "दस्तऐवज यशस्वीरित्या जोडले",
    plz_fst_ent_title_and_media:
      "कृपया प्रथम शीर्षक प्रविष्ट करा आणि मीडिया फाइल प्रविष्ट करा",
    media_add_success: "मीडिया यशस्वीरित्या जोडला",
    plz_first_title_and_URL:
      "कृपया प्रथम शीर्षक प्रविष्ट करा आणि मीडिया URL प्रविष्ट करा",
    plz_etr_valid_url: "कृपया वैध url प्रविष्ट करा",
    generate: "उत्पन्न करा",
    issue_cert: "प्रमाणपत्र जारी करा",
    total_score: "एकूण स्कोअर",
    created_by: "ने निर्मित",
    certificate: "प्रमाणपत्र",
    not_completed: "पूर्ण झाले नाही",
    view_cert: "प्रमाणपत्र पहा",
    issue_certificate: "प्रमाणपत्र जारी करा",
    title: "शीर्षक",
    issue_date: "दिल्याचा दिनांक",
    note_edit_and_delete_txt:
      "टीप: चाचणीच्या 10 मिनिटांपूर्वी संपादन आणि हटवा बटणे लपविली जातील",
    verify_email_msg: "कृपया पुष्टीकरण कोडसाठी तुमचा ईमेल तपासा.",
    start_time_greater_currnt_time:
      "चालू वेळेनंतर सुरू होण्याची वेळ 10 मिनिटांपेक्षा जास्त असावी",
    copi_to_clipboard: "क्लिपबोर्डवर कॉपी केले!",
    host_msg: "यजमान",
    date_time: "तारीख वेळ",
    invities: "निमंत्रित",
    no_chat_history_avai: "कोणताही चॅट इतिहास उपलब्ध नाही.",
    no_feedbacks_avai: "कोणतेही अभिप्राय उपलब्ध नाहीत",
    no_invities_list_avai: "निमंत्रितांची यादी उपलब्ध नाही",
    no_conference_note_avai: "कॉन्फरन्स नोट्स उपलब्ध नाहीत.",
    total_notes: "एकूण नोट्स (१५)",
    view_log_history: "लॉग इतिहास पहा",
    total_duration: "एकूण कालावधी:",
    min: "मि",
    total_time_spent: "एकूण घालवलेला वेळ:",
    entry: "प्रवेश",
    exit: "बाहेर पडा",
    time_spent: "वेळ घालवला",
    no_conference_recording_avai: "कॉन्फरन्स रेकॉर्डिंग उपलब्ध नाहीत",
    no_meetings: "कोणतीही सत्रे नाहीत!",
    this_brow_dont_support_video_tag:
      "हा ब्राउझर व्हिडिओ टॅगला सपोर्ट करत नाही.",
    no_participants_list_avai: "कोणतीही सहभागी यादी उपलब्ध नाही.",
    total_number_session: "सत्रांची एकूण संख्या",
    start_date: "प्रारंभ तारीख:",
    join_mtg_provide_id_below_input:
      "सत्रात सामील होण्यासाठी, खालील इनपुट बॉक्समध्ये सत्र ID प्रदान करा.",
    You_enter_inva_meet: "तुम्ही अवैध सत्र आयडी प्रविष्ट केला आहे.",
    no_ques_creat_yet: "अद्याप कोणतीही प्रश्नावली तयार केलेली नाही!",
    creat_quest_click_creat:
      "प्रश्नावली तयार करा बटणावर क्लिक करून प्रश्नावली तयार करा.",
    only_invit_can_join: "केवळ निमंत्रित सहभागी होऊ शकतात",
    invc_login_mandato: "inVC लॉगिन अनिवार्य",
    training_mode: "प्रशिक्षण मोड",
    audio_only_mode: "फक्त ऑडिओ मोड",
    mute_parti_upon_entry: "प्रवेश केल्यावर सहभागींना निःशब्द करा",
    join_before_host: "होस्ट करण्यापूर्वी सामील व्हा",
    enable_breakout_session: "ब्रेकआउट सत्रे सक्षम करा",
    anonymous_access: "अनामित प्रवेश",
    send_invite: "आमंत्रण पाठवा",
    add_part_email_address_mobil_msg:
      "सहभागींना त्यांचा ईमेल पत्ता किंवा मोबाईल नंबर जोडून, ​​एकाधिक नोंदींसाठी एंटर दाबून जोडा.",
    add_email_mobile: "ईमेल / मोबाईल नंबर जोडा",
    make_sure_the_msg:
      "1 - मोबाईल नंबर देश कोडसह असावा याची खात्री करा (उदा: +91-99XXXXXXXXX)",
    email_id_note: "२ - ईमेल आयडी लोअरकेस असावा (उदा: username@xxx.com)",
    meet_before_schedul_time:
      "तुम्ही नियोजित वेळेपूर्वी या सत्रात सामील होऊ शकत नाही.",
    go_to_dashboard: "डॅशबोर्डवर जा",
    if_you_are_host_msg:
      "जर तुम्ही होस्ट असाल तर कृपया तुमच्या डॅशबोर्डवरून दुसरे द्रुत सत्र सुरू करा",
    this_meet_expir_on: "या सत्राची मुदत संपली",
    this_meet_link__expired: "या सत्राची लिंक कालबाह्य झाली आहे",
    this_meet_schedul_for: "यासाठी हे अधिवेशन आयोजित करण्यात आले आहे",
    meet_min_before_schedule_time:
      "तुम्ही नियोजित वेळेच्या ५ मिनिटे आधी या सत्रात सामील होऊ शकता.",
    this_assign_start_yet: "या असाइनमेंटची वेळ अजून सुरू झालेली नाही...",
    time_not_yet_start: "वेळ अजून सुरू झालेली नाही",
    field_once_generat_cannot_edit:
      "कृपया सर्व फील्ड तपासा एकदा व्युत्पन्न झाले की संपादित केले जाऊ शकत नाही",
    certificate_title: "प्रमाणपत्र शीर्षक",
    invalid_meet_code: "अवैध सत्र कोड",
    meeting_id_below_input_box:
      "सेशनमध्ये सामील होण्यासाठी आणि स्क्रीन शेअर करण्यासाठी, खालील इनपुट बॉक्समध्ये सेशन आयडी द्या.",
    meeting_configuration: "सत्र कॉन्फिगरेशन",
    room_participant_limit_exceed: "खोलीतील सहभागींची मर्यादा ओलांडली.",
    only_audio_call_auto_mute_enabl: "फक्त ऑडिओ कॉल आणि ऑटो म्यूट सक्षम",
    you_audio_video_mute: "तुमचा ऑडिओ आणि व्हिडिओ म्यूट केला आहे!",
    only_audio_call: "फक्त ऑडिओ कॉल",
    your_video_mute: "तुमचा व्हिडिओ निःशब्द केला आहे!",
    your_name: "तुमचे नाव",
    ok_you_r_ready: "ठीक आहे, तुम्ही तयार आहात",
    room_empty_meeting_wait_until_host_join:
      "खोली रिकामी आहे! तुम्ही सत्र सुरू करण्यासाठी लॉग इन करू शकता किंवा होस्ट सामील होईपर्यंत प्रतीक्षा करू शकता",
    room_lock_hang_until_somebody_lets:
      "खोली कुलूपबंद आहे - कोणीतरी तुम्हाला आत येऊ देत नाही तोपर्यंत थांबा ...",
    your_audio_is_muted: "तुमचा ऑडिओ म्यूट केला आहे!",
    view_assignment: "असाइनमेंट पहा",
    assigned_assignment: "नियुक्त असाइनमेंट",
    attempte_assignment_written_anything:
      "तुम्ही असाइनमेंट करण्याचा प्रयत्न केला आहे परंतु त्यात काहीही लिहिलेले नाही.",
    Marks_not_alloted: "गुणांना परवानगी नाही",
    view_questionnaire: "प्रश्नावली पहा",
    assign_questionnaire_list: "प्रश्नावली यादी नियुक्त करा",
    assign_assignment: "असाइनमेंट लिस्ट द्या",
    type: "प्रकार",
    class_description: "वर्ग वर्णन",
    password_updated: "पासवर्ड अपडेट केला!",
    numberOfLicense: "परवान्याची संख्या",
    topic: "विषय",
    del_poll: "मतदान",
    std: "विद्यार्थी",
    profile: "प्रोफाइल",
    your_test: "तुमची परीक्षा",
    unattended_incomplete_Questionaire_txt_msg:
      "काही कारणांमुळे अपूर्ण किंवा अपूर्ण होते. त्यामुळे स्कोअर कार्ड तयार होऊ शकले नाही",
    Assgnmnt_time_not_started: "असाइनमेंटची वेळ अजून सुरू झालेली नाही...",
    submitted_cnt: "सबमिट केलेली सामग्री",
    stud_list: "विद्यार्थ्यांची यादी",
    test_submitted_successfully: "तुमची चाचणी यशस्वीरित्या सबमिट केली गेली आहे",
    score_time_finished_successfully:
      "वेळ संपल्यानंतर स्कोअर प्रदर्शित केला जाईल",
    topics_list: "विषयांची यादी",
    upload_highResImg: "फक्त उच्च-रिझोल्यूशन चित्रे अपलोड करा",
    meetingList_upcoming_meetings: "आगामी सत्रे",
    subject_list: "विषय सूची",
    plz_enter_valid_number_license: "कृपया परवान्याची वैध संख्या प्रविष्ट करा",
    no_class_assigned: "कोणताही वर्ग नियुक्त केलेला नाही",
    class_list: "वर्ग यादी",
    plz_fill_all_details: "कृपया सर्व तपशील भरा",
    plz_click_upload_media_url: "कृपया अपलोड मीडिया url वर क्लिक करा",
    please_enter_msg: "कृपया प्रविष्ट करा",
    Media_msg: "मीडिया.",
    media_url: "मीडिया URL.",
    title: "शीर्षक",
    and_msg: "आणि",
    wrong_answer: "चुकीचे उत्तर",
    right_answer: "बरोबर उत्तर",
    User_list: "वापरकर्त्यांची यादी",
    questionaire_time_not_yet_start:
      "प्रश्नावलीची वेळ अजून सुरू झालेली नाही...",
    submitted_list: "सादर केलेली यादी",
    search_by_name: "नावाने शोधा",
    scheduleDate: "शेड्यूल तारीख",
    view_all: "सर्व पहा",
    view_card: "कार्ड पहा",
    confirm_submit: "तुम्हाला नक्की असाइनमेंट सबमिट करायचे आहे का?",
    confirm_finish: "तुम्हाला खात्री आहे की चाचणी पूर्ण करायची आहे?",
    questionaire: "प्रश्नावली",
    list_of_questns_for_above_questionaire:
      "वरील प्रश्नावलीसाठी नियुक्त केलेल्या प्रश्नांची यादी खाली दिली आहे",
    view_all_assignments: "सर्व असाइनमेंट पहा",
    action: "कृती",
    start_dte: "प्रारंभ तारीख",
    subject: "विषय",
    digital_file_upload_and_digital_signature:
      "येथे अपलोड केलेल्या डिजिटल फायली विद्यार्थ्यांना जारी केलेल्या डिजिटल प्रमाणपत्रांवर दिसतील",
    upload_logo: "लोगो अपलोड करा",
    upload_signature: "स्वाक्षरी अपलोड करा",
    upload_stamp: "स्टॅम्प अपलोड करा",
    drag_and_drop_file: "तुमची फाइल येथे ड्रॅग आणि ड्रॉप करा किंवा",
    max_file_mb_dimensions: "कमाल फाइल आकार 20MB परिमाणे",
    note_assgn_qusnr_text:
      "टीप *: असाइनमेंट सुरू होण्याच्या 10 मिनिटांपूर्वी तुम्ही तुमच्या नोंदी संपादित करू किंवा हटवू शकणार नाही.",
    note_qusnr_text:
      " टीप *: प्रश्नावली सुरू होण्याच्या १० मिनिटांपूर्वी तुम्ही तुमच्या नोंदी संपादित करू किंवा हटवू शकणार नाही.",
    not_attended: "हजेरी लावली नाही",
    not_started: "सुरू नाही",
    dont_have_stu_acc: "विद्यार्थी खाते नाही",
    buy_more: "अधिक खरेदी करा More",
    product: "उत्पादन",
    no_subject_assigned: "कोणतेही विषय नियुक्त केलेले नाहीत",
    logo: "लोगो",
    stamp: "मुद्रांक",
    signature: "स्वाक्षरी",
    uploaded_successfully: "स्वाक्षरी अपलोड केली",
    renewal: "नूतनीकरण",
    domain_name: "डोमेनचे नाव",
    pls_sel_frequency:
      "कृपया तुम्हाला आठवड्यातील कोणता दिवस शेड्यूल करायचा आहे ते निवडा",
    your_test_successfully_submitted:
      "तुमची चाचणी यशस्वीरित्या सबमिट केली गेली आहे",
    score_will_finished: "वेळ संपल्यानंतर स्कोअर प्रदर्शित केला जाईल",
    license_expired: "परवाना कालबाह्य झाला",
    application_longer_accessed_since__license_expired:
      "तुमचा परवाना कालबाह्य झाल्यामुळे अर्जावर यापुढे प्रवेश करता येणार नाही. प्रवेश पुन्हा सक्रिय करण्यासाठी,",
    respective_admin_license_renewal:
      "कृपया परवाना नूतनीकरणासाठी तुमच्या संबंधित प्रशासकाशी संपर्क साधा.",
    okay: " ठीक आहे",
    delete_recurring_schedule: "आवर्ती वेळापत्रक हटवा",
    are_you_sure_delete_recurring_schedule:
      "तुमची खात्री आहे की तुम्ही हे आवर्ती शेड्यूल हटवू इच्छिता?",
    delete_all_recurring_days_completely: "सर्व आवर्ती दिवस पूर्णपणे हटवा.",
    will_eleminate_all_selected: "शेड्यूलमधून निवडलेले सर्व दिवस काढून टाकेल",
    remove_only_selected_days: "फक्त निवडलेले दिवस काढा",
    delete_selected_days_schedule: "हे शेड्यूलमधून फक्त निवडलेले दिवस हटवेल",
    recurring_dates: "आवर्ती तारखा",
    enter_the_coupon_code: "कूपन कोड प्रविष्ट करा",
    coupon_applied: "कूपन लागू केले",
    coupon_id: "कूपनआयडी",
    del_recurring_by_dates:
      "तुम्हाला कोणत्या सत्राचा दिवस हटवायचा आहे ते निवडा",
    more_details: "अधिक माहितीसाठी",
    removeStudentUser: "तुमची खात्री आहे की तुम्ही या विद्यार्थ्याला काढून टाकू इच्छिता?",
    removeTeacherUser: "तुमची खात्री आहे की तुम्ही या शिक्षकाला काढून टाकू इच्छिता?",
    sure_you_want_to_delete: "तुमची खात्री आहे, तुम्ही हे हटवू इच्छिता",
    deleting_information_database: "हे हटवल्याने डेटाबेसमधील सर्व माहिती मिटवली जाईल.",
    to_confirm_type: "प्रकार पुष्टी करण्यासाठी",
    name_not_matched: "नाव जुळत नाही.",
    confirm_this_type: "याची पुष्टी करण्यासाठी, टाइप करा",
    topic_title: "विषयाचे शीर्षक",
    select: "निवडा",
    plz_enter_integers: "कृपया केवळ पूर्णांक मूल्ये प्रविष्ट करा",
    help_Center:"मदत केंद्र",

  },
};
